/*
@license
  Impulse by Archetype Themes (https://archetypethemes.co)
  Access unminified JS in assets/theme.js

  Use this event listener to run your own JS outside of this file.
  Documentation - https://archetypethemes.co/blogs/impulse/javascript-events-for-developers

  document.addEventListener('page:loaded', function() {
    // Page has loaded and theme assets are ready
  });
*/

window.theme = window.theme || {};
window.Shopify = window.Shopify || {};

theme.config = {
  bpSmall: false,
  hasSessionStorage: true,
  hasLocalStorage: true,
  mediaQuerySmall: 'screen and (max-width: ' + 769 + 'px)',
  youTubeReady: false,
  vimeoReady: false,
  vimeoLoading: false,
  isTouch:
    'ontouchstart' in window ||
    (window.DocumentTouch && window.document instanceof DocumentTouch) ||
    window.navigator.maxTouchPoints ||
    window.navigator.msMaxTouchPoints
      ? true
      : false,
  stickyHeader: false,
  rtl: document.documentElement.getAttribute('dir') == 'rtl' ? true : false,
};

if (theme.config.isTouch) {
  document.documentElement.className += ' supports-touch';
}

if (console && console.log) {
  console.log(
    'Impulse theme (' + theme.settings.themeVersion + ') by ARCHΞTYPE | Learn more at https://archetypethemes.co'
  );
}

theme.recentlyViewed = {
  recent: {}, // will store handle+url of recent products
  productInfo: {}, // will store product data to reduce API calls
};

(function () {
  'use strict';

  theme.delegate = {
    on: function (event, callback, options) {
      if (!this.namespaces)
        // save the namespaces on the DOM element itself
        this.namespaces = {};

      this.namespaces[event] = callback;
      options = options || false;

      this.addEventListener(event.split('.')[0], callback, options);
      return this;
    },
    off: function (event) {
      if (!this.namespaces) {
        return;
      }
      this.removeEventListener(event.split('.')[0], this.namespaces[event]);
      delete this.namespaces[event];
      return this;
    },
  };

  // Extend the DOM with these above custom methods
  window.on = Element.prototype.on = theme.delegate.on;
  window.off = Element.prototype.off = theme.delegate.off;

  theme.utils = {
    defaultTo: function (value, defaultValue) {
      return value == null || value !== value ? defaultValue : value;
    },

    wrap: function (el, wrapper) {
      el.parentNode.insertBefore(wrapper, el);
      wrapper.appendChild(el);
    },

    debounce: function (wait, callback, immediate) {
      var timeout;
      return function () {
        var context = this,
          args = arguments;
        var later = function () {
          timeout = null;
          if (!immediate) callback.apply(context, args);
        };
        var callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) callback.apply(context, args);
      };
    },

    throttle: function (limit, callback) {
      var waiting = false;
      return function () {
        if (!waiting) {
          callback.apply(this, arguments);
          waiting = true;
          setTimeout(function () {
            waiting = false;
          }, limit);
        }
      };
    },

    prepareTransition: function (el, callback) {
      el.addEventListener('transitionend', removeClass);

      function removeClass(evt) {
        el.classList.remove('is-transitioning');
        el.removeEventListener('transitionend', removeClass);
      }

      el.classList.add('is-transitioning');
      el.offsetWidth; // check offsetWidth to force the style rendering

      if (typeof callback === 'function') {
        callback();
      }
    },

    // _.compact from lodash
    // Creates an array with all falsey values removed. The values `false`, `null`,
    // `0`, `""`, `undefined`, and `NaN` are falsey.
    // _.compact([0, 1, false, 2, '', 3]);
    // => [1, 2, 3]
    compact: function (array) {
      var index = -1,
        length = array == null ? 0 : array.length,
        resIndex = 0,
        result = [];

      while (++index < length) {
        var value = array[index];
        if (value) {
          result[resIndex++] = value;
        }
      }
      return result;
    },

    serialize: function (form) {
      var arr = [];
      Array.prototype.slice.call(form.elements).forEach(function (field) {
        if (!field.name || field.disabled || ['file', 'reset', 'submit', 'button'].indexOf(field.type) > -1) return;
        if (field.type === 'select-multiple') {
          Array.prototype.slice.call(field.options).forEach(function (option) {
            if (!option.selected) return;
            arr.push(encodeURIComponent(field.name) + '=' + encodeURIComponent(option.value));
          });
          return;
        }
        if (['checkbox', 'radio'].indexOf(field.type) > -1 && !field.checked) return;
        arr.push(encodeURIComponent(field.name) + '=' + encodeURIComponent(field.value));
      });
      return arr.join('&');
    },
  };

  theme.a11y = {
    trapFocus: function (options) {
      var eventsName = {
        focusin: options.namespace ? 'focusin.' + options.namespace : 'focusin',
        focusout: options.namespace ? 'focusout.' + options.namespace : 'focusout',
        keydown: options.namespace ? 'keydown.' + options.namespace : 'keydown.handleFocus',
      };

      // Get every possible visible focusable element
      var focusableEls = options.container.querySelectorAll(
        'button, [href], input, select, textarea, [tabindex]:not([tabindex^="-"])'
      );
      var elArray = [].slice.call(focusableEls);
      var focusableElements = elArray.filter((el) => el.offsetParent !== null);

      var firstFocusable = focusableElements[0];
      var lastFocusable = focusableElements[focusableElements.length - 1];

      if (!options.elementToFocus) {
        options.elementToFocus = options.container;
      }

      options.container.setAttribute('tabindex', '-1');
      options.elementToFocus.focus();

      document.documentElement.off('focusin');
      document.documentElement.on(eventsName.focusout, function () {
        document.documentElement.off(eventsName.keydown);
      });

      document.documentElement.on(eventsName.focusin, function (evt) {
        if (evt.target !== options.container && evt.target !== lastFocusable && evt.target !== firstFocusable) return;

        document.documentElement.on(eventsName.keydown, function (evt) {
          _manageFocus(evt);
        });
      });

      function _manageFocus(evt) {
        if (evt.keyCode !== 9) return;
        /**
         * On the first focusable element and tab backward,
         * focus the last element
         */
        if (evt.target === lastFocusable && !evt.shiftKey) {
          evt.preventDefault();
          firstFocusable.focus();
        }
      }
    },
    removeTrapFocus: function (options) {
      var eventName = options.namespace ? 'focusin.' + options.namespace : 'focusin';

      if (options.container) {
        options.container.removeAttribute('tabindex');
      }

      document.documentElement.off(eventName);
    },

    lockMobileScrolling: function (namespace, element) {
      var el = element ? element : document.documentElement;
      document.documentElement.classList.add('lock-scroll');
      el.on('touchmove' + namespace, function () {
        return true;
      });
    },

    unlockMobileScrolling: function (namespace, element) {
      document.documentElement.classList.remove('lock-scroll');
      var el = element ? element : document.documentElement;
      el.off('touchmove' + namespace);
    },
  };

  // Add class when tab key starts being used to show outlines
  document.documentElement.on('keyup.tab', function (evt) {
    if (evt.keyCode === 9) {
      document.documentElement.classList.add('tab-outline');
      document.documentElement.off('keyup.tab');
    }
  });

  const trapFocusHandlers = {};

  /**
   * Currency Helpers
   * -----------------------------------------------------------------------------
   * A collection of useful functions that help with currency formatting
   *
   * Current contents
   * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
   *   - When theme.settings.superScriptPrice is enabled, format cents in <sup> tag
   * - getBaseUnit - Splits unit price apart to get value + unit
   *
   */

  theme.Currency = (function () {
    var moneyFormat = '${{amount}}';
    var superScript = theme && theme.settings && theme.settings.superScriptPrice;

    function formatMoney(cents, format) {
      if (!format) {
        format = theme.settings.moneyFormat;
      }

      if (typeof cents === 'string') {
        cents = cents.replace('.', '');
      }
      var value = '';
      var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
      var formatString = format || moneyFormat;

      function formatWithDelimiters(number, precision, thousands, decimal) {
        precision = theme.utils.defaultTo(precision, 2);
        thousands = theme.utils.defaultTo(thousands, ',');
        decimal = theme.utils.defaultTo(decimal, '.');

        if (isNaN(number) || number == null) {
          return 0;
        }

        number = (number / 100.0).toFixed(precision);

        var parts = number.split('.');
        var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
        var centsAmount = parts[1] ? decimal + parts[1] : '';

        return dollarsAmount + centsAmount;
      }

      switch (formatString.match(placeholderRegex)[1]) {
        case 'amount':
          value = formatWithDelimiters(cents, 2);

          if (superScript && value && value.includes('.')) {
            value = value.replace('.', '<sup>') + '</sup>';
          }

          break;
        case 'amount_no_decimals':
          value = formatWithDelimiters(cents, 0);
          break;
        case 'amount_with_comma_separator':
          value = formatWithDelimiters(cents, 2, '.', ',');

          if (superScript && value && value.includes(',')) {
            value = value.replace(',', '<sup>') + '</sup>';
          }

          break;
        case 'amount_no_decimals_with_comma_separator':
          value = formatWithDelimiters(cents, 0, '.', ',');
          break;
        case 'amount_no_decimals_with_space_separator':
          value = formatWithDelimiters(cents, 0, ' ');
          break;
      }

      return formatString.replace(placeholderRegex, value);
    }

    function getBaseUnit(variant) {
      if (!variant) {
        return;
      }

      if (!variant.unit_price_measurement || !variant.unit_price_measurement.reference_value) {
        return;
      }

      return variant.unit_price_measurement.reference_value === 1
        ? variant.unit_price_measurement.reference_unit
        : variant.unit_price_measurement.reference_value + variant.unit_price_measurement.reference_unit;
    }

    return {
      formatMoney: formatMoney,
      getBaseUnit: getBaseUnit,
    };
  })();

  theme.Images = (function () {
    /**
     * Find the Shopify image attribute size
     */
    function imageSize(src) {
      if (!src) {
        return '620x'; // default based on theme
      }

      var match = src.match(
        /.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/
      );

      if (match !== null) {
        return match[1];
      } else {
        return null;
      }
    }

    /**
     * Adds a Shopify size attribute to a URL
     */
    function getSizedImageUrl(src, size) {
      if (!src) {
        return src;
      }

      if (size == null) {
        return src;
      }

      if (size === 'master') {
        return this.removeProtocol(src);
      }

      var match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);

      if (match != null) {
        var prefix = src.split(match[0]);
        var suffix = match[0];

        return this.removeProtocol(prefix[0] + '_' + size + suffix);
      }

      return null;
    }

    function removeProtocol(path) {
      return path.replace(/http(s)?:/, '');
    }

    function buildImagePath(string, widths) {
      if (string == null) return [];

      if (widths) {
        const imageUrls = [];

        widths.forEach((width) => {
          let url = `${string}?width=${width}`;
          if (width === widths[widths.length - 1]) {
            url += ` ${width}w`;
          } else {
            url += ` ${width}w,`;
          }
          imageUrls.push(url);
        });
        return imageUrls;
      } else {
        return [string];
      }
    }

    return {
      imageSize: imageSize,
      getSizedImageUrl: getSizedImageUrl,
      removeProtocol: removeProtocol,
      buildImagePath: buildImagePath,
    };
  })();

  // Init section function when it's visible, then disable observer
  theme.initWhenVisible = function (options) {
    var threshold = options.threshold ? options.threshold : 0;

    var observer = new IntersectionObserver(
      (entries, observer) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            if (typeof options.callback === 'function') {
              options.callback();
              observer.unobserve(entry.target);
            }
          }
        });
      },
      { rootMargin: '0px 0px ' + threshold + 'px 0px' }
    );

    observer.observe(options.element);
  };

  theme.LibraryLoader = (function () {
    var types = {
      link: 'link',
      script: 'script',
    };

    var status = {
      requested: 'requested',
      loaded: 'loaded',
    };

    var cloudCdn = 'https://cdn.shopify.com/shopifycloud/';

    var libraries = {
      youtubeSdk: {
        tagId: 'youtube-sdk',
        src: 'https://www.youtube.com/iframe_api',
        type: types.script,
      },
      vimeo: {
        tagId: 'vimeo-api',
        src: 'https://player.vimeo.com/api/player.js',
        type: types.script,
      },
      shopifyXr: {
        tagId: 'shopify-model-viewer-xr',
        src: cloudCdn + 'shopify-xr-js/assets/v1.0/shopify-xr.en.js',
        type: types.script,
      },
      modelViewerUi: {
        tagId: 'shopify-model-viewer-ui',
        src: cloudCdn + 'model-viewer-ui/assets/v1.0/model-viewer-ui.en.js',
        type: types.script,
      },
      modelViewerUiStyles: {
        tagId: 'shopify-model-viewer-ui-styles',
        src: cloudCdn + 'model-viewer-ui/assets/v1.0/model-viewer-ui.css',
        type: types.link,
      },
    };

    function load(libraryName, callback) {
      var library = libraries[libraryName];

      if (!library) return;
      if (library.status === status.requested) return;

      callback = callback || function () {};
      if (library.status === status.loaded) {
        callback();
        return;
      }

      library.status = status.requested;

      var tag;

      switch (library.type) {
        case types.script:
          tag = createScriptTag(library, callback);
          break;
        case types.link:
          tag = createLinkTag(library, callback);
          break;
      }

      tag.id = library.tagId;
      library.element = tag;

      var firstScriptTag = document.getElementsByTagName(library.type)[0];
      firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
    }

    function createScriptTag(library, callback) {
      var tag = document.createElement('script');
      tag.src = library.src;
      tag.addEventListener('load', function () {
        library.status = status.loaded;
        callback();
      });
      return tag;
    }

    function createLinkTag(library, callback) {
      var tag = document.createElement('link');
      tag.href = library.src;
      tag.rel = 'stylesheet';
      tag.type = 'text/css';
      tag.addEventListener('load', function () {
        library.status = status.loaded;
        callback();
      });
      return tag;
    }

    return {
      load: load,
    };
  })();

  theme.rteInit = function () {
    // Wrap tables so they become scrollable on small screens
    document.querySelectorAll('.rte table').forEach((table) => {
      var wrapWith = document.createElement('div');
      wrapWith.classList.add('table-wrapper');
      theme.utils.wrap(table, wrapWith);
    });

    // Wrap video iframe embeds so they are responsive
    document.querySelectorAll('.rte iframe[src*="youtube.com/embed"]').forEach((iframe) => {
      wrapVideo(iframe);
    });
    document.querySelectorAll('.rte iframe[src*="player.vimeo"]').forEach((iframe) => {
      wrapVideo(iframe);
    });

    function wrapVideo(iframe) {
      // Reset the src attribute on each iframe after page load
      // for Chrome's "incorrect iFrame content on 'back'" bug.
      // https://code.google.com/p/chromium/issues/detail?id=395791
      iframe.src = iframe.src;
      var wrapWith = document.createElement('div');
      wrapWith.classList.add('video-wrapper');
      theme.utils.wrap(iframe, wrapWith);
    }

    // Remove CSS that adds animated underline under image links
    document.querySelectorAll('.rte a img').forEach((img) => {
      img.parentNode.classList.add('rte__image');
    });
  };

  theme.Sections = function Sections() {
    this.constructors = {};
    this.instances = [];

    document.addEventListener('shopify:section:load', this._onSectionLoad.bind(this));
    document.addEventListener('shopify:section:unload', this._onSectionUnload.bind(this));
    document.addEventListener('shopify:section:select', this._onSelect.bind(this));
    document.addEventListener('shopify:section:deselect', this._onDeselect.bind(this));
    document.addEventListener('shopify:block:select', this._onBlockSelect.bind(this));
    document.addEventListener('shopify:block:deselect', this._onBlockDeselect.bind(this));
  };

  theme.Sections.prototype = Object.assign({}, theme.Sections.prototype, {
    _createInstance: function (container, constructor, scope) {
      var id = container.getAttribute('data-section-id');
      var type = container.getAttribute('data-section-type');

      constructor = constructor || this.constructors[type];

      if (typeof constructor === 'undefined') {
        return;
      }

      // If custom scope passed, check to see if instance
      // is already initialized so we don't double up
      if (scope) {
        var instanceExists = this._findInstance(id);
        if (instanceExists) {
          this._removeInstance(id);
        }
      }

      // If a section fails to init, handle the error without letting all subsequest section registers to fail
      try {
        var instance = Object.assign(new constructor(container), {
          id: id,
          type: type,
          container: container,
        });
        this.instances.push(instance);
      } catch (e) {
        console.error(e);
      }
    },

    _findInstance: function (id) {
      for (var i = 0; i < this.instances.length; i++) {
        if (this.instances[i].id === id) {
          return this.instances[i];
        }
      }
    },

    _removeInstance: function (id) {
      var i = this.instances.length;
      var instance;

      while (i--) {
        if (this.instances[i].id === id) {
          instance = this.instances[i];
          this.instances.splice(i, 1);
          break;
        }
      }

      return instance;
    },

    _onSectionLoad: function (evt, subSection, subSectionId) {
      if (window.AOS) {
        AOS.refreshHard();
      }
      if (theme && theme.initGlobals) {
        theme.initGlobals();
      }

      var container = subSection ? subSection : evt.target;
      var section = subSection ? subSection : evt.target.querySelector('[data-section-id]');

      if (!section) {
        return;
      }

      this._createInstance(section);

      var instance = subSection ? subSectionId : this._findInstance(evt.detail.sectionId);

      // Check if we have subsections to load
      var haveSubSections = container.querySelectorAll('[data-subsection]');
      if (haveSubSections.length) {
        this.loadSubSections(container);
      }

      // Run JS only in case of the section being selected in the editor
      // before merchant clicks "Add"
      if (instance && typeof instance.onLoad === 'function') {
        instance.onLoad(evt);
      }

      // Force editor to trigger scroll event when loading a section
      setTimeout(function () {
        window.dispatchEvent(new Event('scroll'));
      }, 200);
    },

    _onSectionUnload: function (evt) {
      this.instances = this.instances.filter(function (instance) {
        var isEventInstance = instance.id === evt.detail.sectionId;

        if (isEventInstance) {
          if (typeof instance.onUnload === 'function') {
            instance.onUnload(evt);
          }
        }

        return !isEventInstance;
      });
    },

    loadSubSections: function (scope) {
      if (!scope) {
        return;
      }

      var sections = scope.querySelectorAll('[data-section-id]');

      sections.forEach((el) => {
        this._onSectionLoad(null, el, el.dataset.sectionId);
      });
    },

    _onSelect: function (evt) {
      var instance = this._findInstance(evt.detail.sectionId);

      if (typeof instance !== 'undefined' && typeof instance.onSelect === 'function') {
        instance.onSelect(evt);
      }
    },

    _onDeselect: function (evt) {
      var instance = this._findInstance(evt.detail.sectionId);

      if (typeof instance !== 'undefined' && typeof instance.onDeselect === 'function') {
        instance.onDeselect(evt);
      }
    },

    _onBlockSelect: function (evt) {
      var instance = this._findInstance(evt.detail.sectionId);

      if (typeof instance !== 'undefined' && typeof instance.onBlockSelect === 'function') {
        instance.onBlockSelect(evt);
      }
    },

    _onBlockDeselect: function (evt) {
      var instance = this._findInstance(evt.detail.sectionId);

      if (typeof instance !== 'undefined' && typeof instance.onBlockDeselect === 'function') {
        instance.onBlockDeselect(evt);
      }
    },

    register: function (type, constructor, scope) {
      this.constructors[type] = constructor;

      var sections = document.querySelectorAll('[data-section-type="' + type + '"]');

      if (scope) {
        sections = scope.querySelectorAll('[data-section-type="' + type + '"]');
      }

      sections.forEach(
        function (container) {
          this._createInstance(container, constructor, scope);
        }.bind(this)
      );
    },

    reinit: function (section) {
      for (var i = 0; i < this.instances.length; i++) {
        var instance = this.instances[i];
        if (instance['type'] === section) {
          if (typeof instance.forceReload === 'function') {
            instance.forceReload();
          }
        }
      }
    },
  });

  /*
    Options:
      container
      enableHistoryState - enable when on single product page to update URL
      singleOptionSelector - selector for individual variant option (e.g. 'Blue' or 'Small')
      originalSelectorId - selector for base variant selector (visually hidden)
      variants - JSON parsed object of product variant info
   */
  theme.Variants = (function () {
    function Variants(options) {
      this.container = options.container;
      this.variants = options.variants;
      this.singleOptionSelector = options.singleOptionSelector;
      this.originalSelectorId = options.originalSelectorId;
      this.enableHistoryState = options.enableHistoryState;
      this.dynamicVariantsEnabled = options.dynamicVariantsEnabled;
      this.currentlySelectedValues = this._getCurrentOptions();
      this.currentVariant = this._getVariantFromOptions();

      this.container.querySelectorAll(this.singleOptionSelector).forEach((el) => {
        el.addEventListener('change', this._onSelectChange.bind(this));
      });
    }

    Variants.prototype = Object.assign({}, Variants.prototype, {
      _getCurrentOptions: function () {
        var result = [];

        this.container.querySelectorAll(this.singleOptionSelector).forEach((el) => {
          var type = el.getAttribute('type');

          if (type === 'radio' || type === 'checkbox') {
            if (el.checked) {
              result.push({
                value: el.value,
                index: el.dataset.index,
              });
            }
          } else {
            result.push({
              value: el.value,
              index: el.dataset.index,
            });
          }
        });

        // remove any unchecked input values if using radio buttons or checkboxes
        result = theme.utils.compact(result);

        return result;
      },

      // Pull the number out of the option index name, e.g. 'option1' -> 1
      _numberFromOptionKey: function (key) {
        return parseInt(key.substr(-1));
      },

      // Options should be ordered from highest to lowest priority. Make sure that priority
      // is represented using weighted values when finding best match
      _getWeightedOptionMatchCount: function (variant) {
        return this._getCurrentOptions().reduce((count, { value, index }) => {
          const optionIndex = this._numberFromOptionKey(index);
          const weightedCount = 4 - optionIndex; // The lower the index, the better the match we have
          return variant[index] === value ? count + weightedCount : count;
        }, 0);
      },

      _getFullMatch(needsToBeAvailable) {
        const currentlySelectedOptions = this._getCurrentOptions();
        const variants = this.variants;

        return variants.find((variant) => {
          const isMatch = currentlySelectedOptions.every(({ value, index }) => {
            return variant[index] === value;
          });

          if (needsToBeAvailable) {
            return isMatch && variant.available;
          } else {
            return isMatch;
          }
        });
      },

      // Find a variant that is available and best matches last selected option
      _getClosestAvailableMatch: function (lastSelectedOption) {
        if (!lastSelectedOption) return null;

        const currentlySelectedOptions = this._getCurrentOptions();
        const variants = this.variants;

        const potentialAvailableMatches =
          lastSelectedOption &&
          variants.filter((variant) => {
            return (
              currentlySelectedOptions
                .filter(
                  // Only match based selected options that are equal and preceeding the last selected option
                  ({ value, index }) =>
                    this._numberFromOptionKey(index) <= this._numberFromOptionKey(lastSelectedOption.index)
                )
                .every(({ value, index }) => {
                  // Variant needs to have options that match the current and preceeding selection options
                  return variant[index] === value;
                }) && variant.available
            );
          });

        return potentialAvailableMatches.reduce((bestMatch, variant) => {
          // If this is the first potential match we've found, store it as the best match
          if (bestMatch === null) return variant;

          // If this is not the first potential match, compare the number of options our current best match has in common
          // compared to the next contender.
          const bestMatchCount = this._getWeightedOptionMatchCount(bestMatch, lastSelectedOption);
          const newCount = this._getWeightedOptionMatchCount(variant, lastSelectedOption);

          return newCount > bestMatchCount ? variant : bestMatch;
        }, null);
      },

      _getVariantFromOptions: function (lastSelectedOption) {
        const availableFullMatch = this._getFullMatch(true);
        const closestAvailableMatch = this._getClosestAvailableMatch(lastSelectedOption);
        const fullMatch = this._getFullMatch(false);

        if (this.dynamicVariantsEnabled) {
          // Add some additional smarts to variant matching if Dynamic Variants are enabled
          return availableFullMatch || closestAvailableMatch || fullMatch || null;
        } else {
          // Only return a full match or null (variant doesn't exist) if Dynamic Variants are disabled
          return fullMatch || null;
        }
      },

      _updateInputState: function (variant, el) {
        return (input) => {
          if (variant === null) return;

          const index = input.dataset.index;
          const value = input.value;
          const type = input.getAttribute('type');

          if (type === 'radio' || type === 'checkbox') {
            input.checked = variant[index] === value;
          } else {
            input.value = variant[index];
          }
        };
      },

      _onSelectChange: function ({ srcElement }) {
        const optionSelectElements = this.container.querySelectorAll(this.singleOptionSelector);

        // Get the best variant based on the current selection + last selected element
        const variant = this._getVariantFromOptions({
          index: srcElement.dataset.index,
          value: srcElement.value,
        });

        // Update DOM option input states based on the variant that was found
        optionSelectElements.forEach(this._updateInputState(variant, srcElement));

        // Make sure our currently selected values are up to date after updating state of DOM
        const currentlySelectedValues = (this.currentlySelectedValues = this._getCurrentOptions());

        const detail = {
          variant,
          currentlySelectedValues,
          value: srcElement.value,
          index: srcElement.parentElement.dataset.index,
        };

        this.container.dispatchEvent(new CustomEvent('variantChange', { detail }));
        document.dispatchEvent(new CustomEvent('variant:change', { detail }));

        if (!variant) {
          return;
        }

        this._updateMasterSelect(variant);
        this._updateImages(variant);
        this._updatePrice(variant);
        this._updateUnitPrice(variant);
        this._updateSKU(variant);
        this.currentVariant = variant;

        if (this.enableHistoryState) {
          this._updateHistoryState(variant);
        }
      },

      _updateImages: function (variant) {
        if (!variant.featured_image && !variant.featured_media) {
          return;
        }

        this.container.dispatchEvent(
          new CustomEvent('variantImageChange', {
            detail: {
              variant: variant,
            },
          })
        );
      },

      _updatePrice: function (variant) {
        if (
          this.currentVariant &&
          variant.price === this.currentVariant.price &&
          variant.compare_at_price === this.currentVariant.compare_at_price
        ) {
          return;
        }

        this.container.dispatchEvent(
          new CustomEvent('variantPriceChange', {
            detail: {
              variant: variant,
            },
          })
        );
      },

      _updateUnitPrice: function (variant) {
        if (this.currentVariant && variant.unit_price === this.currentVariant.unit_price) {
          return;
        }

        this.container.dispatchEvent(
          new CustomEvent('variantUnitPriceChange', {
            detail: {
              variant: variant,
            },
          })
        );
      },

      _updateSKU: function (variant) {
        if (this.currentVariant && variant.sku === this.currentVariant.sku) {
          return;
        }

        this.container.dispatchEvent(
          new CustomEvent('variantSKUChange', {
            detail: {
              variant: variant,
            },
          })
        );
      },

      _updateHistoryState: function (variant) {
        if (!history.replaceState || !variant) {
          return;
        }

        var newurl =
          window.location.protocol + '//' + window.location.host + window.location.pathname + '?variant=' + variant.id;
        window.history.replaceState({ path: newurl }, '', newurl);
      },

      _updateMasterSelect: function (variant) {
        let masterSelect = this.container.querySelector(this.originalSelectorId);
        if (!masterSelect) return;

        masterSelect.value = variant.id;
        // Force a change event so Shop Pay installments works after a variant is changed
        masterSelect.dispatchEvent(new Event('change', { bubbles: true }));
      },
    });

    return Variants;
  })();

  window.vimeoApiReady = function () {
    theme.config.vimeoLoading = true;

    // Because there's no way to check for the Vimeo API being loaded
    // asynchronously, we use this terrible timeout to wait for it being ready
    checkIfVimeoIsReady().then(function () {
      theme.config.vimeoReady = true;
      theme.config.vimeoLoading = false;
      document.dispatchEvent(new CustomEvent('vimeoReady'));
    });
  };

  function checkIfVimeoIsReady() {
    let wait;
    let timeout;

    return new Promise((resolve, reject) => {
      wait = setInterval(function () {
        if (!Vimeo) {
          return;
        }

        clearInterval(wait);
        clearTimeout(timeout);
        resolve();
      }, 500);

      timeout = setTimeout(function () {
        clearInterval(wait);
        reject();
      }, 4000); // subjective. test up to 8 times over 4 seconds
    });
  }

  theme.VimeoPlayer = (function () {
    const classes = {
      loading: 'loading',
      loaded: 'loaded',
      interactable: 'video-interactable',
    };

    const defaults = {
      byline: false,
      loop: true,
      muted: true,
      playsinline: true,
      portrait: false,
      title: false,
    };

    function VimeoPlayer(divId, videoId, options) {
      this.divId = divId;
      this.el = document.getElementById(divId);
      this.videoId = videoId;
      this.iframe = null;
      this.options = options;

      if (this.options && this.options.videoParent) {
        this.parent = this.el.closest(this.options.videoParent);
      }

      this.setAsLoading();

      if (theme.config.vimeoReady) {
        this.init();
      } else {
        theme.LibraryLoader.load('vimeo', window.vimeoApiReady);
        document.addEventListener('vimeoReady', this.init.bind(this));
      }
    }

    VimeoPlayer.prototype = Object.assign({}, VimeoPlayer.prototype, {
      init: function () {
        const args = defaults;
        args.id = this.videoId;

        this.videoPlayer = new Vimeo.Player(this.el, args);

        this.videoPlayer.ready().then(this.playerReady.bind(this));
      },

      playerReady: function () {
        this.iframe = this.el.querySelector('iframe');
        this.iframe.setAttribute('tabindex', '-1');

        if (this.options.loop === 'false') {
          this.videoPlayer.setLoop(false);
        }

        // When sound is enabled in section settings,
        // for some mobile browsers Vimeo video playback
        // will stop immediately after starting and
        // will require users to tap the play button once more
        if (this.options.style === 'sound') {
          this.videoPlayer.setVolume(1);
        } else {
          this.videoPlayer.setVolume(0);
        }

        this.setAsLoaded();

        // pause when out of view
        const observer = new IntersectionObserver(
          (entries, observer) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                this.play();
              } else {
                this.pause();
              }
            });
          },
          { rootMargin: '0px 0px 50px 0px' }
        );

        observer.observe(this.iframe);
      },

      setAsLoading: function () {
        if (!this.parent) return;
        this.parent.classList.add(classes.loading);
      },

      setAsLoaded: function () {
        if (!this.parent) return;
        this.parent.classList.remove(classes.loading);
        this.parent.classList.add(classes.loaded);
        this.parent.classList.add(classes.interactable); // Once video is loaded, we should be able to interact with it
        if (Shopify && Shopify.designMode) {
          if (window.AOS) {
            AOS.refreshHard();
          }
        }
      },

      enableInteraction: function () {
        if (!this.parent) return;
        this.parent.classList.add(classes.interactable);
      },

      play: function () {
        if (this.videoPlayer && typeof this.videoPlayer.play === 'function') {
          this.videoPlayer.play();
        }
      },

      pause: function () {
        if (this.videoPlayer && typeof this.videoPlayer.pause === 'function') {
          this.videoPlayer.pause();
        }
      },

      destroy: function () {
        if (this.videoPlayer && typeof this.videoPlayer.destroy === 'function') {
          this.videoPlayer.destroy();
        }
      },
    });

    return VimeoPlayer;
  })();

  window.onYouTubeIframeAPIReady = function () {
    theme.config.youTubeReady = true;
    document.dispatchEvent(new CustomEvent('youTubeReady'));
  };

  /*============================================================================
    YouTube SDK method
    Parameters:
      - player div id (required)
      - arguments
        - videoId (required)
        - videoParent (selector, optional for section loading state)
        - events (object, optional)
  ==============================================================================*/
  theme.YouTube = (function () {
    var classes = {
      loading: 'loading',
      loaded: 'loaded',
      interactable: 'video-interactable',
    };

    var defaults = {
      width: 1280,
      height: 720,
      playerVars: {
        autohide: 0,
        autoplay: 1,
        cc_load_policy: 0,
        controls: 0,
        fs: 0,
        iv_load_policy: 3,
        modestbranding: 1,
        playsinline: 1,
        rel: 0,
      },
    };

    function YouTube(divId, options) {
      this.divId = divId;
      this.iframe = null;

      this.attemptedToPlay = false;

      // API callback events
      defaults.events = {
        onReady: this.onVideoPlayerReady.bind(this),
        onStateChange: this.onVideoStateChange.bind(this),
      };

      this.options = Object.assign({}, defaults, options);

      if (this.options) {
        if (this.options.videoParent) {
          this.parent = document.getElementById(this.divId).closest(this.options.videoParent);
        }

        // Most YT videos will autoplay. If in product media,
        // will handle in theme.Product instead
        if (!this.options.autoplay) {
          this.options.playerVars.autoplay = this.options.autoplay;
        }

        if (this.options.style === 'sound') {
          this.options.playerVars.controls = 1;
          this.options.playerVars.autoplay = 0;
        }
      }

      this.setAsLoading();

      if (theme.config.youTubeReady) {
        this.init();
      } else {
        theme.LibraryLoader.load('youtubeSdk');
        document.addEventListener('youTubeReady', this.init.bind(this));
      }
    }

    YouTube.prototype = Object.assign({}, YouTube.prototype, {
      init: function () {
        this.videoPlayer = new YT.Player(this.divId, this.options);
      },

      onVideoPlayerReady: function (evt) {
        this.iframe = document.getElementById(this.divId); // iframe once YT loads
        this.iframe.setAttribute('tabindex', '-1');

        if (this.options.style !== 'sound') {
          evt.target.mute();
        }

        // pause when out of view
        var observer = new IntersectionObserver(
          (entries, observer) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                this.play();
              } else {
                this.pause();
              }
            });
          },
          { rootMargin: '0px 0px 50px 0px' }
        );

        observer.observe(this.iframe);
      },

      onVideoStateChange: function (evt) {
        switch (evt.data) {
          case -1: // unstarted
            // Handle low power state on iOS by checking if
            // video is reset to unplayed after attempting to buffer
            if (this.attemptedToPlay) {
              this.setAsLoaded();
              this.enableInteraction();
            }
            break;
          case 0: // ended, loop it
            this.play(evt);
            break;
          case 1: // playing
            this.setAsLoaded();
            break;
          case 3: // buffering
            this.attemptedToPlay = true;
            break;
        }
      },

      setAsLoading: function () {
        if (!this.parent) return;
        this.parent.classList.add(classes.loading);
      },

      setAsLoaded: function () {
        if (!this.parent) return;
        this.parent.classList.remove(classes.loading);
        this.parent.classList.add(classes.loaded);
        if (Shopify && Shopify.designMode) {
          if (window.AOS) {
            AOS.refreshHard();
          }
        }
      },

      enableInteraction: function () {
        if (!this.parent) return;
        this.parent.classList.add(classes.interactable);
      },

      play: function () {
        if (this.videoPlayer && typeof this.videoPlayer.playVideo === 'function') {
          this.videoPlayer.playVideo();
        }
      },

      pause: function () {
        if (this.videoPlayer && typeof this.videoPlayer.pauseVideo === 'function') {
          this.videoPlayer.pauseVideo();
        }
      },

      destroy: function () {
        if (this.videoPlayer && typeof this.videoPlayer.destroy === 'function') {
          this.videoPlayer.destroy();
        }
      },
    });

    return YouTube;
  })();

  // Prevent vertical scroll while using flickity sliders
  (function () {
    var e = !1;
    var t;

    document.body.addEventListener('touchstart', function (i) {
      if (!i.target.closest('.flickity-slider')) {
        return (e = !1);
        void 0;
      }
      e = !0;
      t = {
        x: i.touches[0].pageX,
        y: i.touches[0].pageY,
      };
    });

    document.body.addEventListener(
      'touchmove',
      function (i) {
        if (e && i.cancelable) {
          var n = {
            x: i.touches[0].pageX - t.x,
            y: i.touches[0].pageY - t.y,
          };
          Math.abs(n.x) > Flickity.defaults.dragThreshold && i.preventDefault();
        }
      },
      { passive: !1 }
    );
  })();

  /**
   * Ajax Renderer
   * -----------------------------------------------------------------------------
   * Render sections without reloading the page.
   * @param {Object[]} sections - The section to update on render.
   * @param {string} sections[].sectionId - The ID of the section from Shopify.
   * @param {string} sections[].nodeId - The ID of the DOM node to replace.
   * @param {Function} sections[].onReplace (optional) - The custom render function.
   * @param {boolean} debug - Output logs to console for debugging.
   *
   */

  theme.AjaxRenderer = (function () {
    function AjaxRenderer({ sections, onReplace, debug } = {}) {
      this.sections = sections || [];
      this.cachedSections = [];
      this.onReplace = onReplace;
      this.debug = Boolean(debug);
    }

    AjaxRenderer.prototype = Object.assign({}, AjaxRenderer.prototype, {
      renderPage: function (basePath, newParams, updateURLHash = true) {
        const currentParams = new URLSearchParams(window.location.search);
        const updatedParams = this.getUpdatedParams(currentParams, newParams);

        const sectionRenders = this.sections.map((section) => {
          const url = `${basePath}?section_id=${section.sectionId}&${updatedParams.toString()}`;
          const cachedSectionUrl = (cachedSection) => cachedSection.url === url;

          return this.cachedSections.some(cachedSectionUrl)
            ? this.renderSectionFromCache(cachedSectionUrl, section)
            : this.renderSectionFromFetch(url, section);
        });

        if (updateURLHash) this.updateURLHash(updatedParams);

        return Promise.all(sectionRenders);
      },

      renderSectionFromCache: function (url, section) {
        const cachedSection = this.cachedSections.find(url);

        this.log(`[AjaxRenderer] rendering from cache: url=${cachedSection.url}`);
        this.renderSection(cachedSection.html, section);
        return Promise.resolve(section);
      },

      renderSectionFromFetch: function (url, section) {
        this.log(`[AjaxRenderer] redering from fetch: url=${url}`);

        return new Promise((resolve, reject) => {
          fetch(url)
            .then((response) => response.text())
            .then((responseText) => {
              const html = responseText;
              this.cachedSections = [...this.cachedSections, { html, url }];
              this.renderSection(html, section);
              resolve(section);
            })
            .catch((err) => reject(err));
        });
      },

      renderSection: function (html, section) {
        this.log(`[AjaxRenderer] rendering section: section=${JSON.stringify(section)}`);

        const newDom = new DOMParser().parseFromString(html, 'text/html');
        if (this.onReplace) {
          this.onReplace(newDom, section);
        } else {
          if (typeof section.nodeId === 'string') {
            var newContentEl = newDom.getElementById(section.nodeId);
            if (!newContentEl) {
              return;
            }

            document.getElementById(section.nodeId).innerHTML = newContentEl.innerHTML;
          } else {
            section.nodeId.forEach((id) => {
              document.getElementById(id).innerHTML = newDom.getElementById(id).innerHTML;
            });
          }
        }

        return section;
      },

      getUpdatedParams: function (currentParams, newParams) {
        const clone = new URLSearchParams(currentParams);
        const preservedParams = ['sort_by', 'q', 'options[prefix]', 'type'];

        // Find what params need to be removed
        // delete happens first as we cannot specify keys based off of values
        for (const [key, value] of clone.entries()) {
          if (!newParams.getAll(key).includes(value) && !preservedParams.includes(key)) {
            clone.delete(key);
          }
        }

        // Find what params need to be added
        for (const [key, value] of newParams.entries()) {
          if (!clone.getAll(key).includes(value) && value !== '') {
            clone.append(key, value);
          }
        }

        return clone;
      },

      updateURLHash: function (searchParams) {
        history.pushState({}, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
      },

      log: function (...args) {
        if (this.debug) {
          console.log(...args);
        }
      },
    });

    return AjaxRenderer;
  })();

  if (window.Shopify && window.Shopify.theme && navigator && navigator.sendBeacon && window.Shopify.designMode) {
    navigator.sendBeacon(
      'https://api.archetypethemes.co/api/beacon',
      new URLSearchParams({
        shop: window.Shopify.shop,
        themeName:
          window.theme &&
          window.theme.settings &&
          `${window.theme.settings.themeName} v${window.theme.settings.themeVersion}`,
        role: window.Shopify.theme.role,
        route: window.location.pathname,
        themeId: window.Shopify.theme.id,
        themeStoreId: window.Shopify.theme.theme_store_id || 0,
        isThemeEditor: !!window.Shopify.designMode,
      })
    );
  }
  theme.cart = {
    getCart: function () {
      var url = ''.concat(theme.routes.cart, '?t=').concat(Date.now());
      return fetch(url, {
        credentials: 'same-origin',
        method: 'GET',
      }).then((response) => response.json());
    },

    getCartProductMarkup: function () {
      var url = ''.concat(theme.routes.cartPage, '?t=').concat(Date.now());

      url = url.indexOf('?') === -1 ? url + '?view=ajax' : url + '&view=ajax';

      return fetch(url, {
        credentials: 'same-origin',
        method: 'GET',
      })
        .then((response) => response.text())
        .catch((e) => console.error(e));
    },

    changeItem: function (key, qty) {
      return this._updateCart({
        url: ''.concat(theme.routes.cartChange, '?t=').concat(Date.now()),
        data: JSON.stringify({
          id: key,
          quantity: qty,
        }),
      });
    },

    _updateCart: function (params) {
      return fetch(params.url, {
        method: 'POST',
        body: params.data,
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
          Accept: 'application/json',
        },
      })
        .then((response) => {
          return response.text();
        })
        .then((cart) => {
          return cart;
        });
    },

    updateAttribute: function (key, value) {
      return this._updateCart({
        url: '/cart/update.js',
        data: JSON.stringify({
          attributes: {
            [key]: theme.cart.attributeToString(value),
          },
        }),
      });
    },

    updateNote: function (note) {
      return this._updateCart({
        url: '/cart/update.js',
        data: JSON.stringify({
          note: theme.cart.attributeToString(note),
        }),
      });
    },

    attributeToString: function (attribute) {
      if (typeof attribute !== 'string') {
        attribute += '';
        if (attribute === 'undefined') {
          attribute = '';
        }
      }
      return attribute.trim();
    },
  };

  /*============================================================================
    CartForm
    - Prevent checkout when terms checkbox exists
    - Listen to quantity changes, rebuild cart (both widget and page)
  ==============================================================================*/
  theme.CartForm = (function () {
    var selectors = {
      products: '[data-products]',
      qtySelector: '.js-qty__wrapper',
      discounts: '[data-discounts]',
      savings: '[data-savings]',
      subTotal: '[data-subtotal]',

      cartBubble: '.cart-link__bubble',
      cartNote: '[name="note"]',
      termsCheckbox: '.cart__terms-checkbox',
      checkoutBtn: '.cart__checkout',
    };

    var classes = {
      btnLoading: 'btn--loading',
    };

    var config = {
      requiresTerms: false,
    };

    function CartForm(form) {
      if (!form) {
        return;
      }

      this.form = form;
      this.wrapper = form.parentNode;
      this.location = form.dataset.location;
      this.namespace = '.cart-' + this.location;
      this.products = form.querySelector(selectors.products);
      this.submitBtn = form.querySelector(selectors.checkoutBtn);

      this.discounts = form.querySelector(selectors.discounts);
      this.savings = form.querySelector(selectors.savings);
      this.subtotal = form.querySelector(selectors.subTotal);
      this.termsCheckbox = form.querySelector(selectors.termsCheckbox);
      this.noteInput = form.querySelector(selectors.cartNote);

      this.cartItemsUpdated = false;

      if (this.termsCheckbox) {
        config.requiresTerms = true;
      }

      this.init();
    }

    CartForm.prototype = Object.assign({}, CartForm.prototype, {
      init: function () {
        this.initQtySelectors();

        document.addEventListener('cart:quantity' + this.namespace, this.quantityChanged.bind(this));

        this.form.on('submit' + this.namespace, this.onSubmit.bind(this));

        if (this.noteInput) {
          this.noteInput.addEventListener('change', function () {
            var newNote = this.value;
            theme.cart.updateNote(newNote);
          });
        }

        // Dev-friendly way to build the cart
        document.addEventListener(
          'cart:build',
          function () {
            this.buildCart();
          }.bind(this)
        );
      },

      reInit: function () {
        this.initQtySelectors();
      },

      onSubmit: function (evt) {
        this.submitBtn.classList.add(classes.btnLoading);

        /*
          Checks for drawer or cart open class on body element
          and then stops the form from being submitted. We are also
          checking against a custom property, this.cartItemsUpdated = false.

          Error is handled in the quantityChanged method

          For Expanse/Fetch/Gem quick add, if an error is present it is alerted
          through the add to cart fetch request in quick-add.js.

          Custom property this.cartItemsUpdated = false is reset in cart-drawer.js for
          Expanse/Fetch/Gem when using quick add
        */

        if (
          (document.documentElement.classList.contains('js-drawer-open') && this.cartItemsUpdated) ||
          (document.documentElement.classList.contains('cart-open') && this.cartItemsUpdated)
        ) {
          this.submitBtn.classList.remove(classes.btnLoading);
          evt.preventDefault();
          return false;
        }

        if (config.requiresTerms) {
          if (this.termsCheckbox.checked) {
            // continue to checkout
          } else {
            alert(theme.strings.cartTermsConfirmation);
            this.submitBtn.classList.remove(classes.btnLoading);
            evt.preventDefault();
            return false;
          }
        }
      },

      /*============================================================================
        Query cart page to get markup
      ==============================================================================*/
      _parseProductHTML: function (text) {
        const html = document.createElement('div');
        html.innerHTML = text;

        return {
          items: html.querySelector('.cart__items'),
          discounts: html.querySelector('.cart__discounts'),
        };
      },

      buildCart: function () {
        theme.cart.getCartProductMarkup().then(this.cartMarkup.bind(this));
      },

      cartMarkup: function (text) {
        var markup = this._parseProductHTML(text);
        var items = markup.items;
        var count = parseInt(items.dataset.count);
        var subtotal = items.dataset.cartSubtotal;
        var savings = items.dataset.cartSavings;

        this.updateCartDiscounts(markup.discounts);
        this.updateSavings(savings);

        if (count > 0) {
          this.wrapper.classList.remove('is-empty');
        } else {
          this.wrapper.classList.add('is-empty');
        }

        this.updateCount(count);

        // Append item markup
        this.products.innerHTML = '';
        this.products.append(items);

        // Update subtotal
        this.subtotal.innerHTML = theme.Currency.formatMoney(subtotal, theme.settings.moneyFormat);

        this.reInit();

        if (window.AOS) {
          AOS.refreshHard();
        }

        if (Shopify && Shopify.StorefrontExpressButtons) {
          Shopify.StorefrontExpressButtons.initialize();
        }
      },

      updateCartDiscounts: function (markup) {
        if (!this.discounts) {
          return;
        }
        this.discounts.innerHTML = '';
        this.discounts.append(markup);
      },

      /*============================================================================
        Quantity handling
      ==============================================================================*/
      initQtySelectors: function () {
        this.form.querySelectorAll(selectors.qtySelector).forEach((el) => {
          var selector = new theme.QtySelector(el, {
            namespace: this.namespace,
            isCart: true,
          });
        });
      },

      quantityChanged: function (evt) {
        var key = evt.detail[0];
        var qty = evt.detail[1];
        var el = evt.detail[2];

        if (!key || !qty) {
          return;
        }

        // Disable qty selector so multiple clicks can't happen while loading
        if (el) {
          el.classList.add('is-loading');
        }

        theme.cart
          .changeItem(key, qty)
          .then(
            function (cart) {
              const parsedCart = JSON.parse(cart);

              if (parsedCart.status === 422) {
                alert(parsedCart.message);
              } else {
                const updatedItem = parsedCart.items.find((item) => item.key === key);

                // Update cartItemsUpdated property on object so we can reference later
                if (
                  updatedItem &&
                  (evt.type === 'cart:quantity.cart-cart-drawer' || evt.type === 'cart:quantity.cart-header')
                ) {
                  this.cartItemsUpdated = true;
                }

                if (
                  (updatedItem && evt.type === 'cart:quantity.cart-cart-drawer') ||
                  (updatedItem && evt.type === 'cart:quantity.cart-header')
                ) {
                  if (updatedItem.quantity !== qty) {
                  }
                  // Reset property on object so that checkout button will work as usual
                  this.cartItemsUpdated = false;
                }

                if (parsedCart.item_count > 0) {
                  this.wrapper.classList.remove('is-empty');
                } else {
                  this.wrapper.classList.add('is-empty');
                }
              }

              this.buildCart();

              document.dispatchEvent(
                new CustomEvent('cart:updated', {
                  detail: {
                    cart: parsedCart,
                  },
                })
              );
            }.bind(this)
          )
          .catch(function (XMLHttpRequest) {});
      },

      /*============================================================================
        Update elements of the cart
      ==============================================================================*/
      updateSubtotal: function (subtotal) {
        this.form.querySelector(selectors.subTotal).innerHTML = theme.Currency.formatMoney(
          subtotal,
          theme.settings.moneyFormat
        );
      },

      updateSavings: function (savings) {
        if (!this.savings) {
          return;
        }

        if (savings > 0) {
          var amount = theme.Currency.formatMoney(savings, theme.settings.moneyFormat);
          this.savings.classList.remove('hide');
          this.savings.innerHTML = theme.strings.cartSavings.replace('[savings]', amount);
        } else {
          this.savings.classList.add('hide');
        }
      },

      updateCount: function (count) {
        var countEls = document.querySelectorAll('.cart-link__bubble-num');

        if (countEls.length) {
          countEls.forEach((el) => {
            el.innerText = count;
          });
        }

        // show/hide bubble(s)
        var bubbles = document.querySelectorAll(selectors.cartBubble);
        if (bubbles.length) {
          if (count > 0) {
            bubbles.forEach((b) => {
              b.classList.add('cart-link__bubble--visible');
            });
          } else {
            bubbles.forEach((b) => {
              b.classList.remove('cart-link__bubble--visible');
            });
          }
        }
      },
    });

    return CartForm;
  })();

  // Either collapsible containers all acting individually,
  // or tabs that can only have one open at a time
  theme.collapsibles = (function () {
    var selectors = {
      trigger: '.collapsible-trigger',
      module: '.collapsible-content',
      moduleInner: '.collapsible-content__inner',
      tabs: '.collapsible-trigger--tab',
    };

    var classes = {
      hide: 'hide',
      open: 'is-open',
      autoHeight: 'collapsible--auto-height',
      tabs: 'collapsible-trigger--tab',
    };

    var namespace = '.collapsible';

    var isTransitioning = false;

    function init(scope) {
      var el = scope ? scope : document;
      el.querySelectorAll(selectors.trigger).forEach((trigger) => {
        var state = trigger.classList.contains(classes.open);
        trigger.setAttribute('aria-expanded', state);

        trigger.off('click' + namespace);
        trigger.on('click' + namespace, toggle);
      });
    }

    function toggle(evt) {
      if (isTransitioning) {
        return;
      }

      isTransitioning = true;

      var el = evt.currentTarget;
      var isOpen = el.classList.contains(classes.open);
      var isTab = el.classList.contains(classes.tabs);
      var moduleId = el.getAttribute('aria-controls');
      var container = document.getElementById(moduleId);

      if (!moduleId) {
        moduleId = el.dataset.controls;
      }

      // No ID, bail
      if (!moduleId) {
        return;
      }

      // If container=null, there isn't a matching ID.
      // Check if data-id is set instead. Could be multiple.
      // Select based on being in the same parent div.
      if (!container) {
        var multipleMatches = document.querySelectorAll('[data-id="' + moduleId + '"]');
        if (multipleMatches.length > 0) {
          container = el.parentNode.querySelector('[data-id="' + moduleId + '"]');
        }
      }

      if (!container) {
        isTransitioning = false;
        return;
      }

      var height = container.querySelector(selectors.moduleInner).offsetHeight;
      var isAutoHeight = container.classList.contains(classes.autoHeight);
      var parentCollapsibleEl = container.parentNode.closest(selectors.module);
      var childHeight = height;

      if (isTab) {
        if (isOpen) {
          isTransitioning = false;
          return;
        }

        var newModule;
        document.querySelectorAll(selectors.tabs + '[data-id="' + el.dataset.id + '"]').forEach((el) => {
          el.classList.remove(classes.open);
          newModule = document.querySelector('#' + el.getAttribute('aria-controls'));
          setTransitionHeight(newModule, 0, true);
        });
      }

      // If isAutoHeight, set the height to 0 just after setting the actual height
      // so the closing animation works nicely
      if (isOpen && isAutoHeight) {
        setTimeout(function () {
          height = 0;
          setTransitionHeight(container, height, isOpen, isAutoHeight);
        }, 0);
      }

      if (isOpen && !isAutoHeight) {
        height = 0;
      }

      el.setAttribute('aria-expanded', !isOpen);
      if (isOpen) {
        el.classList.remove(classes.open);
      } else {
        el.classList.add(classes.open);
      }

      setTransitionHeight(container, height, isOpen, isAutoHeight);

      // If we are in a nested collapsible element like the mobile nav,
      // also set the parent element's height
      if (parentCollapsibleEl) {
        var parentHeight = parentCollapsibleEl.style.height;

        if (isOpen && parentHeight === 'auto') {
          childHeight = 0; // Set childHeight to 0 if parent is initially opened
        }

        var totalHeight = isOpen
          ? parentCollapsibleEl.offsetHeight - childHeight
          : height + parentCollapsibleEl.offsetHeight;

        setTransitionHeight(parentCollapsibleEl, totalHeight, false, false);
      }
    }

    function setTransitionHeight(container, height, isOpen, isAutoHeight) {
      container.classList.remove(classes.hide);
      theme.utils.prepareTransition(container, function () {
        container.style.height = height + 'px';
        if (isOpen) {
          container.classList.remove(classes.open);
        } else {
          container.classList.add(classes.open);
        }
      });

      if (!isOpen && isAutoHeight) {
        var o = container;
        window.setTimeout(function () {
          o.css('height', 'auto');
          isTransitioning = false;
        }, 500);
      } else {
        isTransitioning = false;
      }
    }

    return {
      init: init,
    };
  })();

  // Shopify-built select-like popovers for currency and language selection
  theme.Disclosure = (function () {
    var selectors = {
      disclosureForm: '[data-disclosure-form]',
      disclosureList: '[data-disclosure-list]',
      disclosureToggle: '[data-disclosure-toggle]',
      disclosureInput: '[data-disclosure-input]',
      disclosureOptions: '[data-disclosure-option]',
    };

    var classes = {
      listVisible: 'disclosure-list--visible',
    };

    function Disclosure(disclosure) {
      this.container = disclosure;
      this._cacheSelectors();
      this._setupListeners();
    }

    Disclosure.prototype = Object.assign({}, Disclosure.prototype, {
      _cacheSelectors: function () {
        this.cache = {
          disclosureForm: this.container.closest(selectors.disclosureForm),
          disclosureList: this.container.querySelector(selectors.disclosureList),
          disclosureToggle: this.container.querySelector(selectors.disclosureToggle),
          disclosureInput: this.container.querySelector(selectors.disclosureInput),
          disclosureOptions: this.container.querySelectorAll(selectors.disclosureOptions),
        };
      },

      _setupListeners: function () {
        this.eventHandlers = this._setupEventHandlers();

        this.cache.disclosureToggle.addEventListener('click', this.eventHandlers.toggleList);

        this.cache.disclosureOptions.forEach(function (disclosureOption) {
          disclosureOption.addEventListener('click', this.eventHandlers.connectOptions);
        }, this);

        this.container.addEventListener('keyup', this.eventHandlers.onDisclosureKeyUp);

        this.cache.disclosureList.addEventListener('focusout', this.eventHandlers.onDisclosureListFocusOut);

        this.cache.disclosureToggle.addEventListener('focusout', this.eventHandlers.onDisclosureToggleFocusOut);

        document.body.addEventListener('click', this.eventHandlers.onBodyClick);
      },

      _setupEventHandlers: function () {
        return {
          connectOptions: this._connectOptions.bind(this),
          toggleList: this._toggleList.bind(this),
          onBodyClick: this._onBodyClick.bind(this),
          onDisclosureKeyUp: this._onDisclosureKeyUp.bind(this),
          onDisclosureListFocusOut: this._onDisclosureListFocusOut.bind(this),
          onDisclosureToggleFocusOut: this._onDisclosureToggleFocusOut.bind(this),
        };
      },

      _connectOptions: function (event) {
        event.preventDefault();

        this._submitForm(event.currentTarget.dataset.value);
      },

      _onDisclosureToggleFocusOut: function (event) {
        var disclosureLostFocus = this.container.contains(event.relatedTarget) === false;

        if (disclosureLostFocus) {
          this._hideList();
        }
      },

      _onDisclosureListFocusOut: function (event) {
        var childInFocus = event.currentTarget.contains(event.relatedTarget);

        var isVisible = this.cache.disclosureList.classList.contains(classes.listVisible);

        if (isVisible && !childInFocus) {
          this._hideList();
        }
      },

      _onDisclosureKeyUp: function (event) {
        if (event.which !== 27) return;
        this._hideList();
        this.cache.disclosureToggle.focus();
      },

      _onBodyClick: function (event) {
        var isOption = this.container.contains(event.target);
        var isVisible = this.cache.disclosureList.classList.contains(classes.listVisible);

        if (isVisible && !isOption) {
          this._hideList();
        }
      },

      _submitForm: function (value) {
        this.cache.disclosureInput.value = value;
        this.cache.disclosureForm.submit();
      },

      _hideList: function () {
        this.cache.disclosureList.classList.remove(classes.listVisible);
        this.cache.disclosureToggle.setAttribute('aria-expanded', false);
      },

      _toggleList: function () {
        var ariaExpanded = this.cache.disclosureToggle.getAttribute('aria-expanded') === 'true';
        this.cache.disclosureList.classList.toggle(classes.listVisible);
        this.cache.disclosureToggle.setAttribute('aria-expanded', !ariaExpanded);
      },

      destroy: function () {
        this.cache.disclosureToggle.removeEventListener('click', this.eventHandlers.toggleList);

        this.cache.disclosureOptions.forEach(function (disclosureOption) {
          disclosureOption.removeEventListener('click', this.eventHandlers.connectOptions);
        }, this);

        this.container.removeEventListener('keyup', this.eventHandlers.onDisclosureKeyUp);

        this.cache.disclosureList.removeEventListener('focusout', this.eventHandlers.onDisclosureListFocusOut);

        this.cache.disclosureToggle.removeEventListener('focusout', this.eventHandlers.onDisclosureToggleFocusOut);

        document.body.removeEventListener('click', this.eventHandlers.onBodyClick);
      },
    });

    return Disclosure;
  })();

  theme.Drawers = (function () {
    function Drawers(id, name) {
      this.config = {
        id: id,
        close: '.js-drawer-close',
        open: '.js-drawer-open-' + name,
        openClass: 'js-drawer-open',
        closingClass: 'js-drawer-closing',
        activeDrawer: 'drawer--is-open',
        namespace: '.drawer-' + name,
      };

      this.nodes = {
        page: document.querySelector('#MainContent'),
      };

      this.drawer = document.querySelector('#' + id);
      this.isOpen = false;

      if (!this.drawer) {
        return;
      }

      this.init();
    }

    Drawers.prototype = Object.assign({}, Drawers.prototype, {
      init: function () {
        // Setup open button(s)
        document.querySelectorAll(this.config.open).forEach((openBtn) => {
          openBtn.setAttribute('aria-expanded', 'false');
          openBtn.addEventListener('click', this.open.bind(this));
        });

        this.drawer.querySelector(this.config.close).addEventListener('click', this.close.bind(this));

        // Close modal if a drawer is opened
        document.addEventListener(
          'modalOpen',
          function () {
            this.close();
          }.bind(this)
        );
      },

      open: function (evt, returnFocusEl) {
        if (evt) {
          evt.preventDefault();
        }

        if (this.isOpen) {
          return;
        }

        // Without this the drawer opens, the click event bubbles up to $nodes.page which closes the drawer.
        if (evt && evt.stopPropagation) {
          evt.stopPropagation();
          // save the source of the click, we'll focus to this on close
          evt.currentTarget.setAttribute('aria-expanded', 'true');
          this.activeSource = evt.currentTarget;
        } else if (returnFocusEl) {
          returnFocusEl.setAttribute('aria-expanded', 'true');
          this.activeSource = returnFocusEl;
        }

        theme.utils.prepareTransition(
          this.drawer,
          function () {
            this.drawer.classList.add(this.config.activeDrawer);
            var stickyBar = document.querySelector("body > div.product-sticky-bar.product-sticky-wrap");
            if (stickyBar) {
              stickyBar.style.transition = 'transform 0.5s';
              stickyBar.style.transform = 'translateY(100%)';
            }
          }.bind(this)
        );

        document.documentElement.classList.add(this.config.openClass);
        this.isOpen = true;

        theme.a11y.trapFocus({
          container: this.drawer,
          namespace: 'drawer_focus',
        });

        document.dispatchEvent(new CustomEvent('drawerOpen'));
        document.dispatchEvent(new CustomEvent('drawerOpen.' + this.config.id));

        this.bindEvents();
      },

      close: function (evt) {
        if (!this.isOpen) {
          return;
        }

        // Do not close if click event came from inside drawer
        if (evt) {
          if (evt.target.closest('.js-drawer-close')) {
            // Do not close if using the drawer close button
          } else if (evt.target.closest('.drawer')) {
            return;
          }
        }

        // deselect any focused form elements
        document.activeElement.blur();

        theme.utils.prepareTransition(
          this.drawer,
          function () {
            this.drawer.classList.remove(this.config.activeDrawer);
            var stickyBar = document.querySelector("body > div.product-sticky-bar.product-sticky-wrap");
            if (stickyBar) {
              stickyBar.style.transform = 'translateY(0)';
            }
          }.bind(this)
        );

        document.documentElement.classList.remove(this.config.openClass);
        document.documentElement.classList.add(this.config.closingClass);

        window.setTimeout(
          function () {
            document.documentElement.classList.remove(this.config.closingClass);
            if (this.activeSource && this.activeSource.getAttribute('aria-expanded')) {
              this.activeSource.setAttribute('aria-expanded', 'false');
              this.activeSource.focus();
            }
          }.bind(this),
          500
        );

        this.isOpen = false;

        theme.a11y.removeTrapFocus({
          container: this.drawer,
          namespace: 'drawer_focus',
        });

        this.unbindEvents();
      },

      bindEvents: function () {
        // Clicking out of drawer closes it
        window.on(
          'click' + this.config.namespace,
          function (evt) {
            this.close(evt);
            return;
          }.bind(this)
        );

        // Pressing escape closes drawer
        window.on(
          'keyup' + this.config.namespace,
          function (evt) {
            if (evt.keyCode === 27) {
              this.close();
            }
          }.bind(this)
        );

        theme.a11y.lockMobileScrolling(this.config.namespace, this.nodes.page);
      },

      unbindEvents: function () {
        window.off('click' + this.config.namespace);
        window.off('keyup' + this.config.namespace);

        theme.a11y.unlockMobileScrolling(this.config.namespace, this.nodes.page);
      },
    });

    return Drawers;
  })();

  theme.Modals = (function () {
    function Modal(id, name, options) {
      var defaults = {
        close: '.js-modal-close',
        open: '.js-modal-open-' + name,
        openClass: 'modal--is-active',
        closingClass: 'modal--is-closing',
        bodyOpenClass: ['modal-open'],
        bodyOpenSolidClass: 'modal-open--solid',
        bodyClosingClass: 'modal-closing',
        closeOffContentClick: true,
      };

      this.id = id;
      this.modal = document.getElementById(id);

      if (!this.modal) {
        return false;
      }

      this.modalContent = this.modal.querySelector('.modal__inner');

      this.config = Object.assign(defaults, options);
      this.modalIsOpen = false;
      this.focusOnOpen = this.config.focusIdOnOpen ? document.getElementById(this.config.focusIdOnOpen) : this.modal;
      this.isSolid = this.config.solid;

      this.init();
    }

    Modal.prototype.init = function () {
      document.querySelectorAll(this.config.open).forEach((btn) => {
        btn.setAttribute('aria-expanded', 'false');
        btn.addEventListener('click', this.open.bind(this));
      });

      this.modal.querySelectorAll(this.config.close).forEach((btn) => {
        btn.addEventListener('click', this.close.bind(this));
      });

      // Close modal if a drawer is opened
      document.addEventListener(
        'drawerOpen',
        function () {
          this.close();
        }.bind(this)
      );
    };

    Modal.prototype.open = function (evt) {
      // Keep track if modal was opened from a click, or called by another function
      var externalCall = false;

      // don't open an opened modal
      if (this.modalIsOpen) {
        return;
      }

      // Prevent following href if link is clicked
      if (evt) {
        evt.preventDefault();
      } else {
        externalCall = true;
      }

      // Without this, the modal opens, the click event bubbles up to $nodes.page
      // which closes the modal.
      if (evt && evt.stopPropagation) {
        evt.stopPropagation();
        // save the source of the click, we'll focus to this on close
        this.activeSource = evt.currentTarget.setAttribute('aria-expanded', 'true');
      }

      if (this.modalIsOpen && !externalCall) {
        this.close();
      }

      this.modal.classList.add(this.config.openClass);

      document.documentElement.classList.add(...this.config.bodyOpenClass);

      if (this.isSolid) {
        document.documentElement.classList.add(this.config.bodyOpenSolidClass);
      }

      this.modalIsOpen = true;

      // Delay trap focus to ensure elements are seen by screen readers
      setTimeout(() => {
        theme.a11y.trapFocus({
          container: this.modal,
          elementToFocus: this.focusOnOpen,
          namespace: 'modal_focus',
        });
      }, 100);

      document.dispatchEvent(new CustomEvent('modalOpen'));
      document.dispatchEvent(new CustomEvent('modalOpen.' + this.id));

      this.bindEvents();
    };

    Modal.prototype.close = function (evt) {
      // don't close a closed modal
      if (!this.modalIsOpen) {
        return;
      }

      // Do not close modal if click happens inside modal content
      if (evt) {
        if (evt.target.closest('.js-modal-close')) {
          // Do not close if using the modal close button
        } else if (evt.target.closest('.modal__inner')) {
          return;
        }
      }

      // deselect any focused form elements
      document.activeElement.blur();

      this.modal.classList.remove(this.config.openClass);
      this.modal.classList.add(this.config.closingClass);

      document.documentElement.classList.remove(...this.config.bodyOpenClass);
      document.documentElement.classList.add(this.config.bodyClosingClass);

      window.setTimeout(
        function () {
          document.documentElement.classList.remove(this.config.bodyClosingClass);
          this.modal.classList.remove(this.config.closingClass);
          if (this.activeSource && this.activeSource.getAttribute('aria-expanded')) {
            this.activeSource.setAttribute('aria-expanded', 'false').focus();
          }
        }.bind(this),
        500
      ); // modal close css transition

      if (this.isSolid) {
        document.documentElement.classList.remove(this.config.bodyOpenSolidClass);
      }

      this.modalIsOpen = false;

      theme.a11y.removeTrapFocus({
        container: this.modal,
        namespace: 'modal_focus',
      });

      document.dispatchEvent(new CustomEvent('modalClose.' + this.id));

      this.unbindEvents();
    };

    Modal.prototype.bindEvents = function () {
      window.on(
        'keyup.modal',
        function (evt) {
          if (evt.keyCode === 27) {
            this.close();
          }
        }.bind(this)
      );

      if (this.config.closeOffContentClick) {
        // Clicking outside of the modal content also closes it
        this.modal.on('click.modal', this.close.bind(this));
      }
    };

    Modal.prototype.unbindEvents = function () {
      document.documentElement.off('.modal');

      if (this.config.closeOffContentClick) {
        this.modal.off('.modal');
      }
    };

    return Modal;
  })();

  /*============================================================================
    ParallaxImage
  ==============================================================================*/

  class ParallaxImage extends HTMLElement {
    constructor() {
      super();
      this.parallaxImage = this.querySelector('[data-parallax-image]');
      this.windowInnerHeight = window.innerHeight;
      this.isActive = false;
      this.timeout = null;
      this.directionMap = {
        right: 0,
        top: 90,
        left: 180,
        bottom: 270,
      };
      this.directionMultipliers = {
        0: [1, 0],
        90: [0, -1],
        180: [-1, 0],
        270: [0, 1],
      };

      this.init();
      window.addEventListener('scroll', () => this.scrollHandler());
    }

    getParallaxInfo() {
      const { width, height, top } = this.parallaxImage.getBoundingClientRect();
      let element = this.parallaxImage;
      let multipliers;
      let { angle, movement } = element.dataset;

      let movementPixels =
        angle === 'top'
          ? Math.ceil(height * (parseFloat(movement) / 100))
          : Math.ceil(width * (parseFloat(movement) / 100));

      // angle has shorthands "top", "left", "bottom" and "right"
      // nullish coalescing. using `||` here would fail for `0`
      angle = this.directionMap[angle] ?? parseFloat(angle);

      // fallback if undefined
      // NaN is the only value that doesn't equal itself
      if (angle !== angle) angle = 270; // move to bottom (default parallax effect)
      if (movementPixels !== movementPixels) movementPixels = 100; // 100px

      // check if angle is located in top half and/or left half
      angle %= 360;
      if (angle < 0) angle += 360;

      const toLeft = angle > 90 && angle < 270;
      const toTop = angle < 180;

      element.style[toLeft ? 'left' : 'right'] = 0;
      element.style[toTop ? 'top' : 'bottom'] = 0;

      // if it's not a perfectly horizontal or vertical movement, get cos and sin
      if (angle % 90) {
        const radians = (angle * Math.PI) / 180;
        multipliers = [Math.cos(radians), Math.sin(radians) * -1]; // only sin has to be inverted
      } else {
        multipliers = this.directionMultipliers[angle];
      }

      // increase width and height according to movement and multipliers
      if (multipliers[0]) element.style.width = `calc(100% + ${movementPixels * Math.abs(multipliers[0])}px)`;
      if (multipliers[1]) element.style.height = `calc(100% + ${movementPixels * Math.abs(multipliers[1])}px)`;

      return {
        element,
        movementPixels,
        multipliers,
        top,
        height,
      };
    }

    init() {
      const { element, movementPixels, multipliers, top, height } = this.getParallaxInfo();

      const scrolledInContainer = this.windowInnerHeight - top;
      const scrollArea = this.windowInnerHeight + height;
      const progress = scrolledInContainer / scrollArea;

      if (progress > -0.1 && progress < 1.1) {
        const position = Math.min(Math.max(progress, 0), 1) * movementPixels;
        element.style.transform = `translate3d(${position * multipliers[0]}px, ${position * multipliers[1]}px, 0)`;
      }

      if (this.isActive) requestAnimationFrame(this.init.bind(this));
    }

    scrollHandler() {
      if (this.isActive) {
        clearTimeout(this.timeout);
      } else {
        this.isActive = true;
        requestAnimationFrame(this.init.bind(this));
      }

      this.timeout = setTimeout(() => (this.isActive = false), 20);
    }
  }

  customElements.define('parallax-image', ParallaxImage);

  if (typeof window.noUiSlider === 'undefined') {
    throw new Error('theme.PriceRange is missing vendor noUiSlider: // =require vendor/nouislider.js');
  }

  theme.PriceRange = (function () {
    var defaultStep = 10;
    var selectors = {
      priceRange: '.price-range',
      priceRangeSlider: '.price-range__slider',
      priceRangeInputMin: '.price-range__input-min',
      priceRangeInputMax: '.price-range__input-max',
      priceRangeDisplayMin: '.price-range__display-min',
      priceRangeDisplayMax: '.price-range__display-max',
    };

    function PriceRange(container, { onChange, onUpdate, ...sliderOptions } = {}) {
      this.container = container;
      this.onChange = onChange;
      this.onUpdate = onUpdate;
      this.sliderOptions = sliderOptions || {};

      return this.init();
    }

    PriceRange.prototype = Object.assign({}, PriceRange.prototype, {
      init: function () {
        if (!this.container.classList.contains('price-range')) {
          throw new Error('You must instantiate PriceRange with a valid container');
        }

        this.formEl = this.container.closest('form');
        this.sliderEl = this.container.querySelector(selectors.priceRangeSlider);
        this.inputMinEl = this.container.querySelector(selectors.priceRangeInputMin);
        this.inputMaxEl = this.container.querySelector(selectors.priceRangeInputMax);
        this.displayMinEl = this.container.querySelector(selectors.priceRangeDisplayMin);
        this.displayMaxEl = this.container.querySelector(selectors.priceRangeDisplayMax);

        this.minRange = parseFloat(this.container.dataset.min) || 0;
        this.minValue = parseFloat(this.container.dataset.minValue) || 0;
        this.maxRange = parseFloat(this.container.dataset.max) || 100;
        this.maxValue = parseFloat(this.container.dataset.maxValue) || this.maxRange;

        return this.createPriceRange();
      },

      createPriceRange: function () {
        if (this.sliderEl && this.sliderEl.noUiSlider && typeof this.sliderEl.noUiSlider.destroy === 'function') {
          this.sliderEl.noUiSlider.destroy();
        }

        var slider = noUiSlider.create(this.sliderEl, {
          connect: true,
          step: defaultStep,
          ...this.sliderOptions,
          // Do not allow overriding these options
          start: [this.minValue, this.maxValue],
          range: {
            min: this.minRange,
            max: this.maxRange,
          },
        });

        slider.on('update', (values) => {
          this.displayMinEl.innerHTML = theme.Currency.formatMoney(values[0], theme.settings.moneyFormat);
          this.displayMaxEl.innerHTML = theme.Currency.formatMoney(values[1], theme.settings.moneyFormat);

          if (this.onUpdate) {
            this.onUpdate(values);
          }
        });

        slider.on('change', (values) => {
          this.inputMinEl.value = values[0];
          this.inputMaxEl.value = values[1];

          if (this.onChange) {
            const formData = new FormData(this.formEl);
            this.onChange(formData);
          }
        });

        return slider;
      },
    });

    return PriceRange;
  })();

  theme.AjaxProduct = (function () {
    var status = {
      loading: false,
    };

    function ProductForm(form, submit, args) {
      this.form = form;
      this.args = args;

      var submitSelector = submit ? submit : '.add-to-cart';

      if (this.form) {
        this.addToCart = form.querySelector(submitSelector);
        this.form.addEventListener('submit', this.addItemFromForm.bind(this));
      }
    }

    ProductForm.prototype = Object.assign({}, ProductForm.prototype, {
      addItemFromForm: function (evt, callback) {
        evt.preventDefault();

        if (status.loading) {
          return;
        }

        // Loading indicator on add to cart button
        this.addToCart.classList.add('btn--loading');

        status.loading = true;

        var data = theme.utils.serialize(this.form);

        fetch(theme.routes.cartAdd, {
          method: 'POST',
          body: data,
          credentials: 'same-origin',
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            'X-Requested-With': 'XMLHttpRequest',
          },
        })
          .then((response) => response.json())
          .then(
            function (data) {
              if (data.status === 422) {
                this.error(data);
              } else {
                var product = data;
                this.success(product);
              }

              status.loading = false;
              this.addToCart.classList.remove('btn--loading');

              // Reload page if adding product from a section on the cart page
              if (document.body.classList.contains('template-cart')) {
                window.scrollTo(0, 0);
                location.reload();
              }
            }.bind(this)
          );
      },

      success: function (product) {
        var errors = this.form.querySelector('.errors');
        if (errors) {
          errors.remove();
        }

        if (theme.settings.cartType === 'page') {
          window.location = theme.routes.cartPage;
        }

        this.form.dispatchEvent(
          new CustomEvent('ajaxProduct:added', {
            detail: {
              product: product,
              addToCartBtn: this.addToCart,
            },
            bubbles: true,
          })
        );

        if (this.args && this.args.scopedEventId) {
          document.dispatchEvent(
            new CustomEvent('ajaxProduct:added:' + this.args.scopedEventId, {
              detail: {
                product: product,
                addToCartBtn: this.addToCart,
              },
            })
          );
        }
      },

      error: function (error) {
        if (!error.description) {
          console.warn(error);
          return;
        }

        var errors = this.form.querySelector('.errors');
        if (errors) {
          errors.remove();
        }

        var errorDiv = document.createElement('div');
        errorDiv.classList.add('errors', 'text-center');

        if (typeof error.description === 'object') {
          errorDiv.textContent = error.message;
        } else {
          errorDiv.textContent = error.description;
        }

        this.form.append(errorDiv);

        this.form.dispatchEvent(
          new CustomEvent('ajaxProduct:error', {
            detail: {
              errorMessage: error.description,
            },
            bubbles: true,
          })
        );

        if (this.args && this.args.scopedEventId) {
          document.dispatchEvent(
            new CustomEvent('ajaxProduct:error:' + this.args.scopedEventId, {
              detail: {
                errorMessage: error.description,
              },
            })
          );
        }
      },
    });

    return ProductForm;
  })();

  theme.ProductMedia = (function () {
    var modelJsonSections = {};
    var models = {};
    var xrButtons = {};

    var selectors = {
      mediaGroup: '[data-product-single-media-group]',
      xrButton: '[data-shopify-xr]',
    };

    function init(modelViewerContainers, sectionId) {
      modelJsonSections[sectionId] = {
        loaded: false,
      };

      modelViewerContainers.forEach(function (container, index) {
        var mediaId = container.dataset.mediaId;
        var modelViewerElement = container.querySelector('model-viewer');
        var modelId = modelViewerElement.dataset.modelId;

        if (index === 0) {
          var mediaGroup = container.closest(selectors.mediaGroup);
          var xrButton = mediaGroup.querySelector(selectors.xrButton);
          xrButtons[sectionId] = {
            element: xrButton,
            defaultId: modelId,
          };
        }

        models[mediaId] = {
          modelId: modelId,
          sectionId: sectionId,
          container: container,
          element: modelViewerElement,
        };
      });

      window.Shopify.loadFeatures([
        {
          name: 'shopify-xr',
          version: '1.0',
          onLoad: setupShopifyXr,
        },
        {
          name: 'model-viewer-ui',
          version: '1.0',
          onLoad: setupModelViewerUi,
        },
      ]);

      theme.LibraryLoader.load('modelViewerUiStyles');
    }

    function setupShopifyXr(errors) {
      if (errors) return;

      if (!window.ShopifyXR) {
        document.addEventListener('shopify_xr_initialized', function () {
          setupShopifyXr();
        });
        return;
      }

      for (var sectionId in modelJsonSections) {
        if (modelJsonSections.hasOwnProperty(sectionId)) {
          var modelSection = modelJsonSections[sectionId];

          if (modelSection.loaded) continue;

          var modelJson = document.querySelector('#ModelJson-' + sectionId);

          window.ShopifyXR.addModels(JSON.parse(modelJson.innerHTML));
          modelSection.loaded = true;
        }
      }
      window.ShopifyXR.setupXRElements();
    }

    function setupModelViewerUi(errors) {
      if (errors) return;

      for (var key in models) {
        if (models.hasOwnProperty(key)) {
          var model = models[key];
          if (!model.modelViewerUi && Shopify) {
            model.modelViewerUi = new Shopify.ModelViewerUI(model.element);
          }
          setupModelViewerListeners(model);
        }
      }
    }

    function setupModelViewerListeners(model) {
      var xrButton = xrButtons[model.sectionId];

      model.container.addEventListener('mediaVisible', function (event) {
        xrButton.element.setAttribute('data-shopify-model3d-id', model.modelId);
        if (theme.config.isTouch) return;
        if (!event.detail.autoplayMedia) return;
        model.modelViewerUi.play();
      });

      model.container.addEventListener('mediaHidden', function () {
        xrButton.element.setAttribute('data-shopify-model3d-id', xrButton.defaultId);
        model.modelViewerUi.pause();
      });

      model.container.addEventListener('xrLaunch', function () {
        model.modelViewerUi.pause();
      });
    }

    function removeSectionModels(sectionId) {
      for (var key in models) {
        if (models.hasOwnProperty(key)) {
          var model = models[key];
          if (model.sectionId === sectionId) {
            delete models[key];
          }
        }
      }
      delete modelJsonSections[sectionId];
    }

    return {
      init: init,
      removeSectionModels: removeSectionModels,
    };
  })();

  theme.QtySelector = (function () {
    var selectors = {
      input: '.js-qty__num',
      plus: '.js-qty__adjust--plus',
      minus: '.js-qty__adjust--minus',
    };

    function QtySelector(el, options) {
      this.wrapper = el;
      this.plus = el.querySelector(selectors.plus);
      this.minus = el.querySelector(selectors.minus);
      this.input = el.querySelector(selectors.input);
      this.minValue = this.input.getAttribute('min') || 1;

      var defaults = {
        namespace: null,
        isCart: false,
        key: this.input.dataset.id,
      };

      this.options = Object.assign({}, defaults, options);

      this.init();
    }

    QtySelector.prototype = Object.assign({}, QtySelector.prototype, {
      init: function () {
        this.plus.addEventListener(
          'click',
          function () {
            var qty = this._getQty();
            this._change(qty + 1);
          }.bind(this)
        );

        this.minus.addEventListener(
          'click',
          function () {
            var qty = this._getQty();
            this._change(qty - 1);
          }.bind(this)
        );

        this.input.addEventListener(
          'change',
          function (evt) {
            this._change(this._getQty());
          }.bind(this)
        );
      },

      _getQty: function () {
        var qty = this.input.value;
        if (parseFloat(qty) == parseInt(qty) && !isNaN(qty)) {
          // We have a valid number!
        } else {
          // Not a number. Default to 1.
          qty = 1;
        }
        return parseInt(qty);
      },

      _change: function (qty) {
        if (qty <= this.minValue) {
          qty = this.minValue;
        }

        this.input.value = qty;

        if (this.options.isCart) {
          document.dispatchEvent(
            new CustomEvent('cart:quantity' + this.options.namespace, {
              detail: [this.options.key, qty, this.wrapper],
            })
          );
        }
      },
    });

    return QtySelector;
  })();

  theme.initQuickShop = function () {
    var ids = [];
    var products = document.querySelectorAll('.grid-product');

    if (!products.length || !theme.settings.quickView) {
      return;
    }

    products.forEach((product) => {
      product.addEventListener('mouseover', productMouseover);
      product.addEventListener('focusin', productMouseover);
    });

    function productMouseover(evt) {
      var el = evt.currentTarget;
      // No quick view on mobile breakpoint
      if (!theme.config.bpSmall) {
        el.removeEventListener('mouseover', productMouseover);
        el.removeEventListener('focusin', productMouseover);
        if (!el || !el.dataset.productId) {
          // Onboarding product, no real data
          return;
        }
        var productId = el.dataset.productId;
        var handle = el.dataset.productHandle;
        var btn = el.querySelector('.quick-product__btn');
        theme.preloadProductModal(handle, productId, btn);
      }
    }
  };

  theme.preloadProductModal = function (handle, productId, btn) {
    var holder = document.getElementById('QuickShopHolder-' + handle);
    var url = theme.routes.home + '/products/' + handle + '?view=modal';

    // remove double `/` in case shop might have /en or language in URL
    url = url.replace('//', '/');

    fetch(url)
      .then((response) => response.text())
      .then((text) => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const div = html.querySelector('.product-section[data-product-handle="' + handle + '"]');

        if (!holder) {
          return;
        }

        holder.innerHTML = '';
        holder.append(div);

        // Setup quick view modal
        var modalId = 'QuickShopModal-' + productId;
        var name = 'quick-modal-' + productId;
        new theme.Modals(modalId, name);

        // Register product template inside quick view
        theme.sections.register('product', theme.Product, holder);

        // Register collapsible elements
        theme.collapsibles.init();

        // Register potential video modal links (when video has sound)
        theme.videoModal();

        if (btn) {
          btn.classList.remove('quick-product__btn--not-ready');
        }
      });
  };

  // theme.Slideshow handles all flickity based sliders
  // Child navigation is only setup to work on product images
  theme.Slideshow = (function () {
    var classes = {
      animateOut: 'animate-out',
      isPaused: 'is-paused',
      isActive: 'is-active',
    };

    var selectors = {
      allSlides: '.slideshow__slide',
      currentSlide: '.is-selected',
      wrapper: '.slideshow-wrapper',
      pauseButton: '.slideshow__pause',
    };

    var productSelectors = {
      thumb: '.product__thumb-item:not(.hide)',
      links: '.product__thumb-item:not(.hide) a',
      arrow: '.product__thumb-arrow',
    };

    var defaults = {
      adaptiveHeight: false,
      autoPlay: false,
      avoidReflow: false, // custom by Archetype
      childNav: null, // element. Custom by Archetype instead of asNavFor
      childNavScroller: null, // element
      childVertical: false,
      dragThreshold: 7,
      fade: false,
      friction: 0.8,
      initialIndex: 0,
      pageDots: false,
      pauseAutoPlayOnHover: false,
      prevNextButtons: false,
      rightToLeft: theme.config.rtl,
      selectedAttraction: 0.14,
      setGallerySize: true,
      wrapAround: true,
    };

    function slideshow(el, args) {
      this.el = el;
      this.args = Object.assign({}, defaults, args);

      // Setup listeners as part of arguments
      this.args.on = {
        ready: this.init.bind(this),
        change: this.slideChange.bind(this),
        settle: this.afterChange.bind(this),
      };

      if (this.args.childNav) {
        this.childNavEls = this.args.childNav.querySelectorAll(productSelectors.thumb);
        this.childNavLinks = this.args.childNav.querySelectorAll(productSelectors.links);
        this.arrows = this.args.childNav.querySelectorAll(productSelectors.arrow);
        if (this.childNavLinks.length) {
          this.initChildNav();
        }
      }

      if (this.args.avoidReflow) {
        avoidReflow(el);
      }

      this.slideshow = new Flickity(el, this.args);

      // Prevent dragging on the product slider from triggering a zoom on product images
      if (el.dataset.zoom && el.dataset.zoom === 'true') {
        this.slideshow.on('dragStart', () => {
          this.slideshow.slider.style.pointerEvents = 'none';

          // With fade enabled, we also need to adjust the pointerEvents on the selected slide
          if (this.slideshow.options.fade) {
            this.slideshow.slider.querySelector('.is-selected').style.pointerEvents = 'none';
          }
        });
        this.slideshow.on('dragEnd', () => {
          this.slideshow.slider.style.pointerEvents = 'auto';

          // With fade enabled, we also need to adjust the pointerEvents on the selected slide
          if (this.slideshow.options.fade) {
            this.slideshow.slider.querySelector('.is-selected').style.pointerEvents = 'auto';
          }
        });
      }

      if (this.args.autoPlay) {
        var wrapper = el.closest(selectors.wrapper);
        this.pauseBtn = wrapper.querySelector(selectors.pauseButton);
        if (this.pauseBtn) {
          this.pauseBtn.addEventListener('click', this._togglePause.bind(this));
        }
      }

      // Reset dimensions on resize
      window.on(
        'resize',
        theme.utils.debounce(
          300,
          function () {
            this.resize();
          }.bind(this)
        )
      );

      // Set flickity-viewport height to first element to
      // avoid awkward page reflows while initializing.
      // Must be added in a `style` tag because element does not exist yet.
      // Slideshow element must have an ID
      function avoidReflow(el) {
        if (!el.id) return;
        var firstChild = el.firstChild;
        while (firstChild != null && firstChild.nodeType == 3) {
          // skip TextNodes
          firstChild = firstChild.nextSibling;
        }
        var style = document.createElement('style');
        style.innerHTML = `#${el.id} .flickity-viewport{height:${firstChild.offsetHeight}px}`;
        document.head.appendChild(style);
      }
    }

    slideshow.prototype = Object.assign({}, slideshow.prototype, {
      init: function (el) {
        this.currentSlide = this.el.querySelector(selectors.currentSlide);

        // Optional onInit callback
        if (this.args.callbacks && this.args.callbacks.onInit) {
          if (typeof this.args.callbacks.onInit === 'function') {
            this.args.callbacks.onInit(this.currentSlide);
          }
        }

        if (window.AOS) {
          AOS.refresh();
        }
      },

      slideChange: function (index) {
        // Outgoing fade styles
        if (this.args.fade && this.currentSlide) {
          this.currentSlide.classList.add(classes.animateOut);
          this.currentSlide.addEventListener(
            'transitionend',
            function () {
              this.currentSlide.classList.remove(classes.animateOut);
            }.bind(this)
          );
        }

        // Match index with child nav
        if (this.args.childNav) {
          this.childNavGoTo(index);
        }

        // Optional onChange callback
        if (this.args.callbacks && this.args.callbacks.onChange) {
          if (typeof this.args.callbacks.onChange === 'function') {
            this.args.callbacks.onChange(index);
          }
        }

        // Show/hide arrows depending on selected index
        if (this.arrows && this.arrows.length) {
          this.arrows[0].classList.toggle('hide', index === 0);
          this.arrows[1].classList.toggle('hide', index === this.childNavLinks.length - 1);
        }
      },
      afterChange: function (index) {
        // Remove all fade animation classes after slide is done
        if (this.args.fade) {
          this.el.querySelectorAll(selectors.allSlides).forEach((slide) => {
            slide.classList.remove(classes.animateOut);
          });
        }

        this.currentSlide = this.el.querySelector(selectors.currentSlide);

        // Match index with child nav (in case slider height changed first)
        if (this.args.childNav) {
          this.childNavGoTo(this.slideshow.selectedIndex);
        }
      },
      destroy: function () {
        if (this.args.childNav && this.childNavLinks.length) {
          this.childNavLinks.forEach((a) => {
            a.classList.remove(classes.isActive);
          });
        }

        this.slideshow.destroy();
      },
      reposition: function () {
        this.slideshow.reposition();
      },
      _togglePause: function () {
        if (this.pauseBtn.classList.contains(classes.isPaused)) {
          this.pauseBtn.classList.remove(classes.isPaused);
          this.slideshow.playPlayer();
        } else {
          this.pauseBtn.classList.add(classes.isPaused);
          this.slideshow.pausePlayer();
        }
      },
      resize: function () {
        this.slideshow.resize();
      },
      play: function () {
        this.slideshow.playPlayer();
      },
      pause: function () {
        this.slideshow.pausePlayer();
      },
      goToSlide: function (i) {
        this.slideshow.select(i);
      },
      setDraggable: function (enable) {
        this.slideshow.options.draggable = enable;
        this.slideshow.updateDraggable();
      },

      initChildNav: function () {
        this.childNavLinks[this.args.initialIndex].classList.add('is-active');

        // Setup events
        this.childNavLinks.forEach((link, i) => {
          // update data-index because image-set feature may be enabled
          link.setAttribute('data-index', i);

          link.addEventListener(
            'click',
            function (evt) {
              evt.preventDefault();
              this.goToSlide(this.getChildIndex(evt.currentTarget));
            }.bind(this)
          );
          link.addEventListener(
            'focus',
            function (evt) {
              this.goToSlide(this.getChildIndex(evt.currentTarget));
            }.bind(this)
          );
          link.addEventListener(
            'keydown',
            function (evt) {
              if (evt.keyCode === 13) {
                this.goToSlide(this.getChildIndex(evt.currentTarget));
              }
            }.bind(this)
          );
        });

        // Setup optional arrows
        if (this.arrows.length) {
          this.arrows.forEach((arrow) => {
            arrow.addEventListener('click', this.arrowClick.bind(this));
          });
        }
      },

      getChildIndex: function (target) {
        return parseInt(target.dataset.index);
      },

      childNavGoTo: function (index) {
        this.childNavLinks.forEach((a) => {
          a.blur();
          a.classList.remove(classes.isActive);
        });

        var el = this.childNavLinks[index];
        el.classList.add(classes.isActive);

        // Prefer the scroller that actually contains this thumb link.
        // Pages can have multiple `.product__thumbs--scroller` instances (e.g. modal + page).
        var scroller = this.args.childNavScroller;
        if (el && typeof el.closest === 'function') {
          var closestScroller = el.closest('.product__thumbs--scroller');
          if (closestScroller) {
            scroller = closestScroller;
          }
        }

        if (!scroller) {
          return;
        }

        // Use bounding rects instead of offsetLeft/offsetTop so scroll math
        // works even when offsetParent is not the scroller.
        var scrollerRect = scroller.getBoundingClientRect();
        var elRect = el.getBoundingClientRect();

        if (this.args.childVertical) {
          var maxTop = Math.max(0, scroller.scrollHeight - scroller.clientHeight);
          var elTop = elRect.top - scrollerRect.top + scroller.scrollTop;
          scroller.scrollTop = Math.max(0, Math.min(elTop - 100, maxTop));
        } else {
          var maxLeft = Math.max(0, scroller.scrollWidth - scroller.clientWidth);
          var elLeft = elRect.left - scrollerRect.left + scroller.scrollLeft;
          scroller.scrollLeft = Math.max(0, Math.min(elLeft - 100, maxLeft));
        }
      },

      arrowClick: function (evt) {
        if (evt.currentTarget.classList.contains('product__thumb-arrow--prev')) {
          this.slideshow.previous();
        } else {
          this.slideshow.next();
        }
      },
    });

    return slideshow;
  })();

  /*============================================================================
    VariantAvailability
    - Cross out sold out or unavailable variants
    - To disable, use the Variant Picker Block setting
    - Required markup:
      - class=variant-input-wrap to wrap select or button group
      - class=variant-input to wrap button/label
  ==============================================================================*/

  theme.VariantAvailability = (function () {
    var classes = {
      disabled: 'disabled',
    };

    function availability(args) {
      this.type = args.type;
      this.variantsObject = args.variantsObject;
      this.currentVariantObject = args.currentVariantObject;
      this.container = args.container;
      this.namespace = args.namespace;

      this.init();
    }

    availability.prototype = Object.assign({}, availability.prototype, {
      init: function () {
        this.container.on('variantChange' + this.namespace, this.setAvailability.bind(this));

        // Set default state based on current selected variant
        this.setInitialAvailability();
      },

      // Create a list of all options. If any variant exists and is in stock with that option, it's considered available
      createAvailableOptionsTree(variants, currentlySelectedValues) {
        // Reduce variant array into option availability tree
        return variants.reduce(
          (options, variant) => {
            // Check each option group (e.g. option1, option2, option3) of the variant
            Object.keys(options).forEach((index) => {
              if (variant[index] === null) return;

              let entry = options[index].find((option) => option.value === variant[index]);

              if (typeof entry === 'undefined') {
                // If option has yet to be added to the options tree, add it
                entry = { value: variant[index], soldOut: true };
                options[index].push(entry);
              }

              const currentOption1 = currentlySelectedValues.find(({ value, index }) => index === 'option1');
              const currentOption2 = currentlySelectedValues.find(({ value, index }) => index === 'option2');

              switch (index) {
                case 'option1':
                  // Option1 inputs should always remain enabled based on all available variants
                  entry.soldOut = entry.soldOut && variant.available ? false : entry.soldOut;
                  break;
                case 'option2':
                  // Option2 inputs should remain enabled based on available variants that match first option group
                  if (currentOption1 && variant['option1'] === currentOption1.value) {
                    entry.soldOut = entry.soldOut && variant.available ? false : entry.soldOut;
                  }
                case 'option3':
                  // Option 3 inputs should remain enabled based on available variants that match first and second option group
                  if (
                    currentOption1 &&
                    variant['option1'] === currentOption1.value &&
                    currentOption2 &&
                    variant['option2'] === currentOption2.value
                  ) {
                    entry.soldOut = entry.soldOut && variant.available ? false : entry.soldOut;
                  }
              }
            });

            return options;
          },
          { option1: [], option2: [], option3: [] }
        );
      },

      setInitialAvailability: function () {
        this.container.querySelectorAll('.variant-input-wrap').forEach((group) => {
          this.disableVariantGroup(group);
        });

        const currentlySelectedValues = this.currentVariantObject.options.map((value, index) => {
          return { value, index: `option${index + 1}` };
        });
        const initialOptions = this.createAvailableOptionsTree(
          this.variantsObject,
          currentlySelectedValues,
          this.currentVariantObject
        );

        for (var [option, values] of Object.entries(initialOptions)) {
          this.manageOptionState(option, values);
        }
      },

      setAvailability: function (evt) {
        const { value: lastSelectedValue, index: lastSelectedIndex, currentlySelectedValues, variant } = evt.detail;

        // Object to hold all options by value.
        // This will be what sets a button/dropdown as
        // sold out or unavailable (not a combo set as purchasable)
        const valuesToManage = this.createAvailableOptionsTree(
          this.variantsObject,
          currentlySelectedValues,
          variant,
          lastSelectedIndex,
          lastSelectedValue
        );

        // Loop through all option levels and send each
        // value w/ args to function that determines to show/hide/enable/disable
        for (var [option, values] of Object.entries(valuesToManage)) {
          this.manageOptionState(option, values, lastSelectedValue);
        }
      },

      manageOptionState: function (option, values) {
        var group = this.container.querySelector('.variant-input-wrap[data-index="' + option + '"]');

        // Loop through each option value
        values.forEach((obj) => {
          this.enableVariantOption(group, obj);
        });
      },

      enableVariantOption: function (group, obj) {
        // Selecting by value so escape it
        var value = obj.value.replace(/([ #;&,.+*~\':"!^$[\]()=>|\/@])/g, '\\$1');

        // Support mixed pickers (some option groups as <select>, others as radios)
        var isDropdownGroup = !!(group && group.querySelector && group.querySelector('select'));

        if (isDropdownGroup) {
          var optionEl = group.querySelector('option[value="' + value + '"]');
          if (optionEl) {
            optionEl.disabled = !!obj.soldOut;
          }
          return;
        }

        var buttonGroup = group.querySelector('.variant-input[data-value="' + value + '"]');
        if (!buttonGroup) return;

        var input = buttonGroup.querySelector('input');
        var label = buttonGroup.querySelector('label');

          // Variant exists - enable & show variant
          if (input) input.classList.remove(classes.disabled);
          if (label) label.classList.remove(classes.disabled);

          // Variant sold out - cross out option (remains selectable)
          if (obj.soldOut) {
            if (input) input.classList.add(classes.disabled);
            if (label) label.classList.add(classes.disabled);
          }
      },

      disableVariantGroup: function (group) {
        var isDropdownGroup = !!(group && group.querySelector && group.querySelector('select'));

        if (isDropdownGroup) {
          group.querySelectorAll('option').forEach((option) => {
            option.disabled = true;
          });
          return;
        }

        group.querySelectorAll('input').forEach((input) => {
          input.classList.add(classes.disabled);
        });
        group.querySelectorAll('label').forEach((label) => {
          label.classList.add(classes.disabled);
        });
      },
    });

    return availability;
  })();

  // Video modal will auto-initialize for any anchor link that points to YouTube
  // MP4 videos must manually be enabled with:
  //   - .product-video-trigger--mp4 (trigger button)
  //   - .product-video-mp4-sound video player element (cloned into modal)
  //     - see media.liquid for example of this
  theme.videoModal = function () {
    var youtubePlayer;
    var vimeoPlayer;

    var videoHolderId = 'VideoHolder';
    var selectors = {
      youtube: 'a[href*="youtube.com/watch"], a[href*="youtu.be/"]',
      vimeo: 'a[href*="player.vimeo.com/player/"], a[href*="vimeo.com/"]',
      mp4Trigger: '.product-video-trigger--mp4',
      mp4Player: '.product-video-mp4-sound',
    };

    var youtubeTriggers = document.querySelectorAll(selectors.youtube);
    var vimeoTriggers = document.querySelectorAll(selectors.vimeo);
    var mp4Triggers = document.querySelectorAll(selectors.mp4Trigger);

    if (!youtubeTriggers.length && !vimeoTriggers.length && !mp4Triggers.length) {
      return;
    }

    var videoHolderDiv = document.getElementById(videoHolderId);

    if (youtubeTriggers.length) {
      theme.LibraryLoader.load('youtubeSdk');
    }

    if (vimeoTriggers.length) {
      theme.LibraryLoader.load('vimeo', window.vimeoApiReady);
    }

    var modal = new theme.Modals('VideoModal', 'video-modal', {
      closeOffContentClick: true,
      bodyOpenClass: ['modal-open', 'video-modal-open'],
      solid: true,
    });

    youtubeTriggers.forEach((btn) => {
      btn.addEventListener('click', triggerYouTubeModal);
    });

    vimeoTriggers.forEach((btn) => {
      btn.addEventListener('click', triggerVimeoModal);
    });

    mp4Triggers.forEach((btn) => {
      btn.addEventListener('click', triggerMp4Modal);
    });

    document.addEventListener('modalClose.VideoModal', closeVideoModal);

    function triggerYouTubeModal(evt) {
      // If not already loaded, treat as normal link
      if (!theme.config.youTubeReady) {
        return;
      }

      evt.preventDefault();
      emptyVideoHolder();

      modal.open(evt);

      var videoId = getYoutubeVideoId(evt.currentTarget.getAttribute('href'));
      youtubePlayer = new theme.YouTube(videoHolderId, {
        videoId: videoId,
        style: 'sound',
        events: {
          onReady: onYoutubeReady,
        },
      });
    }

    function triggerVimeoModal(evt) {
      // If not already loaded, treat as normal link
      if (!theme.config.vimeoReady) {
        return;
      }

      evt.preventDefault();
      emptyVideoHolder();

      modal.open(evt);

      var videoId = evt.currentTarget.dataset.videoId;
      var videoLoop = evt.currentTarget.dataset.videoLoop;
      vimeoPlayer = new theme.VimeoPlayer(videoHolderId, videoId, {
        style: 'sound',
        loop: videoLoop,
      });
    }

    function triggerMp4Modal(evt) {
      emptyVideoHolder();

      var el = evt.currentTarget;
      var player = el.parentNode.querySelector(selectors.mp4Player);

      // Clone video element and place it in the modal
      var playerClone = player.cloneNode(true);
      playerClone.classList.remove('hide');

      videoHolderDiv.append(playerClone);
      modal.open(evt);

      // Play new video element
      videoHolderDiv.querySelector('video').play();
    }

    function onYoutubeReady(evt) {
      evt.target.unMute();
      evt.target.playVideo();
    }

    function getYoutubeVideoId(url) {
      var regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#\&\?]*).*/;
      var match = url.match(regExp);
      return match && match[7].length == 11 ? match[7] : false;
    }

    function emptyVideoHolder() {
      videoHolderDiv.innerHTML = '';
    }

    function closeVideoModal() {
      if (youtubePlayer && typeof youtubePlayer.destroy === 'function') {
        youtubePlayer.destroy();
      } else if (vimeoPlayer && typeof vimeoPlayer.destroy === 'function') {
        vimeoPlayer.destroy();
      } else {
        emptyVideoHolder();
      }
    }
  };

  /*============================================================================
    ToolTip
  ==============================================================================*/

  class ToolTip extends HTMLElement {
    constructor() {
      super();
      this.el = this;
      this.inner = this.querySelector('[data-tool-tip-inner]');
      this.closeButton = this.querySelector('[data-tool-tip-close]');
      this.toolTipContent = this.querySelector('[data-tool-tip-content]');
      this.toolTipTitle = this.querySelector('[data-tool-tip-title]');

      this.triggers = document.querySelectorAll('[data-tool-tip-trigger]');

      document.addEventListener('tooltip:open', (e) => {
        this._open(e.detail.context, e.detail.content);
      });
    }

    _open(context, insertedHtml) {
      this.toolTipContent.innerHTML = insertedHtml;

      // Ensure we set a title for product availability
      if (context != 'store-availability') {
        this.toolTipTitle.remove();
      }

      this._lockScrolling();

      if (this.closeButton) {
        this.closeButton.on('click' + '.tooltip-close', () => {
          this._close();
        });
      }

      document.documentElement.on('click' + '.tooltip-outerclick', (event) => {
        if (this.el.dataset.toolTipOpen === 'true' && !this.inner.contains(event.target)) this._close();
      });

      document.documentElement.on('keydown' + '.tooltip-esc', (event) => {
        if (event.code === 'Escape') this._close();
      });

      this.el.dataset.toolTipOpen = true;
      this.el.dataset.toolTip = context;
    }

    _close() {
      this.toolTipContent.innerHTML = '';
      this.el.dataset.toolTipOpen = 'false';
      this.el.dataset.toolTip = '';

      this._unlockScrolling();

      this.closeButton.off('click' + '.tooltip-close');
      document.documentElement.off('click' + '.tooltip-outerclick');
      document.documentElement.off('keydown' + '.tooltip-esc');
    }

    _lockScrolling() {
      theme.a11y.trapFocus({
        container: this.el,
        namespace: 'tooltip_focus',
      });

      theme.a11y.lockMobileScrolling();
      document.documentElement.classList.add('modal-open');
    }

    _unlockScrolling() {
      theme.a11y.removeTrapFocus({
        container: this.el,
        namespace: 'tooltip_focus',
      });

      theme.a11y.unlockMobileScrolling();
      document.documentElement.classList.remove('modal-open');
    }
  }

  customElements.define('tool-tip', ToolTip);

  /*============================================================================
    ToolTipTrigger
  ==============================================================================*/

  class ToolTipTrigger extends HTMLElement {
    constructor() {
      super();
      this.el = this;
      this.toolTipContent = this.querySelector('[data-tool-tip-content]');
      this.init();
    }

    init() {
      const toolTipOpen = new CustomEvent('tooltip:open', {
        detail: {
          context: this.dataset.toolTip,
          content: this.toolTipContent.innerHTML,
        },
        bubbles: true,
      });

      this.el.addEventListener('click', (e) => {
        e.stopPropagation();
        this.dispatchEvent(toolTipOpen);
      });
    }
  }

  customElements.define('tool-tip-trigger', ToolTipTrigger);

  /*============================================================================
    NewsletterReminder
  ==============================================================================*/

  class NewsletterReminder extends HTMLElement {
    constructor() {
      super();
      this.closeBtn = this.querySelector('[data-close-button]');
      this.popupTrigger = this.querySelector('[data-message]');

      this.id = this.dataset.sectionId;
      this.newsletterId = `NewsletterPopup-${this.id}`;
      this.cookie = Cookies.get(`newsletter-${this.id}`);
      this.cookieName = `newsletter-${this.id}`;
      this.secondsBeforeShow = this.dataset.delaySeconds;
      this.expiry = parseInt(this.dataset.delayDays);
      this.modal = new theme.Modals(`NewsletterPopup-${this.newsletterId}`, 'newsletter-popup-modal');

      this.init();
    }

    init() {
      document.addEventListener('shopify:block:select', (evt) => {
        if (evt.detail.sectionId === this.id) {
          this.show(0, true);
        }
      });

      document.addEventListener('shopify:block:deselect', (evt) => {
        if (evt.detail.sectionId === this.id) {
          this.hide();
        }
      });

      document.addEventListener(`modalOpen.${this.newsletterId}`, () => this.hide());
      document.addEventListener(`modalClose.${this.newsletterId}`, () => this.show());
      document.addEventListener(`newsletter:openReminder`, () => this.show(0));

      this.closeBtn.addEventListener('click', () => {
        this.hide();
        Cookies.set(this.cookieName, 'opened', {
          path: '/',
          expires: this.expiry,
        });
      });

      this.popupTrigger.addEventListener('click', () => {
        const reminderOpen = new CustomEvent('reminder:openNewsletter', {
          bubbles: true,
        });
        this.dispatchEvent(reminderOpen);

        this.hide();
      });
    }

    show(time = this.secondsBeforeShow, forceOpen = false) {
      const reminderAppeared = sessionStorage.getItem('reminderAppeared') === 'true';

      if (!reminderAppeared) {
        setTimeout(() => {
          this.dataset.enabled = 'true';
          sessionStorage.setItem('reminderAppeared', true);
        }, time * 1000);
      }
    }

    hide() {
      this.dataset.enabled = 'false';
    }
  }

  customElements.define('newsletter-reminder', NewsletterReminder);

  /*============================================================================
    ImageElement
  ==============================================================================*/

  class ImageElement extends HTMLElement {
    constructor() {
      super();

      this.init();
    }

    init() {
      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;

        this.removeAnimations();

        observer.unobserve(this);
      };

      // Set an IntersectionObserver to check if the image is nearly in the viewport
      new IntersectionObserver(handleIntersection.bind(this), {
        rootMargin: '0px 0px 400px 0px',
      }).observe(this);
    }

    removeAnimations() {
      // Find the closest image-wrap and remove the animation (fix for streamline image-wrap shimmer)
      const imageWrap = this.closest('.image-wrap');
      const skrimWrap = this.closest('.skrim__link');

      if (imageWrap) {
        imageWrap.classList.add('loaded');
      }

      if (skrimWrap) {
        skrimWrap.classList.add('loaded');
      }
    }
  }

  customElements.define('image-element', ImageElement);

  /*============================================================================
    PredictiveSearch
  ==============================================================================*/

  class PredictiveSearch extends HTMLElement {
    constructor() {
      super();
      this.enabled = this.getAttribute('data-enabled');
      this.context = this.getAttribute('data-context');
      this.input = this.querySelector('input[type="search"]');
      this.predictiveSearchResults = this.querySelector('#predictive-search');
      this.closeBtn = this.querySelector('.btn--close-search');
      this.screen = this.querySelector('[data-screen]');
      this.SearchModal = this.closest('#SearchModal') || null;

      // Open events
      document.addEventListener('predictive-search:open', (e) => {
        if (e.detail.context !== this.context) return;
        this.classList.add('is-active');

        // Wait for opening events to finish then apply focus
        setTimeout(() => {
          this.input.focus();
        }, 100);

        document.body.classList.add('predictive-overflow-hidden');
      });

      // listen for class change of 'modal--is-active on this.SearchModal
      if (this.SearchModal) {
        const observer = new MutationObserver((mutations) => {
          mutations.forEach((mutation) => {
            if (mutation.attributeName === 'class') {
              const modalClass = mutation.target.className;
              if (modalClass.indexOf('modal--is-active') > -1) {
                setTimeout(() => {
                  this.input.focus();
                }, 100);
              }
            }
          });
        });

        observer.observe(this.SearchModal, {
          attributes: true,
        });
      }

      if (this.enabled === 'false') return;

      // On typing
      this.input.addEventListener('keydown', () => {
        this.classList.add('is-active');
      });

      this.input.addEventListener(
        'input',
        this.debounce((event) => {
          this.onChange(event);
        }, 300).bind(this)
      );

      // Close events
      document.addEventListener('predictive-search:close', () => {
        this.close();
      });
      document.addEventListener('keydown', (event) => {
        if (event.keyCode === 27) this.close();
      });
      this.closeBtn.addEventListener('click', (e) => {
        e.preventDefault();
        this.close();
      });
      this.screen.addEventListener('click', () => {
        this.close();
      });
    }

    onChange() {
      const searchTerm = this.input.value.trim();

      if (!searchTerm.length) return;

      this.getSearchResults(searchTerm);
    }

    getSearchResults(searchTerm) {
      const searchObj = {
        q: searchTerm,
        'resources[limit]': 3,
        'resources[limit_scope]': 'each',
        'resources[options][unavailable_products]': 'last',
      };

      const params = this.paramUrl(searchObj);

      fetch(`${theme.routes.predictiveSearch}?${params}&section_id=search-results`)
        .then((response) => {
          if (!response.ok) {
            const error = new Error(response.status);
            this.close();
            throw error;
          }

          return response.text();
        })
        .then((text) => {
          const resultsMarkup = new DOMParser()
            .parseFromString(text, 'text/html')
            .querySelector('#shopify-section-search-results').innerHTML;
          this.predictiveSearchResults.innerHTML = resultsMarkup;
          this.open();

          AOS.refreshHard();
        })
        .catch((error) => {
          this.close();
          throw error;
        });
    }

    open() {
      this.predictiveSearchResults.style.display = 'block';
    }

    close() {
      this.predictiveSearchResults.style.display = 'none';
      this.predictiveSearchResults.innerHTML = '';
      this.classList.remove('is-active');
      document.body.classList.remove('predictive-overflow-hidden');

      document.dispatchEvent(new CustomEvent('predictive-search:close-all'));
    }

    debounce(fn, wait) {
      let t;
      return (...args) => {
        clearTimeout(t);
        t = setTimeout(() => fn.apply(this, args), wait);
      };
    }

    paramUrl(obj) {
      return Object.keys(obj)
        .map(function (key) {
          return key + '=' + encodeURIComponent(obj[key]);
        })
        .join('&');
    }
  }

  customElements.define('predictive-search', PredictiveSearch);

  class RecipientForm extends HTMLElement {
    constructor() {
      super();
      this.checkboxInput = this.querySelector(`#Recipient-Checkbox-${this.dataset.sectionId}`);
      this.emailInput = this.querySelector(`#Recipient-email-${this.dataset.sectionId}`);
      this.nameInput = this.querySelector(`#Recipient-name-${this.dataset.sectionId}`);
      this.messageInput = this.querySelector(`#Recipient-message-${this.dataset.sectionId}`);
      this.dateInput = this.querySelector(`#Recipient-send-on-${this.dataset.sectionId}`);
      this.addEventListener('change', () => this.onChange());
      this.recipientFields = this.querySelector('.recipient-fields');

      this.checkboxInput.addEventListener('change', () => {
        this.recipientFields.style.display = this.checkboxInput.checked ? 'block' : 'none';
      });
    }

    connectedCallback() {
      document.addEventListener('ajaxProduct:error', (event) => {
        const productVariantID = event.target.querySelector('[name="id"]').value;
        if (productVariantID === this.dataset.productVariantId) {
          this.displayErrorMessage(event.detail.errorMessage);
        }
      });

      document.addEventListener('ajaxProduct:added', (event) => {
        const productVariantID = event.target.querySelector('[name="id"]').value;
        if (productVariantID === this.dataset.productVariantId) {
          this.clearInputFields();
          this.clearErrorMessage();
        }
      });
    }

    onChange() {
      if (!this.checkboxInput.checked) {
        this.clearInputFields();
        this.clearErrorMessage();
      }
    }

    clearInputFields() {
      this.querySelectorAll('.field__input').forEach((el) => (el.value = ''));
    }

    displayErrorMessage(body) {
      this.clearErrorMessage();
      if (body) {
        return Object.entries(body).forEach(([key, value]) => {
          const inputElement = this[`${key}Input`];
          if (!inputElement) return;

          inputElement.setAttribute('aria-invalid', true);
          inputElement.classList.add('field__input--error');
        });
      }
    }

    clearErrorMessage() {
      this.querySelectorAll('.field__input').forEach((inputElement) => {
        inputElement.setAttribute('aria-invalid', false);
        inputElement.removeAttribute('aria-describedby');
        inputElement.classList.remove('field__input--error');
      });
    }
  }

  customElements.define('recipient-form', RecipientForm);

  theme.announcementBar = (function () {
    var args = {
      autoPlay: 5000,
      avoidReflow: true,
      cellAlign: theme.config.rtl ? 'right' : 'left',
    };
    var bar;
    var flickity;

    function init() {
      bar = document.getElementById('AnnouncementSlider');
      if (!bar) {
        return;
      }

      unload();

      if (bar.dataset.blockCount === 1) {
        return;
      }

      if (theme.config.bpSmall || bar.dataset.compact === 'true') {
        initSlider();
      }

      document.addEventListener('matchSmall', function () {
        unload();
        initSlider();
      });

      document.addEventListener('unmatchSmall', function () {
        unload();
        if (bar.dataset.compact === 'true') {
          initSlider();
        }
      });
    }

    function initSlider() {
      flickity = new theme.Slideshow(bar, args);
    }

    // Go to slide if selected in the editor
    function onBlockSelect(id) {
      var slide = bar.querySelector('#AnnouncementSlide-' + id);
      var index = parseInt(slide.dataset.index);

      if (flickity && typeof flickity.pause === 'function') {
        flickity.goToSlide(index);
        flickity.pause();
      }
    }

    function onBlockDeselect() {
      if (flickity && typeof flickity.play === 'function') {
        flickity.play();
      }
    }

    function unload() {
      if (flickity && typeof flickity.destroy === 'function') {
        flickity.destroy();
      }
    }

    return {
      init: init,
      onBlockSelect: onBlockSelect,
      onBlockDeselect: onBlockDeselect,
      unload: unload,
    };
  })();

  theme.customerTemplates = function () {
    checkUrlHash();
    initEventListeners();
    resetPasswordSuccess();
    customerAddressForm();

    function checkUrlHash() {
      var hash = window.location.hash;

      // Allow deep linking to recover password form
      if (hash === '#recover') {
        toggleRecoverPasswordForm();
      }
    }

    function toggleRecoverPasswordForm() {
      var passwordForm = document.getElementById('RecoverPasswordForm').classList.toggle('hide');
      var loginForm = document.getElementById('CustomerLoginForm').classList.toggle('hide');
    }

    function initEventListeners() {
      // Show reset password form
      var recoverForm = document.getElementById('RecoverPassword');
      if (recoverForm) {
        recoverForm.addEventListener('click', function (evt) {
          evt.preventDefault();
          toggleRecoverPasswordForm();
        });
      }

      // Hide reset password form
      var hideRecoverPassword = document.getElementById('HideRecoverPasswordLink');
      if (hideRecoverPassword) {
        hideRecoverPassword.addEventListener('click', function (evt) {
          evt.preventDefault();
          toggleRecoverPasswordForm();
        });
      }
    }

    function resetPasswordSuccess() {
      var formState = document.querySelector('.reset-password-success');

      // check if reset password form was successfully submitted
      if (!formState) {
        return;
      }

      // show success message
      document.getElementById('ResetSuccess').classList.remove('hide');
    }

    function customerAddressForm() {
      var newAddressForm = document.getElementById('AddressNewForm');
      var addressForms = document.querySelectorAll('.js-address-form');

      if (!newAddressForm || !addressForms.length) {
        return;
      }

      // Country/province selector can take a short time to load
      setTimeout(function () {
        document.querySelectorAll('.js-address-country').forEach((el) => {
          var countryId = el.dataset.countryId;
          var provinceId = el.dataset.provinceId;
          var provinceContainerId = el.dataset.provinceContainerId;

          new Shopify.CountryProvinceSelector(countryId, provinceId, {
            hideElement: provinceContainerId,
          });
        });
      }, 1000);

      // Toggle new/edit address forms
      document.querySelectorAll('.address-new-toggle').forEach((el) => {
        el.addEventListener('click', function () {
          newAddressForm.classList.toggle('hide');
        });
      });

      document.querySelectorAll('.address-edit-toggle').forEach((el) => {
        el.addEventListener('click', function (evt) {
          var formId = evt.currentTarget.dataset.formId;
          document.getElementById('EditAddress_' + formId).classList.toggle('hide');
        });
      });

      document.querySelectorAll('.address-delete').forEach((el) => {
        el.addEventListener('click', function (evt) {
          var formId = evt.currentTarget.dataset.formId;
          var confirmMessage = evt.currentTarget.dataset.confirmMessage;

          if (confirm(confirmMessage || 'Are you sure you wish to delete this address?')) {
            if (Shopify) {
              Shopify.postLink('/account/addresses/' + formId, {
                parameters: { _method: 'delete' },
              });
            }
          }
        });
      });
    }
  };

  theme.CartDrawer = (function () {
    var selectors = {
      drawer: '#CartDrawer',
      form: '#CartDrawerForm',
    };

    function CartDrawer() {
      this.form = document.querySelector(selectors.form);
      this.drawer = new theme.Drawers('CartDrawer', 'cart');

      this.init();
    }

    CartDrawer.prototype = Object.assign({}, CartDrawer.prototype, {
      init: function () {
        this.cartForm = new theme.CartForm(this.form);
        this.cartForm.buildCart();

        document.addEventListener(
          'ajaxProduct:added',
          function (evt) {
            this.cartForm.buildCart();
            this.open();
          }.bind(this)
        );

        // Dev-friendly way to open cart
        document.addEventListener('cart:open', this.open.bind(this));
        document.addEventListener('cart:close', this.close.bind(this));
      },

      open: function () {
        this.drawer.open();

        theme.a11y.trapFocus({
          container: this.form,
          elementToFocus: this.form,
          namespace: 'cartdrawer_focus',
        });
      },

      close: function () {
        this.drawer.close();

        theme.a11y.removeTrapFocus({
          container: this.form,
          namespace: 'cartdrawer_focus',
        });
      },
    });

    return CartDrawer;
  })();

  theme.headerNav = (function () {
    var selectors = {
      wrapper: '#HeaderWrapper',
      siteHeader: '#SiteHeader',
      searchBtn: '.js-search-header',
      closeSearch: '#SearchClose',
      searchContainer: '.site-header__search-container',
      logo: '#LogoContainer img',
      megamenu: '.megamenu',
      navItems: '.site-nav__item',
      navLinks: '.site-nav__link',
      navLinksWithDropdown: '.site-nav__link--has-dropdown',
      navDropdownLinks: '.site-nav__dropdown-link--second-level',
      navDetails: '.site-nav__details',
    };

    var classes = {
      hasDropdownClass: 'site-nav--has-dropdown',
      hasSubDropdownClass: 'site-nav__deep-dropdown-trigger',
      dropdownActive: 'is-focused',
    };

    var config = {
      namespace: '.siteNav',
      wrapperOverlayed: false,
      overlayedClass: 'is-light',
      overlayEnabledClass: 'header-wrapper--sticky',
      stickyEnabled: false,
      stickyActive: false,
      stickyClass: 'site-header--stuck',
      stickyHeaderWrapper: 'StickyHeaderWrap',
      openTransitionClass: 'site-header--opening',
      lastScroll: 0,
    };

    // Elements used in resize functions, defined in init
    var wrapper;
    var siteHeader;

    function init() {
      wrapper = document.querySelector(selectors.wrapper);
      siteHeader = document.querySelector(selectors.siteHeader);

      config.stickyEnabled = siteHeader.dataset.sticky === 'true';
      if (config.stickyEnabled) {
        config.wrapperOverlayed = wrapper.classList.contains(config.overlayedClass);
        stickyHeaderCheck();
      }

      theme.settings.overlayHeader = siteHeader.dataset.overlay === 'true';
      // Disable overlay header if on collection template with no collection image
      if (theme.settings.overlayHeader && Shopify && Shopify.designMode) {
        if (document.body.classList.contains('template-collection') && !document.querySelector('.collection-hero')) {
          this.disableOverlayHeader();
        }
      }

      menuDetailsHandler();
      searchDrawer();
    }

    function menuDetailsHandler() {
      const navDetails = document.querySelectorAll(selectors.navDetails);

      navDetails.forEach((navDetail) => {
        const summary = navDetail.querySelector('summary');

        // if the navDetail is open, then close it when the user clicks outside of it
        document.addEventListener('click', (evt) => {
          if (navDetail.hasAttribute('open') && !navDetail.contains(evt.target)) {
            navDetail.removeAttribute('open');
            summary.setAttribute('aria-expanded', 'false');
          } else {
            if (navDetail.hasAttribute('open')) {
              summary.setAttribute('aria-expanded', 'false');
            } else {
              summary.setAttribute('aria-expanded', 'true');
            }
          }
        });
      });
    }

    // If the header setting to overlay the menu on the collection image
    // is enabled but the collection setting is disabled, we need to undo
    // the init of the sticky nav
    function disableOverlayHeader() {
      wrapper.classList.remove(config.overlayEnabledClass, config.overlayedClass);
      config.wrapperOverlayed = false;
      theme.settings.overlayHeader = false;
    }

    function stickyHeaderCheck() {
      // Disable sticky header if any mega menu is taller than window
      theme.config.stickyHeader = doesMegaMenuFit();

      if (theme.config.stickyHeader) {
        config.forceStopSticky = false;
        stickyHeader();
      } else {
        config.forceStopSticky = true;
      }
    }

    function doesMegaMenuFit() {
      var largestMegaNav = 0;
      siteHeader.querySelectorAll(selectors.megamenu).forEach((nav) => {
        var h = nav.offsetHeight;
        if (h > largestMegaNav) {
          largestMegaNav = h;
        }
      });

      // 120 ~ space of visible header when megamenu open
      if (window.innerHeight < largestMegaNav + 120) {
        return false;
      }

      return true;
    }

    function stickyHeader() {
      config.lastScroll = 0;

      var wrapWith = document.createElement('div');
      wrapWith.id = config.stickyHeaderWrapper;
      theme.utils.wrap(siteHeader, wrapWith);

      stickyHeaderInitialPosition(siteHeader);
      stickyHeaderHeight();

      window.on('resize' + config.namespace, theme.utils.debounce(50, stickyHeaderHeight));
      window.on('scroll' + config.namespace, theme.utils.throttle(20, stickyHeaderScroll));

      // This gets messed up in the editor, so here's a fix
      if (Shopify && Shopify.designMode) {
        setTimeout(function () {
          stickyHeaderHeight();
        }, 250);
      }
    }

    function stickyHeaderInitialPosition(header) {
      const headerParent = header.closest('.shopify-section-group-header-group');
      const parentNextSibling = headerParent.nextElementSibling;

      // if parentNextSibling has same class as headerParent, then header is above announcement bar
      if (parentNextSibling && parentNextSibling.classList.contains('shopify-section-group-header-group')) {
        // get height of announcement bar and set header wrapper top to that value
        const nextSiblingHeight = parentNextSibling.offsetHeight;
        document.querySelector(selectors.wrapper).style.top = nextSiblingHeight + 'px';
      }
    }

    function stickyHeaderHeight() {
      if (!config.stickyEnabled) {
        return;
      }

      var h = siteHeader.offsetHeight;

      // If sticky header is 'active' i.e. we have scrolled a bit down the page
      // the site header has 20px less padding when sticky
      // and this is not factored into the height calculation
      // The 20px is what causes the header to overlap the announcement bar
      // This only applies when the height is being calculated on larger screen sizes
      if (siteHeader.classList.contains('site-header--stuck') && !theme.config.bpSmall) {
        let siteHeaderPadding = parseFloat(window.getComputedStyle(siteHeader, null).getPropertyValue('padding-top'));
        h += siteHeaderPadding * 2;
      }

      var stickyHeader = document.querySelector('#' + config.stickyHeaderWrapper);
      stickyHeader.style.height = h + 'px';
    }

    function stickyHeaderScroll() {
      if (!config.stickyEnabled) {
        return;
      }

      if (config.forceStopSticky) {
        return;
      }

      requestAnimationFrame(scrollHandler);

      config.lastScroll = window.scrollY;
    }

    function scrollHandler() {
      if (window.scrollY > 250) {
        if (config.stickyActive) {
          return;
        }

        config.stickyActive = true;

        siteHeader.classList.add(config.stickyClass);
        if (config.wrapperOverlayed) {
          wrapper.classList.remove(config.overlayedClass);
        }

        // Add open transition class after element is set to fixed
        // so CSS animation is applied correctly
        setTimeout(function () {
          siteHeader.classList.add(config.openTransitionClass);
        }, 100);
      } else {
        if (!config.stickyActive) {
          return;
        }

        config.stickyActive = false;

        siteHeader.classList.remove(config.openTransitionClass);
        siteHeader.classList.remove(config.stickyClass);
        if (config.wrapperOverlayed) {
          wrapper.classList.add(config.overlayedClass);
        }
      }
    }

    function searchDrawer() {
      document.querySelectorAll(selectors.searchBtn).forEach((btn) => {
        btn.addEventListener('click', function (evt) {
          evt.preventDefault();
          evt.stopPropagation();
          document.dispatchEvent(
            new CustomEvent('predictive-search:open', {
              detail: {
                context: 'header',
              },
              bubbles: true,
            })
          );

          // add is-active class to .site-header__search-container
          document.querySelector(selectors.searchContainer).classList.add('is-active');
        });
      });

      document.addEventListener('predictive-search:close-all', function () {
        closeSearchDrawer();
      });
    }

    function closeSearchDrawer(evt) {
      // Do not close if click event came from inside drawer
      if (evt) {
        // evt.path is non-standard, so have fallback
        var path = evt.path || (evt.composedPath && evt.composedPath());
        for (var i = 0; i < path.length; i++) {
          if (path[i].classList) {
            if (path[i].classList.contains('site-header__search-btn')) {
              break;
            }

            if (path[i].classList.contains('site-header__search-container')) {
              return;
            }
          }
        }
      }

      // deselect any focused form elements
      document.activeElement.blur();

      document.documentElement.classList.add('js-drawer-closing');
      document.documentElement.classList.remove('js-drawer-open', 'js-drawer-open--search');

      window.setTimeout(
        function () {
          document.documentElement.classList.remove('js-drawer-closing');
        }.bind(this),
        500
      );

      var container = document.querySelector(selectors.searchContainer);
      theme.utils.prepareTransition(
        container,
        function () {
          container.classList.remove('is-active');
        }.bind(this)
      );
    }

    return {
      init: init,
      disableOverlayHeader: disableOverlayHeader,
    };
  })();

  window.onpageshow = function (evt) {
    // Removes unload class when returning to page via history
    if (evt.persisted) {
      document.body.classList.remove('unloading');
      document.querySelectorAll('.cart__checkout').forEach((el) => {
        el.classList.remove('btn--loading');
      });
    }
  };

  theme.buildProductGridItem = function (items, gridWidth, rowOf, imageSizes) {
    var output = '';

    items.forEach((product) => {
      var image = theme.buildProductImage(product, imageSizes);

      let priceMarkup = '';
      let vendorMarkup = '';

      if (theme.settings.predictiveSearchPrice)
        priceMarkup = `<div class="grid-product__price">${theme.strings.productFrom}${theme.Currency.formatMoney(
          product.price_min,
          theme.moneyFormat
        )}</div>`;
      if (theme.settings.predictiveSearchVendor)
        vendorMarkup = `<div class="grid-product__vendor">${product.vendor}</div>`;

      var markup = `
        <div class="grid__item grid-product ${gridWidth} aos-animate" data-aos="row-of-${rowOf}">
          <div class="grid-product__content">
            <a href="${product.url}" class="grid-product__link">
              <div class="grid-product__image-mask">
                ${image}
              </div>
              <div class="grid-product__meta">
                <div class="grid-product__title">${product.title}</div>
                ${priceMarkup}
                ${vendorMarkup}
              </div>
            </a>
          </div>
        </div>
      `;

      output += markup;
    });

    return output;
  };

  theme.buildProductImage = function (product, imageSizes) {
    var size = theme.settings.productImageSize;
    var output = '';

    if (size === 'natural') {
      const template = document.getElementById('naturalImageMarkup');
      const clonedMarkup = template.content.cloneNode(true);
      const imageEl = clonedMarkup.querySelector('img');
      const imageWrapperEl = clonedMarkup.querySelector('.image-wrap');

      imageWrapperEl.style.paddingBottom = `${product.image_aspect_ratio}%`;

      addImageProperties(imageEl, imageSizes);

      const imageDiv = document.createElement('div');
      imageDiv.appendChild(clonedMarkup);

      output = imageDiv.innerHTML;
    } else {
      const template = document.getElementById('fixedRatioImageMarkup');
      const clonedMarkup = template.content.cloneNode(true);
      const imageEl = clonedMarkup.querySelector('img');
      const imageWrapperEl = clonedMarkup.querySelector('.grid__image-ratio');

      imageWrapperEl.classList.add(`grid__image-ratio--${size}`);

      if (!theme.settings.productImageCover) {
        imageEl.classList.add('grid__image-contain');
      }

      addImageProperties(imageEl, imageSizes);

      const imageDiv = document.createElement('div');
      imageDiv.appendChild(clonedMarkup);

      output = imageDiv.innerHTML;
    }

    function addImageProperties(imageEl, imageSizes) {
      imageEl.src = product.image_responsive_url;
      imageEl.srcset = product.image_responsive_urls.toString();
      imageEl.alt = product.title;
      imageEl.sizes = imageSizes;
    }

    return output;
  };

  /*============================================================================
    年龄验证弹窗组件
  ==============================================================================*/

  class AgeVerificationPopup extends HTMLElement {
    constructor() {
      super();

      // Cookie相关配置
      this.cookieName = this.id; // Cookie名称（使用元素ID）
      this.cookie = Cookies.get(this.cookieName); // 获取已存在的Cookie

      // CSS类名定义，用于控制不同状态的显示
      this.classes = {
        activeContent: 'age-verification-popup__content--active', // 主内容激活状态
        inactiveContent: 'age-verification-popup__content--inactive', // 主内容非激活状态
        // 拒绝内容非激活状态
        inactiveDeclineContent: 'age-verification-popup__decline-content--inactive',
        activeDeclineContent: 'age-verification-popup__decline-content--active', // 拒绝内容激活状态
      };

      // 获取各个功能按钮和内容区域元素
      this.declineButton = this.querySelector(
        '[data-age-verification-popup-decline-button]' // 拒绝按钮
      );
      this.declineContent = this.querySelector(
        '[data-age-verification-popup-decline-content]' // 拒绝后显示的内容
      );
      this.content = this.querySelector(
        '[data-age-verification-popup-content]' // 主要内容区域
      );
      this.returnButton = this.querySelector(
        '[data-age-verification-popup-return-button]' // 返回按钮
      );
      this.exitButton = this.querySelector(
        '[data-age-verification-popup-exit-button]' // 退出按钮
      );
      this.backgroundImage = this.querySelector('[data-background-image]'); // 背景图片
      this.mobileBackgroundImage = this.querySelector(
        '[data-mobile-background-image]' // 移动端背景图片
      );

      // Shopify主题编辑器模式下的事件监听
      if (Shopify.designMode) {
        // 区域选择事件
        document.addEventListener('shopify:section:select', (event) => {
          if (event.detail.sectionId === this.dataset.sectionId) {
            this.init();
          }
        });

        // 区域加载事件
        document.addEventListener('shopify:section:load', (event) => {
          if (event.detail.sectionId === this.dataset.sectionId) {
            this.init();

            // 如果启用了"测试模式"，移除已设置的Cookie
            if (this.dataset.testMode === 'true' && this.cookie) {
              Cookies.remove(this.cookieName);
            }

            // 检查用户是否在编辑第二个视图
            const secondViewVisited = sessionStorage.getItem(this.id);

            if (!secondViewVisited) return;

            this.showDeclineContent(); // 显示拒绝内容
          }
        });

        // 区域卸载事件
        document.addEventListener('shopify:section:unload', (event) => {
          if (event.detail.sectionId === this.dataset.sectionId) {
            this.modal.close(); // 关闭模态框
          }
        });
      }

      // 年龄验证弹窗只有在测试模式禁用且Cookie存在或编辑器中可见性切换时才隐藏
      if (this.cookie && this.dataset.testMode === 'false') return;

      this.init(); // 初始化弹窗
    }

    // ===== 初始化方法 =====
    init() {
      // 创建模态框实例，禁用点击内容外部关闭功能
      this.modal = new theme.Modals(this.id, 'age-verification-popup-modal', {
        closeOffContentClick: false,
      });

      // 显示桌面端背景图片
      if (this.backgroundImage) {
        this.backgroundImage.style.display = 'block';
      }

      // 在小屏幕设备上显示移动端背景图片
      if (theme.config.bpSmall && this.mobileBackgroundImage) {
        this.mobileBackgroundImage.style.display = 'block';
      }

      this.modal.open(); // 打开模态框

      // 锁定移动端滚动，提升用户体验
      theme.a11y.lockMobileScrolling(`#${this.id}`, document.querySelector('#MainContent'));

      // 拒绝按钮事件处理
      if (this.declineButton) {
        this.declineButton.addEventListener('click', (e) => {
          e.preventDefault();
          this.showDeclineContent(); // 显示拒绝内容

          // 在编辑器中，保存到会话存储以指示用户已进入第二个视图
          // 允许在编辑器中进行更改时保持视图状态
          if (Shopify.designMode) {
            sessionStorage.setItem(this.id, 'second-view');
          }
        });
      }

      // 返回按钮事件处理
      if (this.returnButton) {
        this.returnButton.addEventListener('click', (e) => {
          e.preventDefault();
          this.hideDeclineContent(); // 隐藏拒绝内容

          // 从会话存储中删除数据，确保第二个视图不会持续存在
          const secondViewVisited = sessionStorage.getItem(this.id);

          if (Shopify.designMode && secondViewVisited) {
            sessionStorage.removeItem(this.id);
          }
        });
      }

      // 退出按钮事件处理
      if (this.exitButton) {
        this.exitButton.addEventListener('click', (e) => {
          e.preventDefault();

          // 非测试模式下设置Cookie记录用户已通过验证
          if (this.dataset.testMode === 'false') {
            Cookies.set(this.cookieName, 'entered', {
              expires: 30, // 30天有效期
              sameSite: 'none', // 跨站点Cookie设置
              secure: true, // 需要HTTPS
            });
          }

          // 隐藏背景图片
          if (this.backgroundImage) {
            this.backgroundImage.style.display = 'none';
          }

          if (theme.config.bpSmall && this.mobileBackgroundImage) {
            this.mobileBackgroundImage.style.display = 'none';
          }

          this.modal.close(); // 关闭模态框

          // 解锁移动端滚动
          theme.a11y.unlockMobileScrolling(`#${this.id}`, document.querySelector('#MainContent'));
        });
      }
    }

    // ===== 显示拒绝内容 =====
    showDeclineContent() {
      // 激活拒绝内容显示
      this.declineContent.classList.remove(this.classes.inactiveDeclineContent);
      this.declineContent.classList.add(this.classes.activeDeclineContent);

      // 隐藏主要内容
      this.content.classList.add(this.classes.inactiveContent);
      this.content.classList.remove(this.classes.activeContent);
    }

    // ===== 隐藏拒绝内容 =====
    hideDeclineContent() {
      // 隐藏拒绝内容
      this.declineContent.classList.add(this.classes.inactiveDeclineContent);
      this.declineContent.classList.remove(this.classes.activeDeclineContent);

      // 显示主要内容
      this.content.classList.remove(this.classes.inactiveContent);
      this.content.classList.add(this.classes.activeContent);
    }
  }

  // 注册自定义元素
  customElements.define('age-verification-popup', AgeVerificationPopup);

  // ===== 地图功能模块 =====
  theme.Maps = (function () {
    // 地图配置
    var config = {
      zoom: 14, // 默认缩放级别
    };

    var apiStatus = null; // API加载状态
    var mapsToLoad = []; // 待加载的地图实例队列

    var errors = {}; // 错误信息对象

    // DOM选择器
    var selectors = {
      section: '[data-section-type="map"]', // 地图区域
      map: '[data-map]', // 地图容器
      mapOverlay: '.map-section__overlay', // 地图覆盖层
    };

    // Google地图认证失败时的全局回调函数
    // 在所有地图实例上显示自动错误消息
    window.gm_authFailure = function () {
      if (!Shopify.designMode) {
        return;
      }

      // 为所有地图区域添加错误状态类
      document.querySelectorAll(selectors.section).forEach((section) => {
        section.classList.add('map-section--load-error');
      });

      // 移除所有地图元素
      document.querySelectorAll(selectors.map).forEach((map) => {
        map.parentNode.removeChild(map);
      });

      window.mapError(theme.strings.authError); // 显示认证错误
    };

    // 地图错误显示函数
    window.mapError = function (error) {
      var message = document.createElement('div');
      message.classList.add('map-section__error', 'errors', 'text-center');
      message.innerHTML = error;

      // 在每个地图覆盖层前添加错误消息
      document.querySelectorAll(selectors.mapOverlay).forEach((overlay) => {
        overlay.parentNode.prepend(message);
      });

      // 隐藏地图链接
      document.querySelectorAll('.map-section__link').forEach((link) => {
        link.classList.add('hide');
      });
    };

    // ===== 地图构造函数 =====
    function Map(container) {
      this.container = container;
      this.sectionId = this.container.getAttribute('data-section-id');
      this.namespace = '.map-' + this.sectionId;
      this.map = container.querySelector(selectors.map);
      this.key = this.map.dataset.apiKey; // Google Maps API密钥

      // 错误消息本地化
      errors = {
        addressNoResults: theme.strings.addressNoResults, // 地址无结果
        addressQueryLimit: theme.strings.addressQueryLimit, // 查询限制
        addressError: theme.strings.addressError, // 地址错误
        authError: theme.strings.authError, // 认证错误
      };

      if (!this.key) {
        return; // 没有API密钥则退出
      }

      // 当元素可见时初始化地图API
      theme.initWhenVisible({
        element: this.container,
        callback: this.prepMapApi.bind(this),
        threshold: 20,
      });
    }

    // ===== API加载完成后，加载队列中的所有地图实例 =====
    function initAllMaps() {
      mapsToLoad.forEach((instance) => {
        instance.createMap();
      });
    }

    // ===== 地理编码功能 =====
    function geolocate(map) {
      var geocoder = new google.maps.Geocoder();

      if (!map) {
        return;
      }

      var address = map.dataset.addressSetting; // 获取地址设置

      // 返回Promise以处理异步地理编码
      var deferred = new Promise((resolve, reject) => {
        geocoder.geocode({ address: address }, function (results, status) {
          if (status !== google.maps.GeocoderStatus.OK) {
            reject(status);
          }
          resolve(results);
        });
      });

      return deferred;
    }

    // ===== 地图原型方法 =====
    Map.prototype = Object.assign({}, Map.prototype, {
      // ===== 准备地图API =====
      prepMapApi: function () {
        if (apiStatus === 'loaded') {
          this.createMap(); // API已加载，直接创建地图
        } else {
          mapsToLoad.push(this); // 添加到待加载队列

          if (apiStatus !== 'loading') {
            apiStatus = 'loading';
            // 检查Google Maps API是否已加载
            if (typeof window.google === 'undefined' || typeof window.google.maps === 'undefined') {
              // 动态加载Google Maps API脚本
              var script = document.createElement('script');
              script.onload = function () {
                apiStatus = 'loaded';
                initAllMaps(); // 初始化所有待加载的地图
              };
              script.src = 'https://maps.googleapis.com/maps/api/js?key=' + this.key;
              document.head.appendChild(script);
            }
          }
        }
      },

      // ===== 创建地图 =====
      createMap: function () {
        var mapDiv = this.map;

        return geolocate(mapDiv)
          .then(
            function (results) {
              // 地图配置选项
              var mapOptions = {
                zoom: config.zoom, // 缩放级别
                backgroundColor: 'none', // 背景颜色
                center: results[0].geometry.location, // 中心位置
                draggable: false, // 禁用拖拽
                clickableIcons: false, // 禁用可点击图标
                scrollwheel: false, // 禁用滚轮缩放
                disableDoubleClickZoom: true, // 禁用双击缩放
                disableDefaultUI: true, // 禁用默认UI控件
              };

              // 创建地图实例
              var map = (this.map = new google.maps.Map(mapDiv, mapOptions));
              var center = (this.center = map.getCenter());

              // 添加地图标记
              var marker = new google.maps.Marker({
                map: map,
                position: map.getCenter(),
              });

              // 窗口大小改变时重新调整地图
              google.maps.event.addDomListener(
                window,
                'resize',
                theme.utils.debounce(250, function () {
                  google.maps.event.trigger(map, 'resize');
                  map.setCenter(center);
                  mapDiv.removeAttribute('style');
                })
              );

              // 在设计模式下刷新AOS动画
              if (Shopify.designMode) {
                if (window.AOS) {
                  AOS.refreshHard();
                }
              }
            }.bind(this)
          )
          .catch(function (status) {
            var errorMessage;

            // 根据错误状态设置相应的错误消息
            switch (status) {
              case 'ZERO_RESULTS':
                errorMessage = errors.addressNoResults;
                break;
              case 'OVER_QUERY_LIMIT':
                errorMessage = errors.addressQueryLimit;
                break;
              case 'REQUEST_DENIED':
                errorMessage = errors.authError;
                break;
              default:
                errorMessage = errors.addressError;
                break;
            }

            // 仅在编辑器中向商户显示错误
            if (Shopify.designMode) {
              window.mapError(errorMessage);
            }
          });
      },

      // ===== 卸载清理 =====
      onUnload: function () {
        if (this.map.length === 0) {
          return;
        }
        // 当重新加载没有活跃地图的区域时，会产生无害的JS错误
        if (google && google.maps && google.maps.event) {
          google.maps.event.clearListeners(this.map, 'resize');
        }
      },
    });

    return Map;
  })();

  // ===== 邮件订阅弹窗模块 =====
  theme.NewsletterPopup = (function () {
    // ===== 邮件订阅弹窗构造函数 =====
    function NewsletterPopup(container) {
      this.container = container;
      var sectionId = this.container.getAttribute('data-section-id');

      // Cookie配置
      this.cookieName = 'newsletter-' + sectionId; // Cookie名称
      this.cookie = Cookies.get(this.cookieName); // 获取现有Cookie

      if (!container) {
        return;
      }

      // 在Shopify机器人挑战页面阻止弹窗
      if (window.location.pathname === '/challenge') {
        return;
      }

      // 在密码页面阻止弹窗
      if (window.location.pathname === '/password') {
        return;
      }

      // 从数据属性获取配置信息
      this.data = {
        secondsBeforeShow: container.dataset.delaySeconds, // 显示前延迟秒数
        daysBeforeReappear: container.dataset.delayDays, // 重新出现前的天数
        hasReminder: container.dataset.hasReminder, // 是否有提醒功能
        testMode: container.dataset.testMode, // 测试模式
      };

      // 创建模态框实例
      this.modal = new theme.Modals('NewsletterPopup-' + sectionId, 'newsletter-popup-modal');

      // 为可选按钮设置Cookie点击事件
      var btn = container.querySelector('.popup-cta a');
      if (btn) {
        btn.addEventListener(
          'click',
          function () {
            this.closePopup(true); // 成功关闭弹窗
          }.bind(this)
        );
      }

      // 如果存在错误或成功消息，打开模态框
      if (container.querySelector('.errors') || container.querySelector('.note--success')) {
        this.modal.open();
      }

      // 如果有成功消息，设置Cookie并返回
      if (container.querySelector('.note--success')) {
        this.closePopup(true);
        return;
      }

      // 监听模态框关闭事件
      document.addEventListener('modalClose.' + container.id, this.closePopup.bind(this));

      // 如果没有Cookie，初始化弹窗延迟
      if (!this.cookie) {
        this.initPopupDelay();
      }

      // 监听邮件提醒触发事件
      document.addEventListener('reminder:openNewsletter', () => {
        this.modal.open();
      });
    }

    // ===== 邮件订阅弹窗原型方法 =====
    NewsletterPopup.prototype = Object.assign({}, NewsletterPopup.prototype, {
      // ===== 初始化弹窗延迟 =====
      initPopupDelay: function () {
        // 测试模式下不显示弹窗
        if (this.data.testMode === 'true') {
          return;
        }

        setTimeout(
          function () {
            // 检查邮件弹窗是否已经出现过
            const newsletterAppeared = sessionStorage.getItem('newsletterAppeared') === 'true';
            if (newsletterAppeared) {
              // 如果已出现过，触发提醒事件
              const openReminder = new CustomEvent('newsletter:openReminder', {
                bubbles: true,
              });
              this.container.dispatchEvent(openReminder);
            } else {
              // 首次显示弹窗
              this.modal.open();
              sessionStorage.setItem('newsletterAppeared', true);
            }
          }.bind(this),
          this.data.secondsBeforeShow * 1000 // 延迟时间（毫秒）
        );
      },

      // ===== 关闭弹窗 =====
      closePopup: function (success) {
        // 测试模式下移除Cookie
        if (this.data.testMode === 'true') {
          Cookies.remove(this.cookieName, { path: '/' });
          return;
        }

        // 根据成功状态设置Cookie过期时间
        var expiry = success ? 200 : this.data.daysBeforeReappear;
        var hasReminder = this.data.hasReminder === 'true';
        var reminderAppeared = sessionStorage.getItem('reminderAppeared') === 'true';

        // 根据提醒功能状态设置Cookie
        if (hasReminder && reminderAppeared) {
          Cookies.set(this.cookieName, 'opened', {
            path: '/',
            expires: expiry,
          });
        } else if (!hasReminder) {
          Cookies.set(this.cookieName, 'opened', {
            path: '/',
            expires: expiry,
          });
        }
      },

      // ===== 主题编辑器事件处理方法 =====
      onLoad: function () {
        this.modal.open();
      },

      onSelect: function () {
        this.modal.open();
      },

      onDeselect: function () {
        this.modal.close();
      },

      onBlockSelect: function () {
        this.modal.close();
      },

      onBlockDeselect: function () {
        this.modal.open();
      },

      onUnload: function () {
        this.modal.close();
      },
    });

    return NewsletterPopup;
  })();

  // ===== 密码页头模块 =====
  theme.PasswordHeader = (function () {
    // ===== 密码页头构造函数 =====
    function PasswordHeader() {
      this.init();
    }

    // ===== 密码页头原型方法 =====
    PasswordHeader.prototype = Object.assign({}, PasswordHeader.prototype, {
      // ===== 初始化方法 =====
      init: function () {
        // 检查登录模态框是否存在
        if (!document.querySelector('#LoginModal')) {
          return;
        }

        // 创建密码登录模态框
        var passwordModal = new theme.Modals('LoginModal', 'login-modal', {
          focusIdOnOpen: 'password', // 打开时聚焦到密码输入框
          solid: true, // 实心背景
        });

        // 如果存在错误，打开模态框
        if (document.querySelectorAll('.errors').length) {
          passwordModal.open();
        }
      },
    });

    return PasswordHeader;
  })();

  // ===== 图片查看器模块 =====
  theme.Photoswipe = (function () {
    // DOM选择器
    var selectors = {
      trigger: '.js-photoswipe__zoom', // 缩放触发器
      images: '.photoswipe__image', // 图片元素
      slideshowTrack: '.flickity-viewport ', // 轮播视口
      activeImage: '.is-selected', // 活跃图片
    };

    // ===== 图片查看器构造函数 =====
    function Photoswipe(container, sectionId) {
      this.container = container;
      this.sectionId = sectionId;
      this.namespace = '.photoswipe-' + this.sectionId;
      this.gallery; // PhotoSwipe画廊实例
      this.images; // 图片元素集合
      this.items; // 图片数据项

      // 如果容器不存在或禁用缩放功能，退出
      if (!container || container.dataset.zoom === 'false') {
        return;
      }

      this.init();
    }

    // ===== 图片查看器原型方法 =====
    Photoswipe.prototype = Object.assign({}, Photoswipe.prototype, {
      // ===== 初始化方法 =====
      init: function () {
        // 为所有缩放触发器绑定点击事件
        this.container.querySelectorAll(selectors.trigger).forEach((trigger) => {
          trigger.off('click' + this.namespace);
          trigger.on('click' + this.namespace, this.triggerClick.bind(this));
        });
      },

      // ===== 触发器点击处理 =====
      triggerClick: function (evt) {
        this.items = this.getImageData(); // 获取图片数据
        this.initGallery(this.items, evt.currentTarget.dataset.index); // 初始化画廊
      },

      // ===== 获取子元素索引（因为图片集功能，需要基于父元素中的位置获取索引） =====
      getChildIndex: function (el) {
        var i = 0;
        while ((el = el.previousSibling) != null) {
          i++;
        }

        // 需要基于1的索引
        return i + 1;
      },

      // ===== 计算初始缩放级别 =====
      calculateInitialZoomLevel: function (el) {
        // 获取产品详情页图片的显示大小
        var displayWidth = el.clientWidth;
        var displayHeight = el.clientHeight;

        // 获取图片的原始大小
        var originalWidth = parseInt(el.getAttribute('data-photoswipe-width'), 10);
        var originalHeight = parseInt(el.getAttribute('data-photoswipe-height'), 10);

        // 计算缩放比例（以较小的比例为准，保持图片比例）
        var scaleX = displayWidth / originalWidth;
        var scaleY = displayHeight / originalHeight;
        var scale = Math.min(scaleX, scaleY);

        // 返回缩放级别，确保不小于0.1
        return Math.max(scale, 0.1);
      },

      // ===== 获取图片数据 =====
      getImageData: function () {
        this.images = this.container.querySelectorAll(selectors.images);

        var items = [];
        var options = {};

        // 为每张图片创建数据项
        this.images.forEach((el) => {
          var item = {
            msrc: el.currentSrc || el.src, // 缩略图源
            src: el.getAttribute('data-photoswipe-src'), // 高分辨率图片源
            w: el.getAttribute('data-photoswipe-width'), // 宽度
            h: el.getAttribute('data-photoswipe-height'), // 高度
            el: el, // DOM元素引用
            initialZoomLevel: this.calculateInitialZoomLevel(el), // 计算初始缩放级别
          };

          items.push(item);
        });

        return items;
      },

      // ===== 初始化画廊 =====
      initGallery: function (items, index) {
        var pswpElement = document.querySelectorAll('.pswp')[0]; // PhotoSwipe容器

        // PhotoSwipe配置选项
        var options = {
          allowPanToNext: false, // 禁用拖拽到下一张
          captionEl: false, // 禁用标题元素
          closeOnScroll: false, // 禁用滚动关闭
          counterEl: false, // 禁用计数器
          history: false, // 禁用历史记录
          index: index - 1, // 起始索引（基于0）
          pinchToClose: false, // 禁用捏合关闭
          preloaderEl: false, // 禁用预加载器
          scaleMode: 'zoom', // 缩放模式
          shareEl: false, // 禁用分享按钮
          tapToToggleControls: false, // 禁用点击切换控件
          closeEl: true, // 启用关闭按钮

          // 确保关闭按钮始终可见
          barsSize: { top: 0, bottom: 0 }, // 隐藏顶部和底部栏
          showHideOpacity: false, // 禁用透明度动画

          // 移动端增强配置
          clickToCloseNonZoomable: false, // 非缩放状态下禁用点击关闭
          maxSpreadZoom: 3, // 最大放大倍数
          getDoubleTapZoom: function (isMouseClick, item) {
            // 双击缩放倍数
            if (isMouseClick) {
              return 1.5;
            } else {
              return item.initialZoomLevel < 0.7 ? 1.5 : item.initialZoomLevel + 0.5;
            }
          },
          // 启用更好的移动端手势支持
          spacing: 0.1, // 图片间距
          allowSwipeToClose: true, // 允许向下滑动关闭
          getThumbBoundsFn: function (index) {
            // 获取缩略图边界，用于缩放动画
            var pageYScroll = window.pageYOffset || document.documentElement.scrollTop;
            var thumbnail = items[index].el;
            var rect = thumbnail.getBoundingClientRect();
            return { x: rect.left, y: rect.top + pageYScroll, w: rect.width };
          },
        };

        // 创建PhotoSwipe实例
        this.gallery = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, items, options);

        // 监听图片切换事件
        this.gallery.listen('afterChange', this.afterChange.bind(this));

        // 监听获取数据事件，确保初始缩放级别正确设置
        this.gallery.listen('gettingData', function (index, item) {
          // 重新计算初始缩放级别，确保以产品详情页的显示大小为准
          if (item.el) {
            var displayWidth = item.el.clientWidth;
            var displayHeight = item.el.clientHeight;
            var originalWidth = parseInt(item.el.getAttribute('data-photoswipe-width'), 10);
            var originalHeight = parseInt(item.el.getAttribute('data-photoswipe-height'), 10);

            var scaleX = displayWidth / originalWidth;
            var scaleY = displayHeight / originalHeight;
            var scale = Math.min(scaleX, scaleY);

            item.initialZoomLevel = Math.max(scale, 0.1);
          }
        });

        this.gallery.init(); // 初始化画廊

        this.preventiOS15Scrolling(); // 防止iOS 15滚动问题
      },

      // ===== 图片切换后的处理 =====
      afterChange: function () {
        var index = this.gallery.getCurrentIndex();
        // 更新移动端缩略图激活状态
        this.updateMobileThumbnails(index);
        // 触发自定义事件，通知外部组件图片已切换
        this.container.dispatchEvent(
          new CustomEvent('photoswipe:afterChange', {
            detail: {
              index: index,
            },
          })
        );

        // 更新移动端缩略图激活状态
        this.updateMobileThumbnails(index);
      },

      // ===== 更新移动端缩略图激活状态 =====
      updateMobileThumbnails: function (index) {
        var mobileThumbs = document.querySelectorAll('.product__thumbs--below .product__thumb-item');
        if (mobileThumbs.length > 0) {
          mobileThumbs.forEach((thumb) => {
            thumb.classList.remove('active');
          });

          // 根据 data-index 匹配激活项（避免 DOM 顺序变化导致错位）
          var activeThumb = document.querySelector(
            '.product__thumbs--below .product__thumb-item[data-index="' + index + '"]'
          );
          if (activeThumb) {
            activeThumb.classList.add('active');
            var scroller = activeThumb.closest('.product__thumbs--scroller');
            if (scroller) {
              var thumbLeft = activeThumb.offsetLeft;
              var thumbWidth = activeThumb.offsetWidth;
              var scrollerWidth = scroller.offsetWidth;
              var scrollLeft = thumbLeft - scrollerWidth / 2 + thumbWidth / 2;
              scroller.scrollTo({ left: scrollLeft, behavior: 'smooth' });
            }
          }
        }
      },

      // ===== 同步高度（用于iOS修复） =====
      syncHeight: function () {
        document.documentElement.style.setProperty('--window-inner-height', `${window.innerHeight}px`);
      },

      // ===== 防止iOS 15滚动问题的修复方案 =====
      // 修复方案来源：https://gist.github.com/dimsemenov/0b8c255c0d87f2989e8ab876073534ea
      preventiOS15Scrolling: function () {
        let initialScrollPos;

        // 仅在iOS设备上执行
        if (!/iPhone|iPad|iPod/i.test(window.navigator.userAgent)) return;

        this.syncHeight();

        // 存储滚动位置以便稍后恢复
        initialScrollPos = window.scrollY;

        // PhotoSwipe打开时为根元素添加类
        document.documentElement.classList.add('pswp-open-in-ios');

        window.addEventListener('resize', this.syncHeight);

        // PhotoSwipe销毁时清理
        this.gallery.listen('destroy', () => {
          document.documentElement.classList.remove('pswp-open-in-ios');
          window.scrollTo(0, initialScrollPos); // 恢复滚动位置
        });
      },
    });

    return Photoswipe;
  })();

  /*============================================================================
    产品推荐组件
==============================================================================*/

  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();
      this.el = this;
      this.url = this.dataset.url; // 推荐产品API URL
      this.intent = this.dataset.intent; // 推荐意图（相关、互补等）
      // 获取占位符容器，用于显示推荐内容
      this.placeholder = this.querySelector('.product-recommendations-placeholder');
      this.productResults = this.querySelector('.grid-product');
      this.sectionId = this.dataset.sectionId; // 区域ID
      this.blockId = this.dataset.blockId; // 区块ID

      // 监听推荐内容加载完成事件
      document.addEventListener('recommendations:loaded', (e) => {
        // 获取颜色图片元素，用于颜色样本悬停效果
        this.colorImages = this.el.querySelectorAll('.grid-product__color-image');
        if (this.colorImages.length) {
          this.swatches = this.el.querySelectorAll('.color-swatch--with-image');
          this.colorSwatchHovering(); // 初始化颜色样本悬停功能
        }
      });
    }

    // ===== 组件连接到DOM时执行 =====
    connectedCallback() {
      // 通过API获取推荐产品数据
      fetch(this.url)
        .then((response) => response.text())
        .then((text) => {
          // 解析返回的HTML内容
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('.product-recommendations');

          // 如果没有推荐产品，隐藏整个组件
          if (!recommendations) {
            this.el.classList.add('hide');
            if (AOS) {
              AOS.refreshHard(); // 刷新AOS动画
            }
            return;
          }

          // 将推荐内容插入到占位符中
          this.placeholder.innerHTML = '';
          this.placeholder.innerHTML = recommendations.innerHTML;

          // 重新初始化产品网格项功能
          theme.reinitProductGridItem(this.el);

          // 查找是否有轮播容器
          this.slideshow = this.querySelector('[data-slideshow]');

          if (this.slideshow) {
            this.setupSlider(); // 设置轮播功能
          }

          // 触发推荐内容加载完成事件
          document.dispatchEvent(
            new CustomEvent('recommendations:loaded', {
              detail: {
                section: this.el,
                intent: this.intent,
              },
            })
          );
        })
        .catch((e) => {
          console.error(e);
        });
    }

    // ===== 设置轮播滑块 =====
    setupSlider() {
      const controlType = this.slideshow.dataset.controls; // 控制类型
      const perSlide = parseFloat(this.slideshow.dataset.perSlide); // 每屏显示数量
      const count = parseFloat(this.slideshow.dataset.count); // 总数量

      let prevNextButtons = false; // 前后导航按钮
      let pageDots = true; // 页面指示点

      // 根据控制类型设置导航方式
      if (controlType === 'arrows') {
        pageDots = false;
        prevNextButtons = true;
      }

      // 只有当每屏显示数量小于总数量时才初始化轮播
      if (perSlide < count) {
        this.flickity = new theme.Slideshow(this.slideshow, {
          prevNextButtons,
          pageDots,
          adaptiveHeight: true, // 自适应高度
          wrapAround: false, // 不循环播放
        });
      }
    }

    // ===== 颜色样本悬停功能 =====
    colorSwatchHovering() {
      this.swatches.forEach((swatch) => {
        // 鼠标进入事件
        swatch.addEventListener(
          'mouseenter',
          function () {
            this.setActiveColorImage(swatch);
          }.bind(this)
        );

        // 触摸开始事件（移动端）
        swatch.addEventListener(
          'touchstart',
          function (evt) {
            evt.preventDefault();
            this.setActiveColorImage(swatch);
          }.bind(this),
          { passive: true }
        );

        // 鼠标离开事件
        swatch.addEventListener(
          'mouseleave',
          function () {
            this.removeActiveColorImage(swatch);
          }.bind(this)
        );
      });
    }

    // ===== 设置活跃颜色图片 =====
    setActiveColorImage(swatch) {
      const id = swatch.dataset.variantId; // 变体ID
      const image = swatch.dataset.variantImage; // 变体图片

      // 取消所有活跃的样本图片
      this.colorImages.forEach((el) => {
        el.classList.remove('is-active');
      });

      // 取消所有活跃的样本
      this.swatches.forEach((el) => {
        el.classList.remove('is-active');
      });

      // 设置活跃图片和样本
      const imageEl = this.el.querySelector(`.grid-product__color-image--${id}`);

      imageEl.style.backgroundImage = 'url(' + image + ')';
      imageEl.classList.add('is-active');
      swatch.classList.add('is-active');

      // 用变体URL更新产品网格项的链接
      const variantUrl = swatch.dataset.url;
      const gridItem = swatch.closest('.grid-item__link');
      gridItem.setAttribute('href', variantUrl);
    }

    // ===== 移除活跃颜色图片 =====
    removeActiveColorImage(swatch) {
      const id = swatch.dataset.variantId;
      this.el.querySelector(`.grid-product__color-image--${id}`).classList.remove('is-active');
    }
  }

  // 注册自定义元素
  customElements.define('product-recommendations', ProductRecommendations);

  // ===== 轮播展示区域模块 =====
  theme.SlideshowSection = (function () {
    var selectors = {
      parallaxContainer: '.parallax-container', // 视差容器
    };

    // ===== 轮播展示构造函数 =====
    function SlideshowSection(container) {
      this.container = container;
      var sectionId = container.getAttribute('data-section-id');
      this.slideshow = container.querySelector('#Slideshow-' + sectionId);
      this.namespace = '.' + sectionId;

      this.initialIndex = 0; // 初始幻灯片索引

      if (!this.slideshow) {
        return;
      }

      // 获取Shopify创建的区域包装div，然后获取它在父元素中的索引
      var sectionEl = container.parentElement;
      var sectionIndex = [].indexOf.call(sectionEl.parentElement.children, sectionEl);

      // 如果是第一个区域，立即初始化；否则等到可见时再初始化
      if (sectionIndex === 0) {
        this.init();
      } else {
        theme.initWhenVisible({
          element: this.container,
          callback: this.init.bind(this),
        });
      }
    }

    // ===== 轮播展示原型方法 =====
    SlideshowSection.prototype = Object.assign({}, SlideshowSection.prototype, {
      // ===== 初始化方法 =====
      init: function () {
        var slides = this.slideshow.querySelectorAll('.slideshow__slide');

        // 移除加载状态，添加已加载状态
        this.slideshow.classList.remove('loading', 'loading--delayed');
        this.slideshow.classList.add('loaded');

        if (slides.length > 1) {
          // 多张幻灯片时的轮播配置
          var sliderArgs = {
            prevNextButtons: this.slideshow.hasAttribute('data-arrows'), // 前后箭头
            pageDots: this.slideshow.hasAttribute('data-dots'), // 页面指示点
            fade: true, // 淡入淡出效果
            setGallerySize: false, // 不设置画廊尺寸
            initialIndex: this.initialIndex, // 初始索引
            autoPlay:
              this.slideshow.dataset.autoplay === 'true'
                ? parseInt(this.slideshow.dataset.speed) // 自动播放间隔
                : false,
          };

          this.flickity = new theme.Slideshow(this.slideshow, sliderArgs);
        } else {
          // 单张幻灯片时，直接添加选中状态
          slides[0].classList.add('is-selected');
        }
      },

      // ===== 强制重新加载 =====
      forceReload: function () {
        this.onUnload();
        this.init();
      },

      // ===== 卸载清理 =====
      onUnload: function () {
        if (this.flickity && typeof this.flickity.destroy === 'function') {
          this.flickity.destroy();
        }
      },

      // ===== 取消选择事件 =====
      onDeselect: function () {
        if (this.flickity && typeof this.flickity.play === 'function') {
          this.flickity.play(); // 恢复自动播放
        }
      },

      // ===== 区块选择事件（主题编辑器中） =====
      onBlockSelect: function (evt) {
        var slide = this.slideshow.querySelector('.slideshow__slide--' + evt.detail.blockId);
        var index = parseInt(slide.dataset.index);

        if (this.flickity && typeof this.flickity.pause === 'function') {
          this.flickity.goToSlide(index); // 跳转到指定幻灯片
          this.flickity.pause(); // 暂停自动播放
        } else {
          // 如果区域重新加载，轮播可能还没设置好，等一秒再试
          this.initialIndex = index;
          setTimeout(
            function () {
              if (this.flickity && typeof this.flickity.pause === 'function') {
                this.flickity.pause();
              }
            }.bind(this),
            1000
          );
        }
      },

      // ===== 区块取消选择事件 =====
      onBlockDeselect: function () {
        if (this.flickity && typeof this.flickity.play === 'function') {
          if (this.flickity.args.autoPlay) {
            this.flickity.play(); // 恢复自动播放
          }
        }
      },
    });

    return SlideshowSection;
  })();

  // ===== 门店可用性模块 =====
  theme.StoreAvailability = (function () {
    var selectors = {
      drawerOpenBtn: '.js-drawer-open-availability', // 抽屉打开按钮
      modalOpenBtn: '.js-modal-open-availability', // 模态框打开按钮
      productTitle: '[data-availability-product-title]', // 产品标题
    };

    // ===== 门店可用性构造函数 =====
    function StoreAvailability(container) {
      this.container = container;
      this.baseUrl = container.dataset.baseUrl; // 基础URL
      this.productTitle = container.dataset.productName; // 产品名称
    }

    // ===== 门店可用性原型方法 =====
    StoreAvailability.prototype = Object.assign({}, StoreAvailability.prototype, {
      // ===== 更新内容方法 =====
      updateContent: function (variantId) {
        // 构建变体可用性API URL
        var variantSectionUrl = this.baseUrl + '/variants/' + variantId + '/?section_id=store-availability';

        var self = this;

        // 获取门店可用性数据
        fetch(variantSectionUrl)
          .then(function (response) {
            return response.text();
          })
          .then(function (html) {
            // 如果返回空内容，清空容器
            if (html.trim() === '') {
              this.container.innerHTML = '';
              return;
            }

            // 更新容器内容
            self.container.innerHTML = html;
            self.container.innerHTML = self.container.firstElementChild.innerHTML;

            // 如果有抽屉打开按钮，设置抽屉
            if (self.container.querySelector(selectors.drawerOpenBtn)) {
              self.drawer = new theme.Drawers('StoreAvailabilityDrawer', 'availability');
            }

            // 如果有模态框打开按钮，设置模态框
            if (self.container.querySelector(selectors.modalOpenBtn)) {
              self.modal = new theme.Modals('StoreAvailabilityModal', 'availability');
            }

            // 更新产品标题
            var title = self.container.querySelector(selectors.productTitle);
            if (title) {
              title.textContent = self.productTitle;
            }
          });
      },
    });

    return StoreAvailability;
  })();

  // ===== 视频区域模块 =====
  theme.VideoSection = (function () {
    var selectors = {
      videoParent: '.video-parent-section', // 视频父容器
    };

    // ===== 视频区域构造函数 =====
    function videoSection(container) {
      this.container = container;
      this.sectionId = container.getAttribute('data-section-id');
      this.namespace = '.video-' + this.sectionId;
      this.videoObject; // 视频对象

      // 延迟初始化，当元素可见时再加载
      theme.initWhenVisible({
        element: this.container,
        callback: this.init.bind(this),
        threshold: 500,
      });
    }

    // ===== 视频区域原型方法 =====
    videoSection.prototype = Object.assign({}, videoSection.prototype, {
      // ===== 初始化方法 =====
      init: function () {
        var dataDiv = this.container.querySelector('.video-div');
        if (!dataDiv) {
          return;
        }
        var type = dataDiv.dataset.type; // 视频类型

        // 根据视频类型初始化不同的播放器
        switch (type) {
          case 'youtube':
            var videoId = dataDiv.dataset.videoId;
            this.initYoutubeVideo(videoId);
            break;
          case 'vimeo':
            var videoId = dataDiv.dataset.videoId;
            this.initVimeoVideo(videoId);
            break;
          case 'mp4':
            this.initMp4Video();
            break;
        }
      },

      // ===== 初始化YouTube视频 =====
      initYoutubeVideo: function (videoId) {
        this.videoObject = new theme.YouTube('YouTubeVideo-' + this.sectionId, {
          videoId: videoId,
          videoParent: selectors.videoParent,
        });
      },

      // ===== 初始化Vimeo视频 =====
      initVimeoVideo: function (videoId) {
        this.videoObject = new theme.VimeoPlayer('Vimeo-' + this.sectionId, videoId, {
          videoParent: selectors.videoParent,
        });
      },

      // ===== 初始化MP4视频 =====
      initMp4Video: function () {
        var mp4Video = 'Mp4Video-' + this.sectionId;
        var mp4Div = document.getElementById(mp4Video);
        var parent = mp4Div.closest(selectors.videoParent);

        if (mp4Div) {
          parent.classList.add('loaded');

          // 尝试自动播放视频
          var playPromise = document.querySelector('#' + mp4Video).play();

          // Edge浏览器不返回Promise（视频仍会播放）
          if (playPromise !== undefined) {
            playPromise
              .then(function () {
                // 播放正常
              })
              .catch(function () {
                // 播放失败，显示控制条
                mp4Div.setAttribute('controls', '');
                parent.classList.add('video-interactable');
              });
          }
        }
      },

      // ===== 卸载清理 =====
      onUnload: function (evt) {
        var sectionId = evt.target.id.replace('shopify-section-', '');
        if (this.videoObject && typeof this.videoObject.destroy === 'function') {
          this.videoObject.destroy();
        }
      },
    });

    return videoSection;
  })();

  /*============================================================================
  倒计时器组件
==============================================================================*/

  class CountdownTimer extends HTMLElement {
    constructor() {
      super();
      this.el = this;
      this.display = this.querySelector('[data-time-display]'); // 时间显示容器
      this.block = this.closest('.countdown__block--timer'); // 倒计时区块

      // 获取目标时间参数
      this.year = this.el.dataset.year; // 年
      this.month = this.el.dataset.month; // 月
      this.day = this.el.dataset.day; // 日
      this.hour = this.el.dataset.hour; // 时
      this.minute = this.el.dataset.minute; // 分

      // 获取时间显示占位符元素
      this.daysPlaceholder = this.querySelector('[date-days-placeholder]');
      this.hoursPlaceholder = this.querySelector('[date-hours-placeholder]');
      this.minutesPlaceholder = this.querySelector('[date-minutes-placeholder]');
      this.secondsPlaceholder = this.querySelector('[date-seconds-placeholder]');
      this.messagePlaceholder = this.querySelector('[data-message-placeholder]');

      // 配置选项
      this.hideTimerOnComplete = this.el.dataset.hideTimer; // 完成时是否隐藏计时器
      this.completeMessage = this.el.dataset.completeMessage; // 完成时显示的消息

      this.timerComplete = false; // 计时器是否完成

      this.init();
    }

    // ===== 初始化方法 =====
    init() {
      // 每秒更新一次倒计时
      setInterval(() => {
        if (!this.timerComplete) {
          this._calculate();
        }
      }, 1000);
    }

    // ===== 计算剩余时间 =====
    _calculate() {
      // 计算时间差并转换为整数
      const timeDifference =
        +new Date(`${this.month}/${this.day}/${this.year} ${this.hour}:${this.minute}:00`).getTime() -
        +new Date().getTime();

      // 如果时间差大于0，计算剩余时间
      if (timeDifference > 0) {
        const intervals = {
          days: Math.floor(timeDifference / (1000 * 60 * 60 * 24)), // 天数
          hours: Math.floor((timeDifference / (1000 * 60 * 60)) % 24), // 小时
          minutes: Math.floor((timeDifference / 1000 / 60) % 60), // 分钟
          seconds: Math.floor((timeDifference / 1000) % 60), // 秒数
        };

        // 更新显示
        this.daysPlaceholder.innerHTML = intervals.days;
        this.hoursPlaceholder.innerHTML = intervals.hours;
        this.minutesPlaceholder.innerHTML = intervals.minutes;
        this.secondsPlaceholder.innerHTML = intervals.seconds;

        // 延迟显示倒计时（避免闪烁）
        setTimeout(() => {
          this.display.classList.add('countdown__display--loaded');
        }, 1);
      } else {
        // 倒计时结束处理

        // 显示完成消息
        if (this.completeMessage && this.messagePlaceholder) {
          this.messagePlaceholder.classList.add('countdown__timer-message--visible');
        }

        // 隐藏计时器显示
        if (this.hideTimerOnComplete === 'true') {
          this.display.classList.remove('countdown__display--visible');
          this.display.classList.add('countdown__display--hidden');
        }

        // 隐藏整个计时器区块
        if (!this.completeMessage && this.hideTimerOnComplete === 'true') {
          this.block.classList.add('countdown__block--hidden');
        }

        this.timerComplete = true; // 标记计时器完成
      }
    }
  }

  // 注册自定义元素
  customElements.define('countdown-timer', CountdownTimer);

  /*============================================================================
  热点组件
==============================================================================*/

  class HotSpots extends HTMLElement {
    constructor() {
      super();
      this.el = this;
      this.buttons = this.querySelectorAll('[data-button]'); // 热点按钮
      this.hotspotBlocks = this.querySelectorAll('[data-hotspot-block]'); // 热点内容区块
      this.blockContainer = this.querySelector('[data-block-container]'); // 区块容器
      this.colorImages = this.querySelectorAll('.grid-product__color-image'); // 颜色图片
      this.colorSwatches = this.querySelectorAll('.color-swatch--with-image'); // 颜色样本

      this._bindEvents(); // 绑定事件
      this._setupQuickShop(); // 设置快速购买

      // 如果有颜色图片，初始化颜色样本悬停功能
      if (this.colorImages.length) {
        this._colorSwatchHovering();
      }
    }

    // ===== 颜色样本悬停功能 =====
    _colorSwatchHovering() {
      this.colorSwatches.forEach((swatch) => {
        // 鼠标进入事件
        swatch.addEventListener(
          'mouseenter',
          function () {
            this._setActiveColorImage(swatch);
          }.bind(this)
        );

        // 触摸开始事件
        swatch.addEventListener(
          'touchstart',
          function (evt) {
            evt.preventDefault();
            this._setActiveColorImage(swatch);
          }.bind(this),
          { passive: true }
        );

        // 鼠标离开事件
        swatch.addEventListener(
          'mouseleave',
          function () {
            this._removeActiveColorImage(swatch);
          }.bind(this)
        );
      });
    }

    // ===== 设置活跃颜色图片 =====
    _setActiveColorImage(swatch) {
      var id = swatch.dataset.variantId; // 变体ID
      var image = swatch.dataset.variantImage; // 变体图片

      // 取消所有活跃的样本图片
      this.colorImages.forEach((el) => {
        el.classList.remove('is-active');
      });

      // 取消所有活跃的样本
      this.colorSwatches.forEach((el) => {
        el.classList.remove('is-active');
      });

      // 设置活跃图片和样本
      var imageEl = this.el.querySelector('.grid-product__color-image--' + id);
      imageEl.style.backgroundImage = 'url(' + image + ')';
      imageEl.classList.add('is-active');
      swatch.classList.add('is-active');

      // 用变体URL更新产品网格项链接
      var variantUrl = swatch.dataset.url;
      var gridItem = swatch.closest('.grid-item__link');

      if (gridItem) gridItem.setAttribute('href', variantUrl);
    }

    // ===== 移除活跃颜色图片 =====
    _removeActiveColorImage(swatch) {
      const id = swatch.dataset.variantId;
      this.querySelector(`.grid-product__color-image--${id}`).classList.remove('is-active');
    }

    /* 设置事件监听器 */
    _bindEvents() {
      // 为每个热点按钮绑定点击事件
      this.buttons.forEach((button) => {
        const id = button.dataset.button;

        button.on('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          this._showContent(id); // 显示对应内容
        });
      });

      // 在主题编辑器中选择区块时显示活跃热点
      document.addEventListener('shopify:block:select', (e) => {
        const blockId = e.detail.blockId;
        this._showContent(`${blockId}`);
      });
    }

    /* 切换侧边栏内容 */
    _showContent(id) {
      // 隐藏所有热点区块，显示指定ID的区块
      this.hotspotBlocks.forEach((block) => {
        if (block.dataset.hotspotBlock === id) {
          block.classList.add('is-active');
        } else {
          block.classList.remove('is-active');
        }
      });
    }

    // ===== 设置快速购买功能 =====
    _setupQuickShop() {
      if (this.querySelectorAll('[data-block-type="product"]').length > 0) {
        // 确保使用正确版本的QuickShop
        if (typeof theme.QuickShop === 'function') {
          new theme.QuickShop(this.blockContainer);
        } else if (typeof theme.initQuickShop === 'function') {
          theme.initQuickShop();
        }

        // 设置快速添加功能
        if (typeof theme.QuickAdd === 'function') {
          new theme.QuickAdd(this.blockContainer);
        }
      }
    }
  }

  // 注册自定义元素
  customElements.define('hot-spots', HotSpots);

  /*============================================================================
  图片对比组件
==============================================================================*/

  class ImageCompare extends HTMLElement {
    constructor() {
      super();
      this.el = this;
      this.sectionId = this.dataset.sectionId; // 区域ID
      this.button = this.querySelector('[data-button]'); // 拖拽按钮
      this.draggableContainer = this.querySelector('[data-draggable]'); // 可拖拽容器
      this.primaryImage = this.querySelector('[data-primary-image]'); // 主图片
      this.secondaryImage = this.querySelector('[data-secondary-image]'); // 次图片

      this.calculateSizes(); // 计算尺寸

      // 拖拽状态变量
      this.active = false; // 是否正在拖拽
      this.currentX = 0; // 当前X坐标
      this.initialX = 0; // 初始X坐标
      this.xOffset = 0; // X偏移量

      this.buttonOffset = this.button.offsetWidth / 2; // 按钮偏移量

      // 绑定拖拽事件
      // 触摸事件
      this.el.addEventListener('touchstart', this.dragStart, false);
      this.el.addEventListener('touchend', this.dragEnd, false);
      this.el.addEventListener('touchmove', this.drag, false);

      // 鼠标事件
      this.el.addEventListener('mousedown', this.dragStart, false);
      this.el.addEventListener('mouseup', this.dragEnd, false);
      this.el.addEventListener('mousemove', this.drag, false);

      // 窗口大小改变时重新计算尺寸
      window.on(
        'resize',
        theme.utils.debounce(250, () => {
          this.calculateSizes(true);
        })
      );

      // 监听Shopify区域加载事件
      document.addEventListener('shopify:section:load', (event) => {
        if (event.detail.sectionId === this.sectionId && this.primaryImage !== null) {
          this.calculateSizes();
        }
      });
    }

    // ===== 计算组件尺寸 =====
    calculateSizes(hasResized = false) {
      // 重置拖拽状态
      this.active = false;
      this.currentX = 0;
      this.initialX = 0;
      this.xOffset = 0;

      this.buttonOffset = this.button.offsetWidth / 2; // 按钮偏移量
      this.elWidth = this.el.offsetWidth; // 组件宽度

      // 设置按钮初始位置（居中）
      this.button.style.transform = `translate(-${this.buttonOffset}px, -50%)`;

      // 设置主图片宽度
      if (this.primaryImage) {
        this.primaryImage.style.width = `${this.elWidth}px`;
      }

      // 如果是因为窗口大小改变，重新设置可拖拽容器宽度
      if (hasResized) this.draggableContainer.style.width = `${this.elWidth / 2}px`;
    }

    // ===== 开始拖拽 =====
    dragStart(e) {
      if (e.type === 'touchstart') {
        this.initialX = e.touches[0].clientX - this.xOffset;
      } else {
        this.initialX = e.clientX - this.xOffset;
      }

      // 只有点击按钮时才激活拖拽
      if (e.target === this.button) {
        this.active = true;
      }
    }

    // ===== 结束拖拽 =====
    dragEnd(e) {
      this.initialX = this.currentX;
      this.active = false;
    }

    // ===== 拖拽过程 =====
    drag(e) {
      if (this.active) {
        e.preventDefault();

        // 获取当前坐标
        if (e.type === 'touchmove') {
          this.currentX = e.touches[0].clientX - this.initialX;
        } else {
          this.currentX = e.clientX - this.initialX;
        }

        this.xOffset = this.currentX;
        this.setTranslate(this.currentX, this.button); // 设置变换
      }
    }

    // ===== 设置元素位置变换 =====
    setTranslate(xPos, el) {
      let newXpos = xPos - this.buttonOffset; // 新的X位置
      let newVal = this.elWidth / 2 + xPos; // 新的宽度值

      const boundaryPadding = 50; // 边界填充
      const XposMin = (this.elWidth / 2 + this.buttonOffset) * -1; // 最小X位置
      const XposMax = this.elWidth / 2 - this.buttonOffset; // 最大X位置

      // 设置拖拽边界
      if (newXpos < XposMin + boundaryPadding) {
        newXpos = XposMin + boundaryPadding;
        newVal = boundaryPadding;
      } else if (newXpos > XposMax - boundaryPadding) {
        newXpos = XposMax - boundaryPadding;
        newVal = this.elWidth - boundaryPadding;
      }

      // 应用变换
      el.style.transform = `translate(${newXpos}px, -50%)`;
      this.draggableContainer.style.width = `${newVal}px`;
    }
  }

  // 注册自定义元素
  customElements.define('image-compare', ImageCompare);

  // ===== 博客模块 =====
  theme.Blog = (function () {
    // ===== 博客构造函数 =====
    function Blog(container) {
      // 初始化标签过滤功能
      this.tagFilters();
    }

    // ===== 博客原型方法 =====
    Blog.prototype = Object.assign({}, Blog.prototype, {
      // ===== 标签过滤方法 =====
      tagFilters: function () {
        // 获取博客标签过滤下拉选择器
        var filterBy = document.getElementById('BlogTagFilter');

        if (!filterBy) {
          return;
        }

        // 监听下拉选择器变化事件
        filterBy.addEventListener('change', function () {
          // 直接跳转到选中的URL，实现标签过滤
          location.href = filterBy.value;
        });
      },
    });

    return Blog;
  })();

  // ===== 商品集合页头模块 =====
  theme.CollectionHeader = (function () {
    // 全局标志，标记是否已经加载过
    var hasLoadedBefore = false;

    // ===== 商品集合页头构造函数 =====
    function CollectionHeader(container) {
      this.namespace = '.collection-header';

      // 查找英雄图片容器
      var heroImageContainer = container.querySelector('.collection-hero');
      if (heroImageContainer) {
        // 如果之前已加载过，检查是否需要重新加载
        if (hasLoadedBefore) {
          this.checkIfNeedReload();
        }
        // 移除加载状态，添加已加载状态
        heroImageContainer.classList.remove('loading', 'loading--delayed');
        heroImageContainer.classList.add('loaded');
      } else if (theme.settings.overlayHeader) {
        // 如果没有英雄图片但设置了覆盖页头，禁用覆盖页头
        theme.headerNav.disableOverlayHeader();
      }

      // 标记已加载过
      hasLoadedBefore = true;
    }

    // ===== 商品集合页头原型方法 =====
    CollectionHeader.prototype = Object.assign({}, CollectionHeader.prototype, {
      // ===== 检查是否需要重新加载 =====
      // 如果启用了集合页头英雄图片设置且页头设置为粘性，
      // 页头中的liquid变量需要完整页面刷新。仅在编辑器中必要。
      checkIfNeedReload: function () {
        // 仅在设计模式下执行
        if (!Shopify.designMode) {
          return;
        }

        if (theme.settings.overlayHeader) {
          var header = document.querySelector('.header-wrapper');
          // 如果页头没有覆盖类，重新加载页面
          if (!header.classList.contains('header-wrapper--overlay')) {
            location.reload();
          }
        }
      },
    });

    return CollectionHeader;
  })();

  // ===== 商品集合侧边栏模块 =====
  theme.CollectionSidebar = (function () {
    var drawerStyle = false; // 是否为抽屉样式

    // DOM选择器定义
    var selectors = {
      sidebar: '#CollectionSidebar', // 侧边栏容器
    };

    // ===== 商品集合侧边栏构造函数 =====
    function CollectionSidebar(container) {
      this.container = container.querySelector(selectors.sidebar);
    }

    // ===== 商品集合侧边栏原型方法 =====
    CollectionSidebar.prototype = Object.assign({}, CollectionSidebar.prototype, {
      // ===== 初始化方法 =====
      init: function () {
        // 如果侧边栏不存在，不加载
        if (!this.container) {
          return;
        }

        // 先执行卸载清理
        this.onUnload();

        // 检查是否为抽屉样式
        drawerStyle = this.container.dataset.style === 'drawer';
        // 初始化过滤器抽屉
        theme.FilterDrawer = new theme.Drawers('FilterDrawer', 'collection-filters', true);
      },

      // ===== 强制重新加载 =====
      forceReload: function () {
        this.init();
      },

      // ===== 选择事件处理 =====
      onSelect: function () {
        if (theme.FilterDrawer) {
          if (!drawerStyle) {
            // 如果不是抽屉样式，关闭抽屉
            theme.FilterDrawer.close();
            return;
          }

          // 如果是抽屉样式或小屏幕，打开抽屉
          if (drawerStyle || theme.config.bpSmall) {
            theme.FilterDrawer.open();
          }
        }
      },

      // ===== 取消选择事件处理 =====
      onDeselect: function () {
        if (theme.FilterDrawer) {
          theme.FilterDrawer.close();
        }
      },

      // ===== 卸载清理 =====
      onUnload: function () {
        if (theme.FilterDrawer) {
          theme.FilterDrawer.close();
        }
      },
    });

    return CollectionSidebar;
  })();

  // ===== 商品集合主模块 =====
  theme.Collection = (function () {
    // 全局动画状态标志，防止重复操作
    var isAnimating = false;

    // DOM选择器定义
    var selectors = {
      sortSelect: '#SortBy', // 排序选择器

      colorSwatchImage: '.grid-product__color-image', // 颜色样本图片
      colorSwatch: '.color-swatch--with-image', // 带图片的颜色样本

      collectionGrid: '.collection-grid__wrapper', // 商品网格容器
      trigger: '.collapsible-trigger', // 可折叠触发器
      sidebar: '#CollectionSidebar', // 侧边栏
      filterSidebar: '.collapsible-content--sidebar', // 侧边栏过滤器内容
      activeTagList: '.tag-list--active-tags', // 活跃标签列表
      tags: '.tag-list input', // 标签输入
      activeTags: '.tag-list a', // 活跃标签链接
      tagsForm: '.filter-form', // 标签表单
      filters: '.collection-filter', // 集合过滤器
      priceRange: '.price-range', // 价格范围选择器
    };

    // CSS类名定义
    var classes = {
      activeTag: 'tag--active', // 活跃标签
      removeTagParent: 'tag--remove', // 移除标签父容器
      filterSidebar: 'collapsible-content--sidebar', // 侧边栏过滤器
      isOpen: 'is-open', // 打开状态
    };

    // ===== 商品集合构造函数 =====
    function Collection(container) {
      this.container = container;
      this.sectionId = container.getAttribute('data-section-id');
      this.namespace = '.collection-' + this.sectionId;
      // 初始化侧边栏
      this.sidebar = new theme.CollectionSidebar(container);
      // 获取上下文（区分是否为特色集合）
      this.context = container.getAttribute('data-context');

      // 初始化Ajax渲染器，用于无刷新加载内容
      this.ajaxRenderer = new theme.AjaxRenderer({
        sections: [
          {
            sectionId: this.sectionId,
            nodeId: 'CollectionAjaxContent',
          },
        ],
        onReplace: this.onReplaceAjaxContent.bind(this),
      });

      this.init();
    }

    // ===== 商品集合原型方法 =====
    Collection.prototype = Object.assign({}, Collection.prototype, {
      // ===== 初始化方法 =====
      init: function () {
        /* 防止在集合模板上的特色集合运行额外的JS */
        if (this.context && this.context === 'featured-collection') {
          // 仅初始化颜色样本悬停功能
          this.colorSwatchHovering();
        } else {
          // 完整功能初始化
          this.initSort(); // 初始化排序
          this.colorSwatchHovering(); // 初始化颜色样本悬停
          this.initFilters(); // 初始化过滤器
          this.initPriceRange(); // 初始化价格范围
          this.sidebar.init(); // 初始化侧边栏
        }
      },

      // ===== 初始化排序功能 =====
      initSort: function () {
        this.sortSelect = document.querySelector(selectors.sortSelect);

        if (this.sortSelect) {
          // 获取默认排序值
          this.defaultSort = this.getDefaultSortValue();
          // 绑定排序变化事件
          this.sortSelect.on('change' + this.namespace, this.onSortChange.bind(this));
        }
      },

      // ===== 获取当前排序值 =====
      getSortValue: function () {
        return this.sortSelect.value || this.defaultSort;
      },

      // ===== 获取默认排序值 =====
      getDefaultSortValue: function () {
        return this.sortSelect.getAttribute('data-default-sortby');
      },

      // ===== 排序变化处理 =====
      onSortChange: function () {
        // 获取当前URL参数
        this.queryParams = new URLSearchParams(window.location.search);

        // 设置新的排序参数
        this.queryParams.set('sort_by', this.getSortValue());
        this.queryParams.delete('page'); // 删除页码参数（如果存在）

        // 更新URL并刷新页面
        window.location.search = this.queryParams.toString();
      },

      // ===== 颜色样本悬停功能 =====
      colorSwatchHovering: function () {
        var colorImages = this.container.querySelectorAll(selectors.colorSwatchImage);
        if (!colorImages.length) {
          return;
        }

        // 为每个颜色样本绑定悬停事件
        this.container.querySelectorAll(selectors.colorSwatch).forEach((swatch) => {
          // 鼠标进入时显示对应变体图片
          swatch.addEventListener('mouseenter', () => {
            var id = swatch.dataset.variantId;
            var image = swatch.dataset.variantImage;
            var el = this.container.querySelector('.grid-product__color-image--' + id);
            el.style.backgroundImage = 'url(' + image + ')';
            el.classList.add('is-active');
          });

          // 鼠标离开时隐藏变体图片
          swatch.addEventListener('mouseleave', () => {
            var id = swatch.dataset.variantId;
            this.container.querySelector('.grid-product__color-image--' + id).classList.remove('is-active');
          });
        });
      },

      /*====================
      商品集合过滤器
    ====================*/

      // ===== 初始化过滤器 =====
      initFilters: function () {
        var tags = document.querySelectorAll(selectors.tags);

        if (!tags.length) {
          return;
        }

        // 绑定浏览器后退按钮
        this.bindBackButton();

        // 如果启用粘性页头，设置过滤器的粘性位置
        if (theme.config.stickyHeader) {
          this.setFilterStickyPosition();

          // 窗口大小改变时重新设置位置
          window.on('resize', theme.utils.debounce(500, this.setFilterStickyPosition));
        }

        // 绑定活跃标签点击事件
        document.querySelectorAll(selectors.activeTags).forEach((tag) => {
          tag.addEventListener('click', this.tagClick.bind(this));
        });

        // 绑定标签表单输入事件
        document.querySelectorAll(selectors.tagsForm).forEach((form) => {
          form.addEventListener('input', this.onFormSubmit.bind(this));
        });
      },

      // ===== 初始化价格范围选择器 =====
      initPriceRange: function () {
        const priceRangeEls = document.querySelectorAll(selectors.priceRange);
        priceRangeEls.forEach(
          (el) =>
            new theme.PriceRange(el, {
              // onChange传递formData
              onChange: this.renderFromFormData.bind(this),
            })
        );
      },

      // ===== 标签点击处理 =====
      tagClick: function (evt) {
        var el = evt.currentTarget;

        // 关闭过滤器抽屉
        if (theme.FilterDrawer) {
          theme.FilterDrawer.close();
        }

        // 不使用Ajax加载的集合链接直接跳转
        if (el.classList.contains('no-ajax')) {
          return;
        }

        evt.preventDefault();

        // 防止重复动画
        if (isAnimating) {
          return;
        }

        isAnimating = true;

        const parent = el.parentNode;
        const newUrl = new URL(el.href);

        // 渲染活跃标签状态
        this.renderActiveTag(parent, el);
        // 更新滚动位置
        this.updateScroll(true);
        // 开始加载动画
        this.startLoading();
        // 渲染集合页面
        this.renderCollectionPage(newUrl.searchParams);
      },

      // ===== 表单提交处理 =====
      onFormSubmit: function (evt) {
        var el = evt.target;

        // 关闭过滤器抽屉
        if (theme.FilterDrawer) {
          theme.FilterDrawer.close();
        }

        // 不使用Ajax加载的表单直接提交
        if (el.classList.contains('no-ajax')) {
          return;
        }

        evt.preventDefault();
        if (isAnimating) {
          return;
        }

        isAnimating = true;

        const parent = el.closest('li');
        const formEl = el.closest('form');
        const formData = new FormData(formEl);

        // 渲染活跃标签状态
        this.renderActiveTag(parent, el);
        // 更新滚动位置
        this.updateScroll(true);
        // 开始加载动画
        this.startLoading();
        // 从表单数据渲染页面
        this.renderFromFormData(formData);
      },

      // ===== 获取打开的可折叠过滤器 =====
      fetchOpenCollasibleFilters: function () {
        return Array.from(document.querySelectorAll(`${selectors.sidebar} ${selectors.trigger}.${classes.isOpen}`)).map(
          (trigger) => trigger.dataset.collapsibleId
        );
      },

      // ===== 渲染活跃标签状态 =====
      renderActiveTag: function (parent, el) {
        const textEl = parent.querySelector('.tag__text');

        if (parent.classList.contains(classes.activeTag)) {
          // 如果已经是活跃状态，移除活跃类
          parent.classList.remove(classes.activeTag);
        } else {
          // 添加活跃类
          parent.classList.add(classes.activeTag);

          // 如果是添加标签，立即显示新标签
          // 否则在Ajax完成前移除它
          if (el.closest('li').classList.contains(classes.removeTagParent)) {
            parent.remove();
          } else {
            // 在抽屉和侧边栏中都添加新标签
            document.querySelectorAll(selectors.activeTagList).forEach((list) => {
              const newTag = document.createElement('li');
              const newTagLink = document.createElement('a');
              newTag.classList.add('tag', 'tag--remove');
              newTagLink.classList.add('btn', 'btn--small');
              newTagLink.innerText = textEl.innerText;
              newTag.appendChild(newTagLink);

              list.appendChild(newTag);
            });
          }
        }
      },

      // ===== 从表单数据渲染 =====
      renderFromFormData: function (formData) {
        const searchParams = new URLSearchParams(formData);
        this.renderCollectionPage(searchParams);
      },

      // ===== Ajax内容替换处理 =====
      onReplaceAjaxContent: function (newDom, section) {
        // 获取之前打开的可折叠过滤器ID
        const openCollapsibleIds = this.fetchOpenCollasibleFilters();

        // 在新DOM中重新打开这些可折叠项
        openCollapsibleIds.forEach((selector) => {
          newDom.querySelectorAll(`[data-collapsible-id=${selector}]`).forEach(this.openCollapsible);
        });

        // 替换页面内容
        var newContentEl = newDom.getElementById(section.nodeId);
        if (!newContentEl) {
          return;
        }

        document.getElementById(section.nodeId).innerHTML = newContentEl.innerHTML;
      },

      // ===== 打开可折叠项 =====
      openCollapsible: function (el) {
        if (el.classList.contains(classes.filterSidebar)) {
          el.style.height = 'auto';
        }

        el.classList.add(classes.isOpen);
      },

      // ===== 渲染集合页面 =====
      renderCollectionPage: function (searchParams, updateURLHash = true) {
        this.ajaxRenderer.renderPage(window.location.pathname, searchParams, updateURLHash).then(() => {
          // 重新初始化集合网格
          theme.sections.reinit('collection-grid');
          // 更新滚动位置
          this.updateScroll(false);
          // 重新初始化价格范围
          this.initPriceRange();
          // 重新初始化产品网格项
          theme.reinitProductGridItem();

          // 触发集合重新加载事件
          document.dispatchEvent(new CustomEvent('collection:reloaded'));

          // 重置动画状态
          isAnimating = false;
        });
      },

      // ===== 绑定后退按钮 =====
      bindBackButton: function () {
        // 后退按钮的Ajax页面处理
        window.off('popstate' + this.namespace);
        window.on(
          'popstate' + this.namespace,
          function (state) {
            if (state) {
              const newUrl = new URL(window.location.href);
              this.renderCollectionPage(newUrl.searchParams, false);
            }
          }.bind(this)
        );
      },

      // ===== 更新滚动位置 =====
      updateScroll: function (animate) {
        var scrollToElement = document.querySelector('[data-scroll-to]');
        var scrollTo = scrollToElement && scrollToElement.offsetTop;

        // 在非小屏幕设备上调整滚动位置
        if (!theme.config.bpSmall) {
          scrollTo -= 15;
        }

        // 如果启用粘性页头，减去页头高度
        if (theme.config.stickyHeader) {
          var headerHeight = document.querySelector('.site-header').offsetHeight;
          scrollTo = scrollTo - headerHeight;
        }

        // 执行滚动（带或不带动画）
        if (animate) {
          window.scrollTo({ top: scrollTo, behavior: 'smooth' });
        } else {
          window.scrollTo({ top: scrollTo });
        }
      },

      // ===== 设置过滤器粘性位置 =====
      setFilterStickyPosition: function () {
        var headerHeight = document.querySelector('.site-header').offsetHeight;
        document.querySelector(selectors.filters).style.top = headerHeight + 10 + 'px';

        // 同时更新粘性侧边栏的顶部位置
        var stickySidebar = document.querySelector('.grid__item--sidebar');
        if (stickySidebar) {
          stickySidebar.style.top = headerHeight + 10 + 'px';
        }
      },

      // ===== 强制重新加载 =====
      forceReload: function () {
        this.init();
      },

      // ===== 开始加载动画 =====
      startLoading: function () {
        document.querySelector(selectors.collectionGrid).classList.add('unload');
      },
    });

    return Collection;
  })();

  // ===== 页脚区域模块 =====
  theme.FooterSection = (function () {
    // DOM选择器定义
    var selectors = {
      locale: '[data-disclosure-locale]', // 语言选择器
      currency: '[data-disclosure-currency]', // 货币选择器
    };

    // ===== 页脚构造函数 =====
    function FooterSection(container) {
      this.container = container;
      this.localeDisclosure = null; // 语言选择下拉组件
      this.currencyDisclosure = null; // 货币选择下拉组件

      this.init();
    }

    // ===== 页脚原型方法 =====
    FooterSection.prototype = Object.assign({}, FooterSection.prototype, {
      // ===== 初始化方法 =====
      init: function () {
        var localeEl = this.container.querySelector(selectors.locale);
        var currencyEl = this.container.querySelector(selectors.currency);

        // 初始化语言选择下拉组件
        if (localeEl) {
          this.localeDisclosure = new theme.Disclosure(localeEl);
        }

        // 初始化货币选择下拉组件
        if (currencyEl) {
          this.currencyDisclosure = new theme.Disclosure(currencyEl);
        }

        // 邮件订阅功能：将邮件图标改为提交文本
        var newsletterInput = document.querySelector('.footer__newsletter-input');
        if (newsletterInput) {
          // 监听键盘输入事件，激活输入框样式
          newsletterInput.addEventListener('keyup', function () {
            newsletterInput.classList.add('footer__newsletter-input--active');
          });
        }

        // 重新初始化可折叠框触发器
        theme.collapsibles.init(this.container);
      },

      // ===== 卸载清理方法 =====
      onUnload: function () {
        // 销毁语言选择组件
        if (this.localeDisclosure) {
          this.localeDisclosure.destroy();
        }

        // 销毁货币选择组件
        if (this.currencyDisclosure) {
          this.currencyDisclosure.destroy();
        }
      },
    });

    return FooterSection;
  })();

  // ===== 折叠网格模块 =====
  theme.CollapseGrid = (function () {
    // DOM选择器定义
    var selectors = {
      title: '.collapse-grid__title', // 折叠网格标题（触发器）
      content: '.collapse-grid__line', // 折叠网格内容行
    };

    // ===== 折叠网格构造函数 =====
    function CollapseGrid(container) {
      this.container = container;
      this.init();
    }

    // 事件命名空间，避免事件冲突
    var namespace = '.collapse-grid';

    // ===== 折叠网格原型方法 =====
    CollapseGrid.prototype = Object.assign({}, CollapseGrid.prototype, {
      // ===== 初始化方法 =====
      init: function () {
        // 为每个标题元素绑定点击事件
        this.container.querySelectorAll(selectors.title).forEach((trigger) => {
          // 先移除旧事件，避免重复绑定
          trigger.off('click' + namespace);
          // 绑定新的点击事件
          trigger.on('click' + namespace, (evt) => this.toggle(this.container, evt));
        });

        // 默认打开第一个内容项
        const firstEl = this.container.querySelectorAll(selectors.content)[0];
        if (firstEl) firstEl.classList.add('open');
      },

      // ===== 切换显示方法 =====
      toggle: function (container, evt) {
        // 遍历所有内容项
        container.querySelectorAll(selectors.content).forEach((el) => {
          if (el.dataset.id !== evt.currentTarget.dataset.id) {
            // 关闭其他内容项
            el.classList.remove('open');
          } else {
            // 打开当前点击的内容项
            el.classList.add('open');
          }
        });
      },
    });

    return CollapseGrid;
  })();

  // ===== 探索工作空间模块 =====
  theme.DiscoverWorkspace = (function () {
    // DOM选择器定义
    var selectors = {
      button: '.discover-workspace__button-clickable', // 可点击按钮
      card: '.discover-workspace__card-clickable', // 可点击卡片
    };

    // ===== 探索工作空间构造函数 =====
    function DiscoverWorkspace(container) {
      this.container = container;
      this.init();
    }

    // 事件命名空间
    var namespace = '.discover-workspace';

    // ===== 探索工作空间原型方法 =====
    DiscoverWorkspace.prototype = Object.assign({}, DiscoverWorkspace.prototype, {
      // ===== 初始化方法 =====
      init: function () {
        // 为每个按钮绑定点击事件
        this.container.querySelectorAll(selectors.button).forEach((trigger) => {
          trigger.off('click' + namespace);
          trigger.on('click' + namespace, (evt) => this.toggle(this.container, evt));
        });
      },

      // ===== 切换激活状态方法 =====
      toggle: function (container, evt) {
        // 处理卡片的激活状态
        container.querySelectorAll(selectors.card).forEach((el) => {
          if (el.dataset.id !== evt.currentTarget.dataset.id || el.classList.contains('is-active')) {
            // 移除其他卡片或当前已激活卡片的激活状态
            el.classList.remove('is-active');
          } else {
            // 激活对应的卡片
            el.classList.add('is-active');
          }
        });

        // 处理按钮的激活状态
        container.querySelectorAll(selectors.button).forEach((el) => {
          if (el.dataset.id !== evt.currentTarget.dataset.id || el.classList.contains('is-active')) {
            // 移除其他按钮或当前已激活按钮的激活状态
            el.classList.remove('is-active');
          } else {
            // 激活对应的按钮
            el.classList.add('is-active');
          }
        });
      },
    });

    return DiscoverWorkspace;
  })();

  // ===== 特色展示模块 =====
  theme.FeatureOn = (function () {
    // DOM选择器定义
    var selectors = {
      image: '.feature-on-image-item', // 特色图片项
      imageLine: '.feature-on-image', // 图片行容器
      contentLine: '.feature-on-content', // 内容行容器
    };

    // ===== 特色展示构造函数 =====
    function FeatureOn(container) {
      this.container = container;
      this.init();
    }

    // 事件命名空间和定时器
    var namespace = '.feature-on';
    var timeout = null;

    // ===== 特色展示原型方法 =====
    FeatureOn.prototype = Object.assign({}, FeatureOn.prototype, {
      // ===== 初始化方法 =====
      init: function () {
        // 为每个图片项绑定点击事件
        this.container.querySelectorAll(selectors.image).forEach((trigger) => {
          trigger.off('click' + namespace);
          trigger.on('click' + namespace, (evt) => this.toggle(this.container, evt.currentTarget.dataset.id));
        });

        // 默认激活中间的图片项
        const imageList = this.container.querySelectorAll(selectors.image);
        const midIndex = Math.floor(imageList.length / 2);
        if (imageList[midIndex]) this.toggle(this.container, imageList[midIndex].dataset.id);
      },

      // ===== 切换展示方法 =====
      toggle: function (container, id) {
        // 清除之前的定时器
        if (timeout) clearTimeout(timeout);

        let curIndex = 0; // 当前激活项索引
        let curWidth = 0; // 当前项宽度

        // 获取所有图片项
        const imageList = container.querySelectorAll(selectors.image);

        // 更新激活状态并获取当前项信息
        imageList.forEach((el, index) => {
          if (el.dataset.id !== id) {
            el.classList.remove('active');
          } else {
            el.classList.add('active');
            curIndex = index;
            curWidth = el.offsetWidth;
          }
        });

        // 获取容器元素
        const imageLine = container.querySelector(selectors.imageLine);
        const contentLine = container.querySelector(selectors.contentLine);

        // 计算可见项数量
        const lineItemCount = Math.round(imageLine.offsetWidth / curWidth);

        // 设置图片行的变换效果（居中显示当前项）
        imageLine.style.transform = `translate3d(-${(curIndex - Math.floor(lineItemCount / 2)) * curWidth}px, 0, 0)`;
        imageLine.style.transitionDuration = '300ms';

        // 设置内容行的变换效果
        contentLine.style.transform = `translate3d(-${curIndex * contentLine.offsetWidth}px, 0, 0)`;
        contentLine.style.transitionDuration = '300ms';

        // 处理无限循环逻辑（分三组循环）
        const blockCount = imageList.length / 3;
        if (curIndex < blockCount || curIndex >= blockCount * 2) {
          const preIndex = curIndex;
          // 计算跳转到的新索引
          curIndex = curIndex < blockCount ? curIndex + blockCount : curIndex - blockCount;

          // 延迟执行无缝切换
          setTimeout(() => {
            imageList[preIndex].classList.remove('active');
            // 无动画切换到新位置
            imageLine.style.transitionDuration = '0ms';
            imageLine.style.transform = `translate3d(-${
              (curIndex - Math.floor(lineItemCount / 2)) * curWidth
            }px, 0, 0)`;
            contentLine.style.transitionDuration = '0ms';
            contentLine.style.transform = `translate3d(-${curIndex * contentLine.offsetWidth}px, 0, 0)`;
            imageList[curIndex].classList.add('active');
          }, 400);
        }

        // 设置自动播放定时器（5秒后切换到下一项）
        timeout = setTimeout(() => {
          this.toggle(container, imageList[curIndex + 1].dataset.id);
        }, 5000);
      },
    });

    return FeatureOn;
  })();

  // ===== 产品描述模块 =====
  theme.ProductDesc = (function () {
    // DOM选择器定义
    var selectors = {
      video: '.product-desc-video', // 产品描述视频
    };

    // ===== 产品描述构造函数 =====
    function ProductDesc(container) {
      this.container = container;
      this.init();
    }

    // 事件命名空间
    var namespace = '.product-desc';

    // ===== 产品描述原型方法 =====
    ProductDesc.prototype = Object.assign({}, ProductDesc.prototype, {
      // ===== 初始化方法 =====
      init: function () {
        // 为每个视频元素绑定点击事件
        this.container.querySelectorAll(selectors.video).forEach((trigger) => {
          trigger.off('click' + namespace);
          trigger.on('click' + namespace, this.toggle);
        });
      },

      // ===== 视频播放切换方法 =====
      toggle: function (evt) {
        if (evt.currentTarget.classList.contains('active')) {
          // 如果视频正在播放，暂停并移除激活状态
          evt.currentTarget.children[0].pause();
          evt.currentTarget.classList.remove('active');
        } else {
          // 如果视频未播放，开始播放并添加激活状态
          evt.currentTarget.children[0].play();
          evt.currentTarget.classList.add('active');
        }
      },
    });

    return ProductDesc;
  })();

  // ===== 页头区域模块 =====
  theme.HeaderSection = (function () {
    // DOM选择器定义
    var selectors = {
      locale: '[data-disclosure-locale]', // 语言选择器
      currency: '[data-disclosure-currency]', // 货币选择器
    };

    // ===== 页头构造函数 =====
    function HeaderSection(container) {
      this.container = container;
      this.sectionId = this.container.getAttribute('data-section-id');

      this.init();
    }

    // ===== 页头原型方法 =====
    HeaderSection.prototype = Object.assign({}, HeaderSection.prototype, {
      // ===== 初始化方法 =====
      init: function () {
        // 如果页头重新加载，重新加载任何轮播以确保粘性页头正常工作
        // （可以在sections.instance数组中的任何位置）
        if (Shopify && Shopify.designMode) {
          // 重新初始化轮播区域
          theme.sections.reinit('slideshow-section');

          // 设置定时器调整页头大小，以防logo尺寸发生变化
          setTimeout(function () {
            window.dispatchEvent(new Event('resize'));
          }, 500);
        }

        this.initDrawers(); // 初始化抽屉菜单
        this.initDisclosures(); // 初始化下拉选择组件
        theme.headerNav.init(); // 初始化页头导航
        theme.announcementBar.init(); // 初始化公告栏
        this.hoverMenu(); // 初始化悬停菜单
      },

      // ===== 悬停菜单方法 =====
      hoverMenu: function () {
        // 获取所有带悬停属性的details元素
        const detailsEl = document.querySelectorAll('[data-section-type="header"] details[data-hover="true"]');

        detailsEl.forEach((detail) => {
          const summary = detail.querySelector('summary');
          const summaryLink = summary.dataset.link;

          // 点击summary时跳转到指定链接
          summary.addEventListener('click', (e) => {
            e.preventDefault();
            window.location.href = summaryLink;
          });

          // 焦点进入时打开details
          detail.addEventListener('focusin', () => {
            if (!detail.hasAttribute('open')) {
              // 关闭所有其他details
              detailsEl.forEach((detail) => {
                detail.removeAttribute('open');
                detail.setAttribute('aria-expanded', 'false');
              });

              // 打开当前details
              detail.setAttribute('open', '');
              detail.setAttribute('aria-expanded', 'true');
            }
          });

          // 焦点离开时关闭details
          detail.addEventListener('focusout', () => {
            if (detail.hasAttribute('open') && !detail.matches(':focus-within')) {
              detail.removeAttribute('open');
              detail.setAttribute('aria-expanded', 'false');
            }
          });

          // 鼠标悬停时打开details
          detail.addEventListener('mouseover', () => {
            if (!detail.hasAttribute('open')) {
              detail.setAttribute('open', '');
              detail.setAttribute('aria-expanded', 'true');
            }
          });

          // 鼠标离开时关闭details
          detail.addEventListener('mouseleave', () => {
            if (detail.hasAttribute('open')) {
              detail.removeAttribute('open');
              detail.setAttribute('aria-expanded', 'false');
            }
          });
        });
      },

      // ===== 初始化下拉选择组件 =====
      initDisclosures: function () {
        var localeEl = this.container.querySelector(selectors.locale);
        var currencyEl = this.container.querySelector(selectors.currency);

        // 初始化语言选择组件
        if (localeEl) {
          this.localeDisclosure = new theme.Disclosure(localeEl);
        }

        // 初始化货币选择组件
        if (currencyEl) {
          this.currencyDisclosure = new theme.Disclosure(currencyEl);
        }
      },

      // ===== 初始化抽屉菜单 =====
      initDrawers: function () {
        // 初始化导航抽屉
        theme.NavDrawer = new theme.Drawers('NavDrawer', 'nav');

        // 如果购物车类型是抽屉且不在购物车页面，初始化购物车抽屉
        if (theme.settings.cartType === 'drawer') {
          if (!document.body.classList.contains('template-cart')) {
            new theme.CartDrawer();
          }
        }

        // 初始化导航抽屉中的可折叠组件
        theme.collapsibles.init(document.getElementById('NavDrawer'));
      },

      // ===== 卸载清理方法 =====
      onUnload: function () {
        // 关闭导航抽屉
        theme.NavDrawer.close();
        // 卸载公告栏
        theme.announcementBar.unload();

        // 销毁语言选择组件
        if (this.localeDisclosure) {
          this.localeDisclosure.destroy();
        }

        // 销毁货币选择组件
        if (this.currencyDisclosure) {
          this.currencyDisclosure.destroy();
        }
      },
    });

    return HeaderSection;
  })();

  // ===== 浏览产品模块 =====
  theme.Product = (function () {
    // 全局视频对象存储容器，用于管理页面中的所有视频播放器
    var videoObjects = {};

    // ===== 全屏图片弹窗（兜底：当 zoom/PhotoSwipe 未启用时使用） =====
    var fullscreenImage = (function () {
      var modalEl;
      var imgEl;
      var closeBtn;
      var prevBtn;
      var nextBtn;
      var prevBodyOverflow;
      var images = []; // 图片数组
      var currentIndex = 0; // 当前图片索引

      function ensureStyles() {
        if (document.getElementById('FullscreenImageModalStyles')) return;
        var styleEl = document.createElement('style');
        styleEl.id = 'FullscreenImageModalStyles';
        styleEl.textContent =
          '#FullscreenImageModal{position:fixed;inset:0;z-index:9999;display:none;align-items:center;justify-content:center;}' +
          '#FullscreenImageModal.is-open{display:flex;}' +
          '#FullscreenImageModal .fi-backdrop{position:absolute;inset:0;background:rgba(0,0,0,.85);}' +
          '#FullscreenImageModal .fi-content{position:relative;z-index:1;max-width:95vw;max-height:95vh;display:flex;align-items:center;justify-content:center;}' +
          '#FullscreenImageModal .fi-img{display:block;max-width:100%;max-height:95vh;width:auto;height:auto;}' +
          '#FullscreenImageModal .fi-close{position:fixed;top:16px;right:16px;z-index:3;background:#fff;border:none;border-radius:50%;width:40px;height:40px;display:flex;align-items:center;justify-content:center;cursor:pointer;font-size:28px;line-height:1;padding:0;box-shadow:0 2px 10px rgba(0,0,0,.3);}' +
          '#FullscreenImageModal .fi-close:hover{background:#f0f0f0;}' +
          '#FullscreenImageModal .fi-nav{position:absolute;top:50%;transform:translateY(-50%);background:#fff;border:none;border-radius:50%;width:48px;height:48px;display:flex;align-items:center;justify-content:center;cursor:pointer;transition:all .3s ease;z-index:2;box-shadow:0 2px 10px rgba(0,0,0,.3);}' +
          '#FullscreenImageModal .fi-prev{left:20px;}' +
          '#FullscreenImageModal .fi-next{right:20px;}' +
          '#FullscreenImageModal .fi-nav:hover{background:#f0f0f0;transform:translateY(-50%) scale(1.1);}' +
          '#FullscreenImageModal .fi-nav:disabled{opacity:.3;cursor:not-allowed;pointer-events:none;}' +
          '#FullscreenImageModal .fi-nav svg{width:24px;height:24px;fill:#333;}' +
          '#FullscreenImageModal .fi-counter{position:fixed;bottom:16px;left:50%;transform:translateX(-50%);z-index:2;background:rgba(0,0,0,.6);color:#fff;padding:8px 16px;border-radius:20px;font-size:14px;}' +
          'html.fi-modal-open,body.fi-modal-open{overflow:hidden !important;}';
        document.head.appendChild(styleEl);
      }

      function ensureModal() {
        if (modalEl) return;
        ensureStyles();

        modalEl = document.createElement('div');
        modalEl.id = 'FullscreenImageModal';
        modalEl.setAttribute('role', 'dialog');
        modalEl.setAttribute('aria-modal', 'true');
        modalEl.setAttribute('aria-hidden', 'true');

        modalEl.innerHTML =
          '<div class="fi-backdrop" data-fi-close></div>' +
          '<button type="button" class="fi-close" aria-label="Close" data-fi-close>×</button>' +
          '<div class="fi-content">' +
          '<button type="button" class="fi-nav fi-prev" aria-label="Previous">' +
          '<svg viewBox="0 0 24 24"><path d="M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z"/></svg>' +
          '</button>' +
          '<img class="fi-img" alt="" />' +
          '<button type="button" class="fi-nav fi-next" aria-label="Next">' +
          '<svg viewBox="0 0 24 24"><path d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"/></svg>' +
          '</button>' +
          '</div>' +
          '<div class="fi-counter"></div>';

        document.body.appendChild(modalEl);
        imgEl = modalEl.querySelector('.fi-img');
        closeBtn = modalEl.querySelector('.fi-close');
        prevBtn = modalEl.querySelector('.fi-prev');
        nextBtn = modalEl.querySelector('.fi-next');

        modalEl.addEventListener('click', function (e) {
          if (e.target && e.target.hasAttribute('data-fi-close')) {
            close();
          }
        });

        // 上一张按钮点击事件
        if (prevBtn) {
          prevBtn.addEventListener('click', function (e) {
            e.stopPropagation();
            showPrev();
          });
        }

        // 下一张按钮点击事件
        if (nextBtn) {
          nextBtn.addEventListener('click', function (e) {
            e.stopPropagation();
            showNext();
          });
        }

        // 键盘事件
        document.addEventListener('keydown', function (e) {
          if (!modalEl.classList.contains('is-open')) return;
          if (e.key === 'Escape') {
            close();
          } else if (e.key === 'ArrowLeft') {
            showPrev();
          } else if (e.key === 'ArrowRight') {
            showNext();
          }
        });
      }

      function updateImage() {
        if (images.length === 0) return;
        var current = images[currentIndex];
        if (current) {
          imgEl.src = current.src;
          imgEl.alt = current.alt || '';
        }
        updateNavButtons();
        updateCounter();
      }

      function updateNavButtons() {
        if (!prevBtn || !nextBtn) return;
        
        // 如果只有一张图片，隐藏导航按钮
        if (images.length <= 1) {
          prevBtn.style.display = 'none';
          nextBtn.style.display = 'none';
        } else {
          prevBtn.style.display = 'flex';
          nextBtn.style.display = 'flex';
          
          // 更新按钮禁用状态（可循环）
          prevBtn.disabled = false;
          nextBtn.disabled = false;
        }
      }

      function updateCounter() {
        var counterEl = modalEl.querySelector('.fi-counter');
        if (!counterEl) return;
        
        if (images.length <= 1) {
          counterEl.style.display = 'none';
        } else {
          counterEl.style.display = 'block';
          counterEl.textContent = (currentIndex + 1) + ' / ' + images.length;
        }
      }

      function showPrev() {
        if (images.length <= 1) return;
        currentIndex = currentIndex > 0 ? currentIndex - 1 : images.length - 1;
        updateImage();
      }

      function showNext() {
        if (images.length <= 1) return;
        currentIndex = currentIndex < images.length - 1 ? currentIndex + 1 : 0;
        updateImage();
      }

      function open(src, alt, allImages, index) {
        if (!src) return;
        ensureModal();

        // 设置图片数组和当前索引
        if (allImages && Array.isArray(allImages) && allImages.length > 0) {
          images = allImages;
          currentIndex = typeof index === 'number' ? index : 0;
        } else {
          // 如果没有提供图片数组，创建单图数组
          images = [{ src: src, alt: alt || '' }];
          currentIndex = 0;
        }

        prevBodyOverflow = document.body.style.overflow;
        document.documentElement.classList.add('fi-modal-open');
        document.body.classList.add('fi-modal-open');
        document.body.style.overflow = 'hidden';

        updateImage();

        modalEl.classList.add('is-open');
        modalEl.setAttribute('aria-hidden', 'false');
        if (closeBtn && typeof closeBtn.focus === 'function') {
          closeBtn.focus();
        }
      }

      function close() {
        if (!modalEl) return;
        modalEl.classList.remove('is-open');
        modalEl.setAttribute('aria-hidden', 'true');

        document.documentElement.classList.remove('fi-modal-open');
        document.body.classList.remove('fi-modal-open');
        document.body.style.overflow = prevBodyOverflow || '';

        // 避免在关闭后仍占用带宽（尤其是大图）
        if (imgEl) {
          imgEl.src = '';
        }
        
        // 重置状态
        images = [];
        currentIndex = 0;
      }

      return {
        open: open,
        close: close,
      };
    })();

    // CSS类名定义，用于控制各种状态和样式
    var classes = {
      onSale: 'on-sale', // 促销状态
      disabled: 'disabled', // 禁用状态
      isModal: 'is-modal', // 模态框状态
      loading: 'loading', // 加载中状态
      loaded: 'loaded', // 已加载状态
      hidden: 'hide', // 隐藏状态
      interactable: 'video-interactable', // 视频可交互状态
      visuallyHide: 'visually-invisible', // 视觉隐藏
      lowInventory: 'inventory--low', // 低库存状态
    };

    // DOM选择器定义，用于查找页面元素
    var selectors = {
      productVideo: '.product__video', // 产品视频
      videoParent: '.product__video-wrapper', // 视频容器
      slide: '.product-main-slide', // 主要轮播图片
      currentSlide: '.is-selected', // 当前选中的图片
      startingSlide: '.starting-slide', // 起始图片
      variantType: '.variant-wrapper', // 变体包装器
      blocks: '[data-product-blocks]', // 产品区块
      blocksHolder: '[data-blocks-holder]', // 区块容器
      dynamicVariantsEnabled: '[data-dynamic-variants-enabled]', // 动态变体启用标识
    };

    // ===== 产品类构造函数 =====
    function Product(container) {
      this.container = container;
      // 获取区域ID和产品ID
      var sectionId = (this.sectionId = container.getAttribute('data-section-id'));
      var productId = (this.productId = container.getAttribute('data-product-id'));

      // 判断是否在模态框中显示
      this.inModal = container.dataset.modal === 'true';
      this.modal;

      // 产品设置配置
      this.settings = {
        enableHistoryState: container.dataset.history || false, // 是否启用浏览器历史状态
        namespace: '.product-' + sectionId, // 事件命名空间
        inventory: false, // 库存管理
        inventoryThreshold: 10, // 库存阈值
        modalInit: false, // 模态框初始化状态
        hasImages: true, // 是否有图片
        imageSetName: null, // 图片集名称
        imageSetIndex: null, // 图片集索引
        currentImageSet: null, // 当前图片集
        imageSize: '620x', // 图片尺寸
        currentSlideIndex: 0, // 当前轮播索引
        videoLooping: container.dataset.videoLooping, // 视频循环播放
      };

      // 如果在模态框中，重写部分设置
      if (this.inModal) {
        this.settings.enableHistoryState = false;
        this.settings.namespace = '.product-' + sectionId + '-modal';
        this.modal = document.getElementById('QuickShopModal-' + productId);
      }

      // 产品特定的DOM选择器
      this.selectors = {
        variantsJson: '[data-variant-json]', // 变体JSON数据
        currentVariantJson: '[data-current-variant-json]', // 当前变体JSON
        form: '.product-single__form', // 产品表单

        // 媒体相关
        media: '[data-product-media-type-model]', // 3D模型媒体
        closeMedia: '.product-single__close-media', // 关闭媒体按钮
        photoThumbs: '[data-product-thumb]', // 缩略图
        thumbSlider: '[data-product-thumbs]', // 缩略图轮播
        thumbScroller: '.product__thumbs--scroller', // 缩略图滚动器
        mainSlider: '[data-product-photos]', // 主图轮播
        imageContainer: '[data-product-images]', // 图片容器
        productImageMain: '[data-product-image-main]', // 主产品图片

        // 价格相关
        priceWrapper: '[data-product-price-wrap]', // 价格包装器
        price: '[data-product-price]', // 产品价格
        comparePrice: '[data-compare-price]', // 对比价格
        savePrice: '[data-save-price]', // 节省价格
        priceA11y: '[data-a11y-price]', // 无障碍价格
        comparePriceA11y: '[data-compare-price-a11y]', // 无障碍对比价格
        unitWrapper: '[data-unit-price-wrapper]', // 单位价格包装器
        unitPrice: '[data-unit-price]', // 单位价格
        unitPriceBaseUnit: '[data-unit-base]', // 单位基数
        sku: '[data-sku]', // SKU
        inventory: '[data-product-inventory]', // 库存
        incomingInventory: '[data-incoming-inventory]', // 即将到货库存
        colorLabel: '[data-variant-color-label]', // 颜色标签

        // 购买相关
        addToCart: '[data-add-to-cart]', // 添加到购物车按钮
        addToCartText: '[data-add-to-cart-text]', // 添加到购物车文本

        // 变体选择相关
        originalSelectorId: '[data-product-select]', // 原始选择器
        singleOptionSelector: '[data-variant-input]', // 单选项选择器
        variantColorSwatch: '.variant__input--color-swatch', // 颜色样本
        dynamicVariantsEnabled: '[data-dynamic-variants-enabled]', // 动态变体

        availabilityContainer: '[data-store-availability-holder]', // 门店可用性容器
      };

      // 缓存DOM元素和初始化
      this.cacheElements();

      // 获取第一张产品图片
      this.firstProductImage = this.cache.mainSlider.querySelector('img');

      // 如果没有图片，设置hasImages为false
      if (!this.firstProductImage) {
        this.settings.hasImages = false;
      }

      // 检查是否有图片集设置
      var dataSetEl = this.cache.mainSlider.querySelector('[data-set-name]');
      if (dataSetEl) {
        this.settings.imageSetName = dataSetEl.dataset.setName;
      }

      // 初始化产品
      this.init();
    }

    // ===== 产品原型方法 =====
    Product.prototype = Object.assign({}, Product.prototype, {
      // ===== 初始化方法 =====
      init: function () {
        if (this.inModal) {
          // 模态框模式设置
          this.container.classList.add(classes.isModal);
          // 监听模态框打开事件
          document.addEventListener('modalOpen.QuickShopModal-' + this.productId, this.openModalProduct.bind(this));
          // 监听模态框关闭事件
          document.addEventListener('modalClose.QuickShopModal-' + this.productId, this.closeModalProduct.bind(this));
        }

        if (!this.inModal) {
          // 非模态框模式，执行完整初始化
          this.formSetup(); // 表单设置
          this.productSetup(); // 产品设置
          this.videoSetup(); // 视频设置
          this.initProductSlider(); // 初始化产品轮播
          this.customMediaListners(); // 自定义媒体监听器
          this.addIdToRecentlyViewed(); // 添加到最近浏览
        }
      },

      // ===== DOM元素缓存方法 =====
      cacheElements: function () {
        this.cache = {
          form: this.container.querySelector(this.selectors.form),
          mainSlider: this.container.querySelector(this.selectors.mainSlider),
          thumbSlider: this.container.querySelector(this.selectors.thumbSlider),
          thumbScroller: this.container.querySelector(this.selectors.thumbScroller),
          productImageMain: this.container.querySelector(this.selectors.productImageMain),

          // 价格相关元素缓存
          priceWrapper: this.container.querySelector(this.selectors.priceWrapper),
          comparePriceA11y: this.container.querySelector(this.selectors.comparePriceA11y),
          comparePrice: this.container.querySelector(this.selectors.comparePrice),
          price: this.container.querySelector(this.selectors.price),
          savePrice: this.container.querySelector(this.selectors.savePrice),
          priceA11y: this.container.querySelector(this.selectors.priceA11y),
        };
      },

      // ===== 表单设置方法 =====
      formSetup: function () {
        this.initQtySelector(); // 初始化数量选择器
        this.initAjaxProductForm(); // 初始化Ajax产品表单
        this.availabilitySetup(); // 门店可用性设置
        this.initVariants(); // 初始化变体

        // 如果设置了图片集名称，更新图片集
        if (this.settings.imageSetName) {
          this.updateImageSet();
        }
      },

      // ===== 门店可用性设置 =====
      availabilitySetup: function () {
        var container = this.container.querySelector(this.selectors.availabilityContainer);
        if (container) {
          this.storeAvailability = new theme.StoreAvailability(container);
        }
      },

      // ===== 产品设置方法 =====
      productSetup: function () {
        this.setImageSizes(); // 设置图片尺寸
        this.initImageZoom(); // 初始化图片缩放
        this.initSelectedImageFullscreen(); // 点击当前选中主图全屏
        this.initModelViewerLibraries(); // 初始化3D模型查看器
        this.initShopifyXrLaunch(); // 初始化Shopify XR启动
      },

      // ===== 设置图片尺寸 =====
      setImageSizes: function () {
        if (!this.settings.hasImages) {
          return;
        }

        // 获取srcset图片源，适用于大多数现代浏览器
        // 否则默认使用settings.imageSize
        var currentImage = this.firstProductImage.currentSrc;

        if (currentImage) {
          this.settings.imageSize = theme.Images.imageSize(currentImage);
        }
      },

      // ===== 添加到最近浏览 =====
      addIdToRecentlyViewed: function () {
        var handle = this.container.getAttribute('data-product-handle');
        var url = this.container.getAttribute('data-product-url');
        var aspectRatio = this.container.getAttribute('data-aspect-ratio');
        var featuredImage = this.container.getAttribute('data-img-url');

        // 如果产品已在最近浏览中，先删除
        if (theme.recentlyViewed.recent.hasOwnProperty(handle)) {
          delete theme.recentlyViewed.recent[handle];
        }

        // 将产品添加到最近浏览列表末尾
        theme.recentlyViewed.recent[handle] = {
          url: url,
          aspectRatio: aspectRatio,
          featuredImage: featuredImage,
        };

        // 如果支持本地存储，保存到localStorage
        if (theme.config.hasLocalStorage) {
          window.localStorage.setItem('theme-recent', JSON.stringify(theme.recentlyViewed.recent));
        }
      },

      // ===== 初始化产品变体 =====
      initVariants: function () {
        var variantJson = this.container.querySelector(this.selectors.variantsJson);

        if (!variantJson) {
          return;
        }

        // 解析变体JSON数据
        this.variantsObject = JSON.parse(variantJson.innerHTML);
        var dynamicVariantsEnabled = !!this.container.querySelector(selectors.dynamicVariantsEnabled);

        // 变体选项配置
        var options = {
          container: this.container,
          enableHistoryState: this.settings.enableHistoryState,
          singleOptionSelector: this.selectors.singleOptionSelector,
          originalSelectorId: this.selectors.originalSelectorId,
          variants: this.variantsObject,
          dynamicVariantsEnabled,
        };

        // 处理颜色样本变更事件
        var swatches = this.container.querySelectorAll(this.selectors.variantColorSwatch);
        if (swatches.length) {
          swatches.forEach((swatch) => {
            swatch.addEventListener(
              'change',
              function (evt) {
                var color = swatch.dataset.colorName;
                var index = swatch.dataset.colorIndex;
                this.updateColorName(color, index);
              }.bind(this)
            );
          });
        }

        // 创建变体实例
        this.variants = new theme.Variants(options);

        // 页面加载时的产品可用性检查
        if (this.storeAvailability) {
          var variant_id = this.variants.currentVariant
            ? this.variants.currentVariant.id
            : this.variants.variants[0].id;

          this.storeAvailability.updateContent(variant_id);
          this.container.on('variantChange' + this.settings.namespace, this.updateAvailability.bind(this));
        }

        // 绑定变体变更事件监听器
        this.container.on(
          'variantChange' + this.settings.namespace,
          this.updateCartButton.bind(this) // 更新购物车按钮
        );
        this.container.on(
          'variantImageChange' + this.settings.namespace,
          this.updateVariantImage.bind(this) // 更新变体图片
        );
        this.container.on(
          'variantPriceChange' + this.settings.namespace,
          this.updatePrice.bind(this) // 更新价格
        );
        this.container.on(
          'variantUnitPriceChange' + this.settings.namespace,
          this.updateUnitPrice.bind(this) // 更新单位价格
        );

        // 如果有SKU元素，绑定SKU变更事件
        if (this.container.querySelector(this.selectors.sku)) {
          this.container.on('variantSKUChange' + this.settings.namespace, this.updateSku.bind(this));
        }

        // 库存管理设置
        var inventoryEl = this.container.querySelector(this.selectors.inventory);
        if (inventoryEl) {
          this.settings.inventory = true;
          this.settings.inventoryThreshold = inventoryEl.dataset.threshold;

          // 页面加载时更新库存
          this.updateInventory({
            detail: { variant: this.variants.currentVariant },
          });

          this.container.on('variantChange' + this.settings.namespace, this.updateInventory.bind(this));
        }

        // 动态变体可用性更新
        if (dynamicVariantsEnabled) {
          var currentVariantJson = this.container.querySelector(this.selectors.currentVariantJson);

          if (currentVariantJson) {
            var variantType = this.container.querySelector(selectors.variantType);

            if (variantType) {
              new theme.VariantAvailability({
                container: this.container,
                namespace: this.settings.namespace,
                type: variantType.dataset.type,
                variantsObject: this.variantsObject,
                currentVariantObject: JSON.parse(currentVariantJson.innerHTML),
              });
            }
          }
        }

        // 图片集名称变体变更监听器
        if (this.settings.imageSetName) {
          var variantWrapper = this.container.querySelector(
            '.variant-input-wrap[data-handle="' + this.settings.imageSetName + '"]'
          );
          if (variantWrapper) {
            this.settings.imageSetIndex = variantWrapper.dataset.index;
            this.container.on('variantChange' + this.settings.namespace, this.updateImageSet.bind(this));
          } else {
            this.settings.imageSetName = null;
          }
        }
      },

      // ===== 初始化数量选择器 =====
      initQtySelector: function () {
        this.container.querySelectorAll('.js-qty__wrapper').forEach((el) => {
          new theme.QtySelector(el, {
            namespace: '.product',
          });
        });
      },

      // ===== 初始化Ajax产品表单 =====
      initAjaxProductForm: function () {
        new theme.AjaxProduct(this.cache.form);
      },

      /*============================================================================
        变体更改方法
      ==============================================================================*/

      // ===== 更新颜色名称 =====
      updateColorName: function (color, index) {
        // 在单选按钮变更时更新，而不是在variant.js中
        this.container.querySelector(this.selectors.colorLabel + `[data-index="${index}"]`).textContent = color;
      },

      // ===== 更新购物车按钮 =====
      updateCartButton: function (evt) {
        var variant = evt.detail.variant;
        var cartBtn = this.container.querySelector(this.selectors.addToCart);
        var cartBtnText = this.container.querySelector(this.selectors.addToCartText);

        if (!cartBtn) return;

        if (variant) {
          if (variant.available) {
            // 可用，启用提交按钮并更改文本
            cartBtn.classList.remove(classes.disabled);
            cartBtn.disabled = false;
            var defaultText = cartBtnText.dataset.defaultText;
            cartBtnText.textContent = defaultText;
          } else {
            // 售罄，禁用提交按钮并更改文本
            cartBtn.classList.add(classes.disabled);
            cartBtn.disabled = true;
            cartBtnText.textContent = theme.strings.soldOut;
          }
        } else {
          // 变体不存在，禁用提交按钮
          cartBtn.classList.add(classes.disabled);
          cartBtn.disabled = true;
          cartBtnText.textContent = theme.strings.unavailable;
        }
      },

      // ===== 更新价格显示 =====
      updatePrice: function (evt) {
        var variant = evt.detail.variant;

        if (variant) {
          // 常规价格
          this.cache.price.innerHTML = theme.Currency.formatMoney(variant.price, theme.settings.moneyFormat);

          // 如果有对比价格，显示促销价格
          if (variant.compare_at_price > variant.price) {
            this.cache.comparePrice.innerHTML = theme.Currency.formatMoney(
              variant.compare_at_price,
              theme.settings.moneyFormat
            );
            this.cache.priceWrapper.classList.remove(classes.hidden);
            this.cache.price.classList.add(classes.onSale);
            this.cache.comparePriceA11y.setAttribute('aria-hidden', 'false');
            this.cache.priceA11y.setAttribute('aria-hidden', 'false');

            // 计算节省金额
            var savings = variant.compare_at_price - variant.price;

            if (theme.settings.saveType == 'percent') {
              savings = Math.round((savings * 100) / variant.compare_at_price) + '%';
            } else {
              savings = theme.Currency.formatMoney(savings, theme.settings.moneyFormat);
            }

            this.cache.savePrice.classList.remove(classes.hidden);
            this.cache.savePrice.innerHTML = theme.strings.savePrice.replace('[saved_amount]', savings);
          } else {
            // 无促销价格
            if (this.cache.priceWrapper) {
              this.cache.priceWrapper.classList.add(classes.hidden);
            }
            this.cache.savePrice.classList.add(classes.hidden);
            this.cache.price.classList.remove(classes.onSale);
            if (this.cache.comparePriceA11y) {
              this.cache.comparePriceA11y.setAttribute('aria-hidden', 'true');
            }
            this.cache.priceA11y.setAttribute('aria-hidden', 'true');
          }
        }
      },

      // ===== 更新单位价格 =====
      updateUnitPrice: function (evt) {
        var variant = evt.detail.variant;

        if (variant && variant.unit_price) {
          this.container.querySelector(this.selectors.unitPrice).innerHTML = theme.Currency.formatMoney(
            variant.unit_price,
            theme.settings.moneyFormat
          );
          this.container.querySelector(this.selectors.unitPriceBaseUnit).innerHTML =
            theme.Currency.getBaseUnit(variant);
          this.container.querySelector(this.selectors.unitWrapper).classList.remove(classes.hidden);
        } else {
          this.container.querySelector(this.selectors.unitWrapper).classList.add(classes.hidden);
        }
      },

      // ===== 图片集参数设置 =====
      imageSetArguments: function (variant) {
        var variant = variant ? variant : this.variants ? this.variants.currentVariant : null;
        if (!variant) return;

        var setValue = (this.settings.currentImageSet = this.getImageSetName(variant[this.settings.imageSetIndex]));
        var set = this.settings.imageSetName + '_' + setValue;

        // 总是从索引0开始
        this.settings.currentSlideIndex = 0;

        // 返回包含cellSelector的主轮播参数对象
        return {
          cellSelector: '[data-group="' + set + '"]',
          imageSet: set,
          initialIndex: this.settings.currentSlideIndex,
        };
      },

      // ===== 更新图片集 =====
      updateImageSet: function (evt) {
        // 如果直接调用，使用当前变体
        var variant = evt ? evt.detail.variant : this.variants ? this.variants.currentVariant : null;
        if (!variant) {
          return;
        }

        var setValue = this.getImageSetName(variant[this.settings.imageSetIndex]);

        // 已经在当前图片组中
        if (this.settings.currentImageSet === setValue) {
          return;
        }

        this.initProductSlider(variant);
      },

      // ===== 根据当前图片集显示/隐藏缩略图 =====
      updateImageSetThumbs: function (set) {
        this.cache.thumbSlider.querySelectorAll('.product__thumb-item').forEach((thumb) => {
          thumb.classList.toggle(classes.hidden, thumb.dataset.group !== set);
        });
      },

      // ===== 获取图片集名称（格式化字符串） =====
      getImageSetName: function (string) {
        return string
          .toLowerCase()
          .replace(/[^a-z0-9]+/g, '-')
          .replace(/-$/, '')
          .replace(/^-/, '');
      },

      // ===== 更新SKU显示 =====
      updateSku: function (evt) {
        var variant = evt.detail.variant;
        var newSku = '';

        if (variant) {
          if (variant.sku) {
            newSku = variant.sku;
          }

          this.container.querySelector(this.selectors.sku).textContent = newSku;
        }
      },

      // ===== 更新库存显示 =====
      updateInventory: function (evt) {
        var variant = evt.detail.variant;

        // 重写以显示售罄变体的库存信息（当策略设置为继续销售时）
        // 必须设置为true才能显示售罄变体的库存信息
        const inStockForOOSAndContinueSelling = false;

        if (!variant) {
          // 变体不可用
          // 隐藏库存数量和即将到货通知
          this.toggleInventoryQuantity('hidden', false);
          this.toggleIncomingInventory(false);
          return;
        }

        // 库存管理为空
        // 隐藏低库存信息但显示有库存状态
        // 隐藏即将到货通知
        if (!variant.inventory_management) {
          this.toggleInventoryQuantity('visible', false);
          this.toggleIncomingInventory(false);
          return;
        }

        if (variant.inventory_management === 'shopify' && window.inventories && window.inventories[this.productId]) {
          const variantInventoryObject = window.inventories[this.productId][variant.id];

          const { quantity, policy, incoming, next_incoming_date } = variantInventoryObject || {};

          this.toggleInventoryQuantity(undefined, quantity);

          if (inStockForOOSAndContinueSelling) {
            if (quantity <= 0 && policy === 'continue') {
              this.toggleInventoryQuantity('visible', false);
              this.toggleIncomingInventory(false);
              return;
            }
          }

          if ((incoming && !variant.available) || (quantity <= 0 && policy === 'continue')) {
            this.toggleIncomingInventory(true, next_incoming_date, policy);
          } else {
            this.toggleIncomingInventory(false);
          }
        }
      },

      // ===== 更新门店可用性 =====
      updateAvailability: function (evt) {
        var variant = evt.detail.variant;
        if (!variant) {
          return;
        }

        this.storeAvailability.updateContent(variant.id);
      },

      // ===== 切换库存数量显示 =====
      toggleInventoryQuantity: function (state = undefined, quantity) {
        const productInventoryEl = this.container.querySelector(this.selectors.inventory);
        const inventorySalesPoint = productInventoryEl.closest('.sales-point');

        if (state && state === 'hidden') {
          // 变体不可用，隐藏并返回
          if (inventorySalesPoint) {
            inventorySalesPoint.classList.add(classes.hidden);
          }
          return;
        }

        let showLowInventoryMessage = false;

        // 检查是否应显示低库存信息
        if (parseInt(quantity) <= parseInt(this.settings.inventoryThreshold) && parseInt(quantity) > 0) {
          showLowInventoryMessage = true;
        }

        if (parseInt(quantity) > 0 || (state && state === 'visible')) {
          if (showLowInventoryMessage) {
            productInventoryEl.parentNode.classList.add(classes.lowInventory);
            if (quantity > 1) {
              productInventoryEl.textContent = theme.strings.otherStockLabel.replace('[count]', quantity);
            } else {
              productInventoryEl.textContent = theme.strings.oneStockLabel.replace('[count]', quantity);
            }
          } else {
            productInventoryEl.parentNode.classList.remove(classes.lowInventory);
            productInventoryEl.textContent = theme.strings.inStockLabel;
          }

          if (inventorySalesPoint) {
            inventorySalesPoint.classList.remove(classes.hidden);
          }
        } else {
          if (inventorySalesPoint) {
            inventorySalesPoint.classList.add(classes.hidden);
          }
        }
      },

      // ===== 切换即将到货库存显示 =====
      toggleIncomingInventory: function (showIncomingInventory, incomingInventoryDate, policy) {
        const incomingInventoryEl = this.container.querySelector(this.selectors.incomingInventory);
        const incomingInventoryIcon = incomingInventoryEl.querySelector('.icon-and-text');

        if (!incomingInventoryEl) return;

        const incomingInventoryBlockEnabled = incomingInventoryEl.dataset.enabled === 'true';
        const textEl = incomingInventoryEl.querySelector('.js-incoming-text');

        // 如果即将到货库存块被禁用，隐藏它
        if (!incomingInventoryBlockEnabled) {
          incomingInventoryEl.classList.add(classes.hidden);
          return;
        }

        if (showIncomingInventory) {
          if (incomingInventoryDate) {
            textEl.textContent = theme.strings.willBeInStockAfter.replace('[date]', incomingInventoryDate);
            incomingInventoryEl.classList.remove(classes.hidden);
          } else {
            textEl.textContent = theme.strings.waitingForStock;
            incomingInventoryEl.classList.remove(classes.hidden);
          }

          // 当缺货且有即将到货库存且继续销售被禁用时，更新图标为低库存
          if (incomingInventoryIcon) {
            if (policy !== 'continue') {
              incomingInventoryIcon.classList.add(classes.lowInventory);
            } else {
              incomingInventoryIcon.classList.remove(classes.lowInventory);
            }
          }
        } else {
          incomingInventoryEl.classList.add(classes.hidden);
        }
      },

      /*============================================================================
        产品视频处理
      ==============================================================================*/

      // ===== 视频设置 =====
      videoSetup: function () {
        var productVideos = this.cache.mainSlider.querySelectorAll(selectors.productVideo);

        if (!productVideos.length) {
          return false;
        }

        // 根据视频类型初始化不同的视频播放器
        productVideos.forEach((vid) => {
          var type = vid.dataset.videoType;
          if (type === 'youtube') {
            this.initYoutubeVideo(vid); // YouTube视频
          } else if (type === 'vimeo') {
            this.initVimeoVideo(vid); // Vimeo视频
          } else if (type === 'mp4') {
            this.initMp4Video(vid); // MP4视频
          }
        });
      },

      // ===== 初始化YouTube视频 =====
      initYoutubeVideo: function (div) {
        videoObjects[div.id] = new theme.YouTube(div.id, {
          videoId: div.dataset.videoId,
          videoParent: selectors.videoParent,
          autoplay: false, // 将在回调中处理
          style: div.dataset.videoStyle,
          loop: div.dataset.videoLoop,
          events: {
            onReady: this.youtubePlayerReady.bind(this),
            onStateChange: this.youtubePlayerStateChange.bind(this),
          },
        });
      },

      // ===== 初始化Vimeo视频 =====
      initVimeoVideo: function (div) {
        videoObjects[div.id] = new theme.VimeoPlayer(div.id, div.dataset.videoId, {
          videoParent: selectors.videoParent,
          autoplay: false,
          style: div.dataset.videoStyle,
          loop: div.dataset.videoLoop,
        });
      },

      // ===== YouTube播放器就绪回调 =====
      // 来自YouTube SDK
      // 通过evt.target.getIframe().id获取iframe ID
      // 然后通过videoObjects[id]访问产品视频播放器
      youtubePlayerReady: function (evt) {
        var iframeId = evt.target.getIframe().id;

        if (!videoObjects[iframeId]) {
          // 没有YouTube播放器数据
          return;
        }

        var obj = videoObjects[iframeId];
        var player = obj.videoPlayer;

        if (obj.options.style !== 'sound') {
          player.mute(); // 如果不是声音模式，静音播放
        }

        obj.parent.classList.remove('loading');
        obj.parent.classList.add('loaded');
        obj.parent.classList.add('video-interactable'); // 之前，视频只有在幻灯片切换后才可交互

        // 如果元素在可见/第一张幻灯片中且静音，播放它
        if (this._isFirstSlide(iframeId) && obj.options.style !== 'sound') {
          player.playVideo();
        }
      },

      // ===== 检查是否为第一张幻灯片 =====
      _isFirstSlide: function (id) {
        return this.cache.mainSlider.querySelector(selectors.startingSlide + ' ' + '#' + id);
      },

      // ===== YouTube播放器状态变更回调 =====
      youtubePlayerStateChange: function (evt) {
        var iframeId = evt.target.getIframe().id;
        var obj = videoObjects[iframeId];

        switch (evt.data) {
          case -1: // 未开始
            // 通过检查视频在尝试缓冲后是否重置为未播放来处理iOS低功耗状态
            if (obj.attemptedToPlay) {
              obj.parent.classList.add('video-interactable');
            }
            break;
          case 0: // 结束
            if (obj && obj.options.loop === 'true') {
              obj.videoPlayer.playVideo(); // 循环播放
            }
            break;
          case 3: // 缓冲中
            obj.attemptedToPlay = true;
            break;
        }
      },

      // ===== 初始化MP4视频 =====
      initMp4Video: function (div) {
        videoObjects[div.id] = {
          id: div.id,
          type: 'mp4',
        };

        if (this._isFirstSlide(div.id)) {
          this.playMp4Video(div.id);
        }
      },

      // ===== 停止所有视频 =====
      stopVideos: function () {
        for (var [id, vid] of Object.entries(videoObjects)) {
          if (vid.videoPlayer) {
            if (typeof vid.videoPlayer.stopVideo === 'function') {
              vid.videoPlayer.stopVideo(); // YouTube播放器
            }
          } else if (vid.type === 'mp4') {
            this.stopMp4Video(vid.id); // MP4播放器
          }
        }
      },

      // ===== 获取视频类型 =====
      _getVideoType: function (video) {
        return video.getAttribute('data-video-type');
      },

      // ===== 获取视频div ID =====
      _getVideoDivId: function (video) {
        return video.id;
      },

      // ===== 播放MP4视频 =====
      playMp4Video: function (id) {
        var player = this.container.querySelector('#' + id);
        var playPromise = player.play();

        if (playPromise !== undefined) {
          playPromise
            .then(function () {
              // 按预期播放
            })
            .catch(function (error) {
              // 可能是iOS低功耗模式，显示控制条
              player.setAttribute('controls', '');
              player.closest(selectors.videoParent).setAttribute('data-video-style', 'unmuted');
            });
        }
      },

      // ===== 停止MP4视频 =====
      stopMp4Video: function (id) {
        var player = this.container.querySelector('#' + id);
        if (player && typeof player.pause === 'function') {
          player.pause();
        }
      },

      /*============================================================================
        产品图片处理
      ==============================================================================*/

      // ===== 初始化图片缩放 =====
      initImageZoom: function () {
        var container = this.container.querySelector(this.selectors.imageContainer);
        if (!container) {
          return;
        }
        new theme.Photoswipe(container, this.sectionId);
        container.addEventListener(
          'photoswipe:afterChange',
          function (evt) {
            if (this.flickity) {
              this.flickity.goToSlide(evt.detail.index);
            }
          }.bind(this)
        );
      },

      // ===== 点击当前选中主图，全屏弹窗展示 =====
      initSelectedImageFullscreen: function () {
        if (!this.cache || !this.cache.mainSlider) return;
        if (this._selectedImageFullscreenBound) return;
        this._selectedImageFullscreenBound = true;

        this.cache.mainSlider.addEventListener(
          'click',
          function (evt) {
            // 只处理点击图片本身（避免点到按钮/链接/表单等误触）
            if (evt.target && evt.target.closest && evt.target.closest('.js-photoswipe__zoom')) return;
            if (evt.target && evt.target.closest && evt.target.closest('a,button,input,select,textarea,label')) return;

            var slide = evt.target && evt.target.closest ? evt.target.closest('.product-main-slide') : null;
            if (!slide) return;
            if (!slide.classList.contains('is-selected')) return;

            var clickedImg = evt.target && evt.target.closest ? evt.target.closest('img') : null;
            if (!clickedImg) return;

            // 优先：如果启用了 zoom，则直接触发现有 PhotoSwipe（等同点放大镜按钮）
            var zoomBtn = slide.querySelector('.js-photoswipe__zoom');
            if (zoomBtn && this.container && this.container.querySelector(this.selectors.imageContainer)) {
              zoomBtn.click();
              return;
            }

            // 兜底：自建全屏弹窗，支持多图切换
            var allSlides = this.cache.mainSlider.querySelectorAll('.product-main-slide');
            var allImages = [];
            var currentIndex = 0;
            
            allSlides.forEach(function(slideEl, idx) {
              var img = slideEl.querySelector('img');
              if (img) {
                var hiRes = img.getAttribute('data-photoswipe-src');
                var imgSrc = hiRes || img.currentSrc || img.src;
                allImages.push({
                  src: imgSrc,
                  alt: img.alt || ''
                });
                
                // 记录当前点击的图片索引
                if (slideEl === slide) {
                  currentIndex = idx;
                }
              }
            });

            var hiRes = clickedImg.getAttribute('data-photoswipe-src');
            var src = hiRes || clickedImg.currentSrc || clickedImg.src;
            fullscreenImage.open(src, clickedImg.alt, allImages, currentIndex);
          }.bind(this)
        );
      },

      // ===== 获取缩略图索引 =====
      getThumbIndex: function (target) {
        return target.dataset.index;
      },

      // ===== 更新变体图片 =====
      updateVariantImage: function (evt) {
        var variant = evt.detail.variant;
        if (!variant) {
          return;
        }

        // 获取该变体配置的主图（优先 featured_media，其次 featured_image）
        var baseSrc = null;
        if (variant.featured_media && variant.featured_media.preview_image && variant.featured_media.preview_image.src) {
          baseSrc = variant.featured_media.preview_image.src;
        } else if (variant.featured_image && variant.featured_image.src) {
          baseSrc = variant.featured_image.src;
        } else if (typeof variant.featured_image === 'string') {
          baseSrc = variant.featured_image;
        }

        if (!baseSrc) {
          return;
        }

        // 需求：选择变体后用“第二张图”承载变体图，并激活第二张。
        // 若只有一张图，则回退更新/激活第一张。
        var mainSlides = this.cache.mainSlider ? this.cache.mainSlider.querySelectorAll('.product-main-slide') : null;
        var targetIndex = mainSlides && mainSlides.length > 1 ? 1 : 0;

        // 只更新目标幻灯片里的大图，避免移动端“交换顺序”导致更新错 slide
        var targetSlide = this.cache.mainSlider.querySelector('.product-main-slide[data-index="' + targetIndex + '"]');
        if (!targetSlide) {
          targetSlide = this.cache.mainSlider.querySelector(selectors.startingSlide);
        }

        var featuredImage = null;
        if (targetSlide) {
          featuredImage = targetSlide.querySelector('.photoswipe__image') || targetSlide.querySelector('img');
        }

        if (featuredImage && featuredImage.tagName === 'IMG') {
          var joiner = baseSrc.indexOf('?') === -1 ? '?' : '&';
          featuredImage.src = `${baseSrc}${joiner}width=1080`;
          featuredImage.srcset = `${baseSrc}${joiner}width=360 360w,${baseSrc}${joiner}width=540 540w,${baseSrc}${joiner}width=720 720w,${baseSrc}${joiner}width=900 900w,${baseSrc}${joiner}width=1080 1080w,`;
          featuredImage.dataset.photoswipeSrc = `${baseSrc}${joiner}width=1800`;

          var container = this.container.querySelector(this.selectors.imageContainer);
          if (container) new theme.Photoswipe(container, this.sectionId);
        }

        // 同步更新对应的缩略图（.product__thumbs--scroller 下的 .product__thumb-item）
        // 让第二张缩略图本身也显示为当前变体图，而不只是“高亮状态”变化。
        var thumbJoiner = baseSrc.indexOf('?') === -1 ? '?' : '&';
        var thumbSrc = `${baseSrc}${thumbJoiner}width=200`;
        var thumbSrcset = `${baseSrc}${thumbJoiner}width=100 100w,${baseSrc}${thumbJoiner}width=200 200w,${baseSrc}${thumbJoiner}width=300 300w,`;

        var thumbItems = this.container.querySelectorAll(
          '.product__thumbs--scroller .product__thumb-item[data-index="' +
            targetIndex +
            '"]'
        );
        thumbItems.forEach(function (item) {
          var img = item.querySelector('img');
          if (!img) return;
          img.src = thumbSrc;
          img.srcset = thumbSrcset;
        });

        // 跳转到该变体图片的幻灯片
        // 现在统一激活第二张（若存在）
        if (this.flickity) {
          this.flickity.goToSlide(targetIndex);
        }
      },

      // ===== 初始化产品轮播 =====
      initProductSlider: function (variant) {
        // 如果只有一张图片则停止，但为第一张幻灯片添加激活类
        if (this.cache.mainSlider.querySelectorAll(selectors.slide).length <= 1) {
          var slide = this.cache.mainSlider.querySelector(selectors.slide);
          if (slide) {
            slide.classList.add('is-selected');
          }
          return;
        }

        // 销毁轮播以准备新的初始化
        if (this.flickity && typeof this.flickity.destroy === 'function') {
          this.flickity.destroy();
        }

        // 如果存在variant参数，幻灯片是因为启用了图片集功能并切换到新组而重新初始化
        if (!variant) {
          var activeSlide = this.cache.mainSlider.querySelector(selectors.startingSlide);
          this.settings.currentSlideIndex = this._slideIndex(activeSlide);
        }

        // 移动端：默认展示缩略图第一张（index=0），与下方缩略图顺序一致
        if (window.innerWidth <= 768 && this.container.querySelector('[data-product-thumbs-mobile]')) {
          this.settings.currentSlideIndex = 0;
        }

        // 主轮播配置参数
        var mainSliderArgs = {
          dragThreshold: 25, // 拖拽阈值
          adaptiveHeight: true, // 自适应高度
          avoidReflow: true, // 避免重排
          initialIndex: this.settings.currentSlideIndex, // 初始索引
          childNav: this.cache.thumbSlider, // 子导航（缩略图）
          childNavScroller: this.cache.thumbScroller, // 子导航滚动器
          childVertical: this.cache.thumbSlider.dataset.position === 'beside', // 垂直子导航
          pageDots: true, // 页面指示点（仅移动端CSS）
          wrapAround: true, // 环绕播放
          callbacks: {
            onInit: this.onSliderInit.bind(this), // 初始化回调
            onChange: this.onSlideChange.bind(this), // 切换回调
          },
        };

        // 如果启用图片集功能，重写默认设置
        if (this.settings.imageSetName) {
          var imageSetArgs = this.imageSetArguments(variant);
          mainSliderArgs = Object.assign({}, mainSliderArgs, imageSetArgs);
          this.updateImageSetThumbs(mainSliderArgs.imageSet);
        }

        this.flickity = new theme.Slideshow(this.cache.mainSlider, mainSliderArgs);

        // 初始化移动端缩略图点击事件
        this.initMobileThumbnailClicks();

        // 初始化时设置第一个缩略图为激活状态
        this.setInitialThumbnailState();
      },

      // ===== 初始化移动端缩略图点击事件 =====
      initMobileThumbnailClicks: function () {
        var self = this;
        var mobileThumbs = this.container.querySelectorAll('.js-mobile-thumb');

        mobileThumbs.forEach(function (thumb) {
          thumb.addEventListener('click', function (e) {
            e.preventDefault();
            var index = parseInt(this.dataset.index);

            // 切换主轮播到对应图片
            if (self.flickity && typeof self.flickity.goToSlide === 'function') {
              self.flickity.goToSlide(index);
            }

            // 更新缩略图激活状态
            var thumbItems = self.container.querySelectorAll('[data-product-thumbs-mobile] .product__thumb-item');
            thumbItems.forEach(function (item) {
              item.classList.remove('active');
            });

            // 根据 data-index 匹配激活项（避免 DOM 顺序变化导致错位）
            var activeThumb = self.container.querySelector(
              '[data-product-thumbs-mobile] .product__thumb-item[data-index="' + index + '"]'
            );
            if (activeThumb) {
              activeThumb.classList.add('active');
            }

            // 滚动到激活的缩略图
            if (activeThumb) {
              var scroller = activeThumb.closest('.product__thumbs--scroller');
              if (scroller) {
                var scrollerRect = scroller.getBoundingClientRect();
                var thumbRect = activeThumb.getBoundingClientRect();
                var isOutOfView = thumbRect.left < scrollerRect.left || thumbRect.right > scrollerRect.right;

                if (isOutOfView) {
                  var delta = thumbRect.left - scrollerRect.left - (scrollerRect.width / 2 - thumbRect.width / 2);
                  var targetLeft = scroller.scrollLeft + delta;
                  var maxLeft = Math.max(0, scroller.scrollWidth - scroller.clientWidth);
                  targetLeft = Math.max(0, Math.min(targetLeft, maxLeft));
                  scroller.scrollTo({ left: targetLeft, behavior: 'smooth' });
                }
              }
            }
          });
        });
      },

      // ===== 设置初始缩略图状态 =====
      setInitialThumbnailState: function () {
        var initialIndex = typeof this.settings.currentSlideIndex === 'number' ? this.settings.currentSlideIndex : 0;
        var thumbItems = this.container.querySelectorAll('[data-product-thumbs-mobile] .product__thumb-item');
        thumbItems.forEach(function (item) {
          item.classList.remove('active');
        });

        var initialThumb = this.container.querySelector(
          '[data-product-thumbs-mobile] .product__thumb-item[data-index="' + initialIndex + '"]'
        );
        if (!initialThumb) {
          initialThumb = this.container.querySelector('[data-product-thumbs-mobile] .product__thumb-item');
        }
        if (initialThumb) {
          initialThumb.classList.add('active');
        }
      },

      // ===== 同步移动端缩略图状态 =====
      syncMobileThumbnails: function (index) {
        var self = this;
        var thumbItems = this.container.querySelectorAll('[data-product-thumbs-mobile] .product__thumb-item');

        // 移除所有激活状态
        thumbItems.forEach(function (item) {
          item.classList.remove('active');
        });

        // 设置当前激活状态
        var activeThumb = this.container.querySelector(
          '[data-product-thumbs-mobile] .product__thumb-item[data-index="' + index + '"]'
        );
        if (activeThumb) {
          activeThumb.classList.add('active');

          // 在移动端滚动到激活的缩略图
          var scroller = activeThumb.closest('.product__thumbs--scroller');
          if (scroller && window.innerWidth <= 768) {
            var scrollerRect = scroller.getBoundingClientRect();
            var thumbRect = activeThumb.getBoundingClientRect();
            var isOutOfView = thumbRect.left < scrollerRect.left || thumbRect.right > scrollerRect.right;

            if (isOutOfView) {
              var delta = thumbRect.left - scrollerRect.left - (scrollerRect.width / 2 - thumbRect.width / 2);
              var targetLeft = scroller.scrollLeft + delta;
              var maxLeft = Math.max(0, scroller.scrollWidth - scroller.clientWidth);
              targetLeft = Math.max(0, Math.min(targetLeft, maxLeft));
              scroller.scrollTo({ left: targetLeft, behavior: 'smooth' });
            }
          }
        }
      },

      // ===== 轮播初始化回调 =====
      onSliderInit: function (slide) {
        // 如果轮播在图片集功能激活时初始化，
        // 当它们是第一张幻灯片时初始化任何视频/媒体
        if (this.settings.imageSetName) {
          this.prepMediaOnSlide(slide);
        }
      },

      // ===== 幻灯片变更回调 =====
      onSlideChange: function (index) {
        if (!this.flickity) return;

        var prevSlide = this.cache.mainSlider.querySelector(
          '.product-main-slide[data-index="' + this.settings.currentSlideIndex + '"]'
        );

        // 如果存在imageSetName，使用更具体的选择器
        var nextSlide = this.settings.imageSetName
          ? this.cache.mainSlider.querySelectorAll('.flickity-slider .product-main-slide')[index]
          : this.cache.mainSlider.querySelector('.product-main-slide[data-index="' + index + '"]');

        prevSlide.setAttribute('tabindex', '-1');
        nextSlide.setAttribute('tabindex', 0);

        // 暂停任何现有的幻灯片视频/媒体
        this.stopMediaOnSlide(prevSlide);

        // 准备下一张幻灯片的视频/媒体
        this.prepMediaOnSlide(nextSlide);

        // 更新当前轮播索引
        this.settings.currentSlideIndex = index;

        // 同步移动端缩略图状态
        this.syncMobileThumbnails(index);
      },

      // ===== 停止幻灯片上的媒体 =====
      stopMediaOnSlide(slide) {
        // 停止现有视频
        var video = slide.querySelector(selectors.productVideo);
        if (video) {
          var videoType = this._getVideoType(video);
          var videoId = this._getVideoDivId(video);
          if (videoType === 'youtube') {
            if (videoObjects[videoId].videoPlayer) {
              videoObjects[videoId].videoPlayer.stopVideo();
              return;
            }
          } else if (videoType === 'mp4') {
            this.stopMp4Video(videoId);
            return;
          }
        }

        // 停止现有媒体
        var currentMedia = slide.querySelector(this.selectors.media);
        if (currentMedia) {
          currentMedia.dispatchEvent(
            new CustomEvent('mediaHidden', {
              bubbles: true,
              cancelable: true,
            })
          );
        }
      },

      // ===== 准备幻灯片上的媒体 =====
      prepMediaOnSlide(slide) {
        var video = slide.querySelector(selectors.productVideo);
        if (video) {
          this.flickity.reposition();
          var videoType = this._getVideoType(video);
          var videoId = this._getVideoDivId(video);
          if (videoType === 'youtube') {
            if (videoObjects[videoId].videoPlayer && videoObjects[videoId].options.style !== 'sound') {
              videoObjects[videoId].videoPlayer.playVideo();
              return;
            }
          } else if (videoType === 'mp4') {
            this.playMp4Video(videoId);
          }
        }

        var nextMedia = slide.querySelector(this.selectors.media);
        if (nextMedia) {
          nextMedia.dispatchEvent(
            new CustomEvent('mediaVisible', {
              bubbles: true,
              cancelable: true,
            })
          );
          slide.querySelector('.shopify-model-viewer-ui__button').setAttribute('tabindex', 0);
          slide.querySelector('.product-single__close-media').setAttribute('tabindex', 0);
        }
      },

      // ===== 获取幻灯片索引 =====
      _slideIndex: function (el) {
        return parseInt(el.getAttribute('data-index'), 10) || 0;
      },

      /*============================================================================
        快速查看模态框中的产品
      ==============================================================================*/

      // ===== 打开模态框产品 =====
      openModalProduct: function () {
        var initialized = false;

        if (!this.settings.modalInit) {
          this.blocksHolder = this.container.querySelector(selectors.blocksHolder);
          var url = this.blocksHolder.dataset.url;

          // 通过Ajax获取产品详情
          fetch(url)
            .then(function (response) {
              return response.text();
            })
            .then(
              function (html) {
                var parser = new DOMParser();
                var doc = parser.parseFromString(html, 'text/html');
                var blocks = doc.querySelector(selectors.blocks);

                // 因为同一产品可能在我们加载表单元素的页面上快速查看中打开，
                // 我们需要更新任何`id`、`for`和`form`属性
                blocks.querySelectorAll('[id]').forEach((el) => {
                  // 更新输入`id`
                  var val = el.getAttribute('id');
                  el.setAttribute('id', val + '-modal');

                  // 如果存在相关标签，更新它
                  var label = blocks.querySelector(`[for="${val}"]`);
                  if (label) {
                    label.setAttribute('for', val + '-modal');
                  }

                  // 更新任何可折叠元素
                  var collapsibleTrigger = blocks.querySelector(`[aria-controls="${val}"]`);
                  if (collapsibleTrigger) {
                    collapsibleTrigger.setAttribute('aria-controls', val + '-modal');
                  }
                });

                // 更新任何带有`form`属性的元素
                // 表单元素已经附加了`-modal`
                var form = blocks.querySelector(this.selectors.form);
                if (form) {
                  var formId = form.getAttribute('id');
                  blocks.querySelectorAll('[form]').forEach((el) => {
                    el.setAttribute('form', formId);
                  });
                }

                this.blocksHolder.innerHTML = '';
                this.blocksHolder.append(blocks);
                this.blocksHolder.classList.add('product-form-holder--loaded');

                this.cacheElements();

                this.formSetup();
                this.updateModalProductInventory();

                // 初始化Shopify支付按钮
                if (Shopify && Shopify.PaymentButton) {
                  Shopify.PaymentButton.init();
                }

                // 重新连接可折叠框触发器
                theme.collapsibles.init(this.container);

                document.dispatchEvent(
                  new CustomEvent('quickview:loaded', {
                    detail: {
                      productId: this.productId,
                    },
                  })
                );
              }.bind(this)
            );

          this.productSetup();
          this.videoSetup();

          // 在快速查看中启用产品轮播
          // 1. 启用图片集时，确保在初始化前有this.variants
          // 2. 正常初始化，不需要表单数据
          if (this.settings.imageSetName) {
            if (this.variants) {
              this.initProductSlider();
            } else {
              document.addEventListener(
                'quickview:loaded',
                function (evt) {
                  if (evt.detail.productId === this.productId) {
                    this.initProductSlider();
                  }
                }.bind(this)
              );
            }
          } else {
            this.initProductSlider();
          }
          this.customMediaListners();
          this.addIdToRecentlyViewed();
          this.settings.modalInit = true;
        } else {
          initialized = true;
        }

        AOS.refreshHard(); // 刷新AOS动画

        document.dispatchEvent(
          new CustomEvent('quickview:open', {
            detail: {
              initialized: initialized,
              productId: this.productId,
            },
          })
        );
      },

      // ===== 更新模态框产品库存 =====
      // 推荐产品通过JS加载，不会将变体库存添加到我们稍后检查的全局变量中。
      // 此函数抓取数据div以获取该信息并手动添加值。
      updateModalProductInventory: function () {
        window.inventories = window.inventories || {};
        this.container.querySelectorAll('.js-product-inventory-data').forEach((el) => {
          var productId = el.dataset.productId;
          window.inventories[productId] = {};

          el.querySelectorAll('.js-variant-inventory-data').forEach((el) => {
            window.inventories[productId][el.dataset.id] = {
              quantity: el.dataset.quantity,
              policy: el.dataset.policy,
              incoming: el.dataset.incoming,
              next_incoming_date: el.dataset.date,
            };
          });
        });
      },

      // ===== 关闭模态框产品 =====
      closeModalProduct: function () {
        this.stopVideos(); // 停止所有视频播放
      },

      /*============================================================================
        产品媒体（3D模型）
      ==============================================================================*/

      // ===== 初始化3D模型查看器库 =====
      initModelViewerLibraries: function () {
        var modelViewerElements = this.container.querySelectorAll(this.selectors.media);
        if (modelViewerElements.length < 1) return;

        theme.ProductMedia.init(modelViewerElements, this.sectionId);
      },

      // ===== 初始化Shopify XR启动 =====
      initShopifyXrLaunch: function () {
        document.addEventListener(
          'shopify_xr_launch',
          function () {
            var currentMedia = this.container.querySelector(
              this.selectors.productMediaWrapper + ':not(.' + self.classes.hidden + ')'
            );
            currentMedia.dispatchEvent(
              new CustomEvent('xrLaunch', {
                bubbles: true,
                cancelable: true,
              })
            );
          }.bind(this)
        );
      },

      // ===== 自定义媒体监听器 =====
      customMediaListners: function () {
        // 关闭媒体按钮监听器
        document.querySelectorAll(this.selectors.closeMedia).forEach((el) => {
          el.addEventListener(
            'click',
            function () {
              var slide = this.cache.mainSlider.querySelector(selectors.currentSlide);
              var media = slide.querySelector(this.selectors.media);
              if (media) {
                media.dispatchEvent(
                  new CustomEvent('mediaHidden', {
                    bubbles: true,
                    cancelable: true,
                  })
                );
              }
            }.bind(this)
          );
        });

        // 3D模型查看器监听器
        var modelViewers = this.container.querySelectorAll('model-viewer');
        if (modelViewers.length) {
          modelViewers.forEach((el) => {
            el.addEventListener(
              'shopify_model_viewer_ui_toggle_play',
              function (evt) {
                this.mediaLoaded(evt);
              }.bind(this)
            );

            el.addEventListener(
              'shopify_model_viewer_ui_toggle_pause',
              function (evt) {
                this.mediaUnloaded(evt);
              }.bind(this)
            );
          });
        }
      },

      // ===== 媒体加载完成 =====
      mediaLoaded: function (evt) {
        // 显示关闭媒体按钮
        this.container.querySelectorAll(this.selectors.closeMedia).forEach((el) => {
          el.classList.remove(classes.hidden);
        });

        // 禁用轮播拖拽
        if (this.flickity) {
          this.flickity.setDraggable(false);
        }
      },

      // ===== 媒体卸载 =====
      mediaUnloaded: function (evt) {
        // 隐藏关闭媒体按钮
        this.container.querySelectorAll(this.selectors.closeMedia).forEach((el) => {
          el.classList.add(classes.hidden);
        });

        // 启用轮播拖拽
        if (this.flickity) {
          this.flickity.setDraggable(true);
        }
      },

      // ===== 卸载清理 =====
      onUnload: function () {
        // 清理3D模型
        theme.ProductMedia.removeSectionModels(this.sectionId);

        // 销毁轮播实例
        if (this.flickity && typeof this.flickity.destroy === 'function') {
          this.flickity.destroy();
        }
      },
    });

    // 返回Product构造函数
    return Product;
  })();

  // ===== 最近浏览产品模块 =====
  theme.RecentlyViewed = (function () {
    // 全局初始化标志，防止重复初始化
    var init = false;

    // ===== 最近浏览产品构造函数 =====
    function RecentlyViewed(container) {
      // 如果没有容器元素，直接返回
      if (!container) {
        return;
      }

      this.container = container;
      // 获取区域ID，用于标识不同的最近浏览区域
      this.sectionId = this.container.getAttribute('data-section-id');
      // 事件命名空间，避免事件冲突
      this.namespace = '.recently-viewed' + this.sectionId;
      // 网格项宽度类名，用于响应式布局
      this.gridItemWidth = this.container.getAttribute('data-grid-item-class');
      // 每行显示的产品数量
      this.rowOf = this.container.getAttribute('data-row-of');
      // 图片尺寸配置，用于响应式图片
      this.imageSizes = this.container.getAttribute('data-image-sizes');

      // 使用可见性检测延迟初始化，提升页面性能
      // 当元素距离视口600px时开始初始化
      theme.initWhenVisible({
        element: this.container,
        callback: this.init.bind(this),
        threshold: 600,
      });
    }

    // ===== 最近浏览产品原型方法 =====
    RecentlyViewed.prototype = Object.assign({}, RecentlyViewed.prototype, {
      // ===== 初始化方法 =====
      init: function () {
        // 防止重复初始化
        if (init) {
          return;
        }

        init = true;

        // 检查是否有最近浏览的产品记录
        if (
          Object.keys(theme.recentlyViewed.recent).length === 0 &&
          theme.recentlyViewed.recent.constructor === Object
        ) {
          // 页面加载时没有历史记录，隐藏容器
          this.container.classList.add('hide');
          return;
        }

        // 获取输出容器，用于显示最近浏览的产品
        this.outputContainer = document.getElementById('RecentlyViewed-' + this.sectionId);
        // 获取当前产品的handle，用于排除当前产品
        this.handle = this.container.getAttribute('data-product-handle');

        // 通过JS API请求新的产品信息
        var promises = [];
        Object.keys(theme.recentlyViewed.recent).forEach(
          function (handle) {
            // 过滤掉无效的handle
            if (handle !== 'undefined') {
              promises.push(this.getProductInfo(handle));
            }
          }.bind(this)
        );

        // 等待所有产品信息获取完成后处理结果
        Promise.all(promises).then(
          function (result) {
            this.setupOutput(result); // 设置输出内容
            this.captureProductDetails(result); // 缓存产品详情
          }.bind(this)
        );
      },

      // ===== 获取产品信息 =====
      getProductInfo: function (handle) {
        return new Promise(function (resolve, reject) {
          // 如果产品信息已经缓存，直接使用缓存
          if (theme.recentlyViewed.productInfo.hasOwnProperty(handle)) {
            resolve(theme.recentlyViewed.productInfo[handle]);
          } else {
            // 通过Shopify产品API获取产品信息
            fetch('/products/' + handle + '.js')
              .then(function (response) {
                return response.text();
              })
              .then(function (product) {
                resolve(product);
              });
          }
        });
      },

      // ===== 设置输出内容 =====
      setupOutput: function (products) {
        var allProducts = [];
        var data = {};
        // 获取显示数量限制
        var limit = this.container.getAttribute('data-recent-count');

        var i = 0;

        // 处理每个产品数据
        Object.keys(products).forEach(
          function (key) {
            if (!products[key]) {
              return;
            }
            var product = JSON.parse(products[key]);

            // 忽略当前产品
            if (product.handle === this.handle) {
              return;
            }

            // 忽略未定义的handle
            if (typeof product.handle == 'undefined') {
              return;
            }

            i++;

            // 新增或格式化的产品属性
            const widths = [180, 360, 540, 720, 900]; // 响应式图片宽度

            // 设置产品URL，优先使用缓存的URL
            product.url = theme.recentlyViewed.recent[product.handle]
              ? theme.recentlyViewed.recent[product.handle].url
              : product.url;

            // 构建响应式图片路径
            product.image_responsive_url = theme.Images.buildImagePath(product.featured_image);
            product.image_responsive_urls = theme.Images.buildImagePath(product.featured_image, widths);
            // 设置图片宽高比
            product.image_aspect_ratio = theme.recentlyViewed.recent[product.handle].aspectRatio;

            // 单位价格检查（使用第一个变体）
            var firstVariant = product.variants[0];
            if (firstVariant && firstVariant.unit_price) {
              var baseUnit = '';

              // 构建单位价格的基准单位显示
              if (firstVariant.unit_price_measurement) {
                if (firstVariant.unit_price_measurement.reference_value != 1) {
                  baseUnit += firstVariant.unit_price_measurement.reference_value + ' ';
                }
                baseUnit += firstVariant.unit_price_measurement.reference_unit;
              }

              // 格式化单位价格
              product.unit_price = theme.Currency.formatMoney(firstVariant.unit_price);
              if (baseUnit != '') {
                product.unit_price += '/' + baseUnit;
              }
            }

            // 将产品添加到数组开头（最新的在前面）
            allProducts.unshift(product);
          }.bind(this)
        );

        // 如果没有产品，隐藏容器
        if (allProducts.length === 0) {
          this.container.classList.add('hide');
          return;
        }

        // 构建产品网格HTML标记
        var productMarkup = theme.buildProductGridItem(
          allProducts.slice(0, limit), // 按限制数量截取产品
          this.gridItemWidth, // 网格项宽度
          this.rowOf, // 每行数量
          this.imageSizes // 图片尺寸
        );

        // 将生成的HTML插入到输出容器中
        this.outputContainer.innerHTML = productMarkup;

        // 刷新AOS动画效果
        if (AOS) {
          AOS.refreshHard();
        }
      },

      // ===== 缓存产品详情 =====
      captureProductDetails: function (products) {
        // 将产品信息存储到缓存中
        for (var i = 0; i < products.length; i++) {
          var product = products[i];
          theme.recentlyViewed.productInfo[product.handle] = product;
        }

        // 将数据添加到会话存储中，减少后续API请求
        if (theme.config.hasSessionStorage) {
          sessionStorage.setItem('recent-products', JSON.stringify(theme.recentlyViewed.productInfo));
        }
      },

      // ===== 卸载清理 =====
      onUnload: function () {
        init = false; // 重置初始化标志
      },
    });

    return RecentlyViewed;
  })();

  // ===== 推荐评价轮播模块 =====
  theme.Testimonials = (function () {
    // 默认轮播配置
    var defaults = {
      adaptiveHeight: true, // 自适应高度
      avoidReflow: true, // 避免重排
      pageDots: true, // 显示页面指示点
      prevNextButtons: false, // 不显示前后导航按钮
    };

    // ===== 推荐评价构造函数 =====
    function Testimonials(container) {
      this.container = container;
      this.timeout; // 定时器，用于自动播放
      var sectionId = container.getAttribute('data-section-id');
      // 获取轮播容器
      this.slideshow = container.querySelector('#Testimonials-' + sectionId);
      // 事件命名空间
      this.namespace = '.testimonial-' + sectionId;

      if (!this.slideshow) {
        return;
      }

      // 使用可见性检测延迟初始化
      theme.initWhenVisible({
        element: this.container,
        callback: this.init.bind(this),
        threshold: 600,
      });
    }

    // ===== 推荐评价原型方法 =====
    Testimonials.prototype = Object.assign({}, Testimonials.prototype, {
      // ===== 初始化方法 =====
      init: function () {
        // 当只有少数几个区块时不环绕播放
        if (this.slideshow.dataset.count <= 3) {
          defaults.wrapAround = false;
        }

        // 创建轮播实例
        this.flickity = new theme.Slideshow(this.slideshow, defaults);

        // 加载时自动滚动到下一张幻灯片，提示有更多内容
        if (this.slideshow.dataset.count > 2) {
          this.timeout = setTimeout(
            function () {
              this.flickity.goToSlide(1); // 跳转到第二张幻灯片
            }.bind(this),
            1000 // 延迟1秒
          );
        }
      },

      // ===== 卸载清理 =====
      onUnload: function () {
        if (this.flickity && typeof this.flickity.destroy === 'function') {
          this.flickity.destroy();
        }
      },

      // ===== 取消选择事件 =====
      onDeselect: function () {
        if (this.flickity && typeof this.flickity.play === 'function') {
          this.flickity.play(); // 恢复自动播放
        }
      },

      // ===== 区块选择事件 =====
      onBlockSelect: function (evt) {
        // 根据区块ID找到对应的幻灯片
        var slide = this.slideshow.querySelector('.testimonials-slide--' + evt.detail.blockId);
        var index = parseInt(slide.dataset.index);

        // 清除自动播放定时器
        clearTimeout(this.timeout);

        // 跳转到选中的幻灯片并暂停自动播放
        if (this.flickity && typeof this.flickity.pause === 'function') {
          this.flickity.goToSlide(index);
          this.flickity.pause();
        }
      },

      // ===== 区块取消选择事件 =====
      onBlockDeselect: function () {
        if (this.flickity && typeof this.flickity.play === 'function') {
          this.flickity.play(); // 恢复自动播放
        }
      },
    });

    return Testimonials;
  })();

  // ===== 存储支持检测工具函数 =====
  theme.isStorageSupported = function (type) {
    // 如果在iframe中且无法访问sessionStorage，返回false
    if (window.self !== window.top) {
      return false;
    }

    var testKey = 'test';
    var storage;

    // 根据类型选择存储对象
    if (type === 'session') {
      storage = window.sessionStorage; // 会话存储
    }
    if (type === 'local') {
      storage = window.localStorage; // 本地存储
    }

    try {
      // 尝试设置和删除测试项来检测存储是否可用
      storage.setItem(testKey, '1');
      storage.removeItem(testKey);
      return true;
    } catch (error) {
      // 如果出现错误（如隐私模式或存储已满），返回false
      return false;
    }
  };

  // ===== 重新初始化产品网格项工具函数 =====
  theme.reinitProductGridItem = function (scope) {
    // 刷新AOS动画效果
    if (AOS) {
      AOS.refreshHard();
    }

    // 如果不在模态框打开状态，重新初始化快速购买功能
    if (!document.documentElement.classList.contains('modal-open')) {
      theme.initQuickShop();
    }

    // 重新连接可折叠框触发器
    theme.collapsibles.init();
  };

  /*============================================================================
    Things that don't require DOM to be ready
  ==============================================================================*/
  theme.config.hasSessionStorage = theme.isStorageSupported('session');
  theme.config.hasLocalStorage = theme.isStorageSupported('local');
  AOS.init({
    easing: 'ease-out-quad',
    once: true,
    offset: 60,
    disableMutationObserver: true,
  });

  if (theme.config.hasLocalStorage) {
    theme.recentlyViewed.localStorage = window.localStorage.getItem('theme-recent');

    if (theme.recentlyViewed.localStorage) {
      theme.recentlyViewed.recent = JSON.parse(theme.recentlyViewed.localStorage);
    }
  }

  theme.recentlyViewed.productInfo =
    theme.config.hasSessionStorage && sessionStorage['recent-products']
      ? JSON.parse(sessionStorage['recent-products'])
      : {};

  // Trigger events when going between breakpoints
  theme.config.bpSmall = matchMedia(theme.config.mediaQuerySmall).matches;
  matchMedia(theme.config.mediaQuerySmall).addListener(function (mql) {
    if (mql.matches) {
      theme.config.bpSmall = true;
      document.dispatchEvent(new CustomEvent('matchSmall'));
    } else {
      theme.config.bpSmall = false;
      document.dispatchEvent(new CustomEvent('unmatchSmall'));
    }
  });

  /*============================================================================
    Things that require DOM to be ready
  ==============================================================================*/
  function DOMready(callback) {
    if (document.readyState != 'loading') callback();
    else document.addEventListener('DOMContentLoaded', callback);
  }

  // Load generic JS. Also reinitializes when sections are
  // added, edited, or removed in Shopify's editor
  theme.initGlobals = function () {
    theme.collapsibles.init();
    theme.videoModal();
  };

  DOMready(function () {
    theme.sections = new theme.Sections();

    theme.sections.register('slideshow-section', theme.SlideshowSection);
    theme.sections.register('header', theme.HeaderSection);
    theme.sections.register('product', theme.Product);
    theme.sections.register('blog', theme.Blog);
    theme.sections.register('password-header', theme.PasswordHeader);
    theme.sections.register('photoswipe', theme.Photoswipe);
    theme.sections.register('background-image', theme.BackgroundImage);
    theme.sections.register('testimonials', theme.Testimonials);
    theme.sections.register('video-section', theme.VideoSection);
    theme.sections.register('map', theme.Maps);
    theme.sections.register('footer-section', theme.FooterSection);
    theme.sections.register('collapse-grid', theme.CollapseGrid);
    theme.sections.register('discover-workspace', theme.DiscoverWorkspace);
    theme.sections.register('feature-on', theme.FeatureOn);
    theme.sections.register('product-desc', theme.ProductDesc);
    theme.sections.register('store-availability', theme.StoreAvailability);
    theme.sections.register('recently-viewed', theme.RecentlyViewed);
    theme.sections.register('newsletter-popup', theme.NewsletterPopup);
    theme.sections.register('collection-header', theme.CollectionHeader);
    theme.sections.register('collection-grid', theme.Collection);

    theme.initGlobals();
    theme.initQuickShop();
    theme.rteInit();

    if (document.body.classList.contains('template-cart')) {
      var cartPageForm = document.getElementById('CartPageForm');
      if (cartPageForm) {
        new theme.CartForm(cartPageForm);
      }
    }

    if (theme.settings.isCustomerTemplate) {
      theme.customerTemplates();
    }

    document.dispatchEvent(new CustomEvent('page:loaded'));
  });
  /* --- 返回顶部组件模块 --- */
  document.addEventListener('DOMContentLoaded', () => {
    const backToTopButton = document.getElementById('back-to-top');

    if (backToTopButton) {
      const scrollThreshold = 300; // 向下滚动超过300像素后显示按钮

      const toggleVisibility = () => {
        if (window.pageYOffset > scrollThreshold) {
          backToTopButton.classList.add('visible');
        } else {
          backToTopButton.classList.remove('visible');
        }
      };

      // 使用节流的滚动监听器以优化性能
      let isThrottled = false;
      window.addEventListener('scroll', () => {
        if (!isThrottled) {
          window.requestAnimationFrame(() => {
            toggleVisibility();
            isThrottled = false;
          });
          isThrottled = true;
        }
      });

      backToTopButton.addEventListener('click', (event) => {
        event.preventDefault();
        window.scrollTo({
          top: 0,
          behavior: 'smooth',
        });
      });
    }
  });

  /* --- Related Products Bundle And Save Slider --- */
  document.addEventListener('DOMContentLoaded', () => {
    const relatedProductsSliders = document.querySelectorAll('.related-products-bundle__wrapper');
    
    relatedProductsSliders.forEach(slider => {
      const track = slider.querySelector('.related-products-bundle__track');
      const prevBtn = slider.querySelector('.related-products-bundle__arrow--prev');
      const nextBtn = slider.querySelector('.related-products-bundle__arrow--next');
      const cards = track.querySelectorAll('.related-products-bundle__card');
      
      if (!track || cards.length <= 1) return;
      
      let currentIndex = 0;
      const totalCards = cards.length;
      
      function updateSlider() {
        const offset = -currentIndex * 100;
        track.style.transform = `translateX(${offset}%)`;
        
        // Update button states
        if (prevBtn) {
          prevBtn.style.opacity = currentIndex === 0 ? '0.5' : '1';
          prevBtn.style.pointerEvents = currentIndex === 0 ? 'none' : 'auto';
        }
        
        if (nextBtn) {
          nextBtn.style.opacity = currentIndex === totalCards - 1 ? '0.5' : '1';
          nextBtn.style.pointerEvents = currentIndex === totalCards - 1 ? 'none' : 'auto';
        }
      }
      
      if (prevBtn) {
        prevBtn.addEventListener('click', () => {
          if (currentIndex > 0) {
            currentIndex--;
            updateSlider();
          }
        });
      }
      
      if (nextBtn) {
        nextBtn.addEventListener('click', () => {
          if (currentIndex < totalCards - 1) {
            currentIndex++;
            updateSlider();
          }
        });
      }
      
      // Initialize
      updateSlider();
      
      // Add swipe support for mobile
      let startX = 0;
      let isDragging = false;
      
      track.addEventListener('touchstart', (e) => {
        startX = e.touches[0].clientX;
        isDragging = true;
      });
      
      track.addEventListener('touchmove', (e) => {
        if (!isDragging) return;
        e.preventDefault();
      });
      
      track.addEventListener('touchend', (e) => {
        if (!isDragging) return;
        isDragging = false;
        
        const endX = e.changedTouches[0].clientX;
        const diff = startX - endX;
        
        if (Math.abs(diff) > 50) {
          if (diff > 0 && currentIndex < totalCards - 1) {
            currentIndex++;
            updateSlider();
          } else if (diff < 0 && currentIndex > 0) {
            currentIndex--;
            updateSlider();
          }
        }
      });

      /* --- Mouse drag support (desktop) --- */
      // Reuse existing prev/next + transform logic to avoid fighting with track translateX implementation.
      let mouseDown = false;
      let mouseDidMove = false;
      let mouseStartX = 0;
      let mouseStartY = 0;
      let mouseStartedHorizontal = false;

      const CLICK_CANCEL_PX = 8;
      const SWIPE_TRIGGER_PX = 50;

      function cancelClickOnce(targetEl) {
        if (!targetEl) return;
        targetEl._rpMouseCancelClickOnce = true;
        window.setTimeout(() => {
          targetEl._rpMouseCancelClickOnce = false;
        }, 0);
      }

      // Capture-phase click cancel to prevent accidental link clicks after drag
      track.addEventListener(
        'click',
        (e) => {
          if (track._rpMouseCancelClickOnce) {
            e.preventDefault();
            e.stopPropagation();
          }
        },
        true
      );

      const onMouseDown = (e) => {
        if (e.button !== 0) return;
        mouseDown = true;
        mouseDidMove = false;
        mouseStartedHorizontal = false;
        mouseStartX = e.clientX;
        mouseStartY = e.clientY;
        track.style.cursor = 'grabbing';
        track.style.userSelect = 'none';
      };

      const onMouseMove = (e) => {
        if (!mouseDown) return;
        const dx = e.clientX - mouseStartX;
        const dy = e.clientY - mouseStartY;

        if (!mouseStartedHorizontal) {
          if (Math.abs(dy) > Math.abs(dx) && Math.abs(dy) > 6) {
            // vertical intent -> abort
            mouseDown = false;
            track.style.cursor = '';
            track.style.userSelect = '';
            return;
          }
          if (Math.abs(dx) > 6) mouseStartedHorizontal = true;
        }

        if (!mouseStartedHorizontal) return;
        e.preventDefault();
        if (Math.abs(dx) > CLICK_CANCEL_PX) mouseDidMove = true;
      };

      const onMouseUp = (e) => {
        if (!mouseDown) return;
        mouseDown = false;
        track.style.cursor = '';
        track.style.userSelect = '';

        const dx = e.clientX - mouseStartX;
        if (Math.abs(dx) >= SWIPE_TRIGGER_PX) {
          if (dx < 0 && nextBtn) nextBtn.click();
          if (dx > 0 && prevBtn) prevBtn.click();
        }

        if (mouseDidMove) cancelClickOnce(track);
      };

      // Mouse listeners
      track.addEventListener('mousedown', onMouseDown);
      track.addEventListener('mousemove', onMouseMove);
      track.addEventListener('mouseup', onMouseUp);
      track.addEventListener('mouseleave', onMouseUp);
    });
  });

  /* --- Drag-to-scroll for .lb-upsell-ppa-grid-carousel (desktop + touch) --- */
  (function () {
    const CLICK_CANCEL_PX = 8;

    function initDragScroll(el) {
      if (!el || el.dataset.lbDragScrollInited === '1') return;
      if (el.scrollWidth <= el.clientWidth + 2) return;

      el.dataset.lbDragScrollInited = '1';

      let isDown = false;
      let didMove = false;
      let startedHorizontal = false;
      let startX = 0;
      let startY = 0;
      let startScrollLeft = 0;

      const cancelClickOnce = () => {
        el._lbCancelClickOnce = true;
        window.setTimeout(() => {
          el._lbCancelClickOnce = false;
        }, 0);
      };

      el.addEventListener(
        'click',
        (e) => {
          if (el._lbCancelClickOnce) {
            e.preventDefault();
            e.stopPropagation();
          }
        },
        true
      );

      const getPoint = (evt) => {
        if (evt && evt.touches && evt.touches[0]) return { x: evt.touches[0].clientX, y: evt.touches[0].clientY };
        if (evt && evt.changedTouches && evt.changedTouches[0])
          return { x: evt.changedTouches[0].clientX, y: evt.changedTouches[0].clientY };
        return { x: evt.clientX, y: evt.clientY };
      };

      const onDown = (e) => {
        if (e.type === 'mousedown' && e.button !== 0) return;
        const p = getPoint(e);
        isDown = true;
        didMove = false;
        startedHorizontal = false;
        startX = p.x;
        startY = p.y;
        startScrollLeft = el.scrollLeft;
        el.style.cursor = 'grabbing';
        el.style.userSelect = 'none';
      };

      const onMove = (e) => {
        if (!isDown) return;
        const p = getPoint(e);
        const dx = p.x - startX;
        const dy = p.y - startY;

        if (!startedHorizontal) {
          if (Math.abs(dy) > Math.abs(dx) && Math.abs(dy) > 6) {
            // vertical intent -> abort
            isDown = false;
            el.style.cursor = '';
            el.style.userSelect = '';
            return;
          }
          if (Math.abs(dx) > 6) startedHorizontal = true;
        }
        if (!startedHorizontal) return;

        if (e.cancelable) e.preventDefault();
        if (Math.abs(dx) > CLICK_CANCEL_PX) didMove = true;
        el.scrollLeft = startScrollLeft - dx;
      };

      const onUp = () => {
        if (!isDown) return;
        isDown = false;
        el.style.cursor = '';
        el.style.userSelect = '';
        if (didMove) cancelClickOnce();
      };

      el.addEventListener('mousedown', onDown);
      el.addEventListener('mousemove', onMove);
      el.addEventListener('mouseup', onUp);
      el.addEventListener('mouseleave', onUp);

      el.addEventListener('touchstart', onDown, { passive: true });
      el.addEventListener('touchmove', onMove, { passive: false });
      el.addEventListener('touchend', onUp, { passive: true });
      el.addEventListener('touchcancel', onUp, { passive: true });
    }

    function initAll() {
      document.querySelectorAll('.lb-upsell-ppa-grid-carousel').forEach((grid) => {
        // Find the actual scrollable parent
        let scrollParent = grid;
        let current = grid;
        
        // Walk up to find real scroll container
        for (let i = 0; i < 5 && current; i++) {
          const style = window.getComputedStyle(current);
          const canScroll = current.scrollWidth > current.clientWidth + 2 && 
                           (style.overflowX === 'scroll' || style.overflowX === 'auto');
          if (canScroll) {
            scrollParent = current;
            break;
          }
          current = current.parentElement;
        }
        
        // Fallback: if no auto/scroll parent found, try .lb-upsell-ppa-carousel
        if (scrollParent === grid) {
          const carouselParent = grid.closest('.lb-upsell-ppa-carousel') || grid.closest('.lb-upsell-ppa');
          if (carouselParent && carouselParent.scrollWidth > carouselParent.clientWidth + 2) {
            scrollParent = carouselParent;
          }
        }
        
        initDragScroll(scrollParent);
      });
    }

    // 使用 MutationObserver 监听 DOM 变化，确保动态注入的元素也能被初始化
    function observeUpsellInjection() {
      const observer = new MutationObserver(function(mutations) {
        let shouldInit = false;
        mutations.forEach(function(mutation) {
          if (mutation.addedNodes.length) {
            mutation.addedNodes.forEach(function(node) {
              if (node.nodeType === 1) {
                // 检查新增的节点或其子节点中是否包含目标元素
                if (node.matches && node.matches('.lb-upsell-ppa-grid-carousel, .lb-upsell-ppa-carousel, .lb-upsell-ppa')) {
                  shouldInit = true;
                } else if (node.querySelector && node.querySelector('.lb-upsell-ppa-grid-carousel')) {
                  shouldInit = true;
                }
              }
            });
          }
        });
        if (shouldInit) {
          // 延迟一下确保元素完全渲染
          window.setTimeout(initAll, 100);
        }
      });
      
      // 监听整个 body 的变化
      if (document.body) {
        observer.observe(document.body, {
          childList: true,
          subtree: true
        });
      } else {
        // 如果 body 还没准备好，等待一下
        document.addEventListener('DOMContentLoaded', function() {
          observer.observe(document.body, {
            childList: true,
            subtree: true
          });
        });
      }
    }

    // 多重触发机制，确保不同场景下都能初始化
    document.addEventListener('DOMContentLoaded', initAll);
    document.addEventListener('page:loaded', initAll);
    // Upsell widgets sometimes inject after load
    window.setTimeout(initAll, 800);
    window.setTimeout(initAll, 2500);
    window.setTimeout(initAll, 5000);
    // 启动 DOM 变化监听
    observeUpsellInjection();
  })();
})();

